import { AppLocale } from './i18n.types';

export const FR_TRANSLATIONS = {
  'notes.links.categoriesTitle': 'Catégories de notes liées',
  'notes.links.categoriesHelp': 'Les notes de ces catégories sont accessibles depuis cet élément.',
  'notes.links.categoryEmpty': 'Aucune catégorie liée.',
  'notes.links.categoriesLoading': 'Chargement des catégories…',
  'notes.links.chooseCategory': 'Choisir une catégorie',
  'notes.links.chooseCategoryPlaceholder': 'Sélectionner une catégorie…',
  'notes.links.link': 'Lier',
  'notes.links.remove': 'Retirer',
  'notes.links.notesTitle': 'Notes liées',
  'notes.links.notesEmpty': 'Aucune note liée.',
  'notes.links.notesLoading': 'Chargement des notes…',
  'notes.links.chooseNote': 'Choisir une note',
  'notes.links.chooseNotePlaceholder': 'Sélectionner une note existante…',
  'notes.links.newNotePlaceholder': 'Nouvelle note liée',
  'notes.links.create': 'Créer',
  'notes.links.categoryUpdateError': 'Impossible de mettre à jour la catégorie.',
  'notes.links.categoryLoadError': 'Impossible de charger les catégories.',
  'notes.links.noteUpdateError': 'Impossible de mettre à jour le lien.',
  'notes.links.noteLoadError': 'Impossible de charger les notes.',
  'tasks.recurrent.defaultPeriod': 'Créneau horaire par défaut',
  'today.noteCategory': 'Catégorie',
  'today.noteLinksLoadError': 'Les liens vers les notes sont indisponibles.',
  'culture.xlsxExport': "Exporter Excel",
  'culture.xlsxImport': "Importer Excel",
  'culture.xlsxInvalid': "Fichier XLSX invalide ou non conforme au format Culture LifeOps.",
  'culture.xlsxExportError': "Impossible d'exporter les données Culture.",
  'culture.xlsxImportError': "Impossible d'importer le classeur Culture. Vérifie les feuilles et les références.",
  'culture.xlsxImportResult': "Bilan de l'import",
  'culture.xlsxItems': "œuvres",
  'culture.xlsxSeasons': "saisons",
  'culture.xlsxHistory': "consommations",
  'culture.xlsxLists': "listes",
  'culture.xlsxLinks': "références",
  'culture.xlsxSkipped': "déjà présentes",
  'culture.xlsxPreview': "Contenu du fichier à importer",
  'culture.xlsxImportHint': "L'import réutilise les éléments existants si possible. Les dates, types, références et statuts doivent respecter le modèle LifeOps.",
  'culture.xlsxConfirmImport': "Confirmer l'import",
  'culture.syncAllRaindrop': "Synchroniser tous les bookmarks Raindrop",
  'culture.dailyChoose': "Choisir les lectures du jour",
  'culture.dailySelected': "Bookmarks sélectionnés pour ce jour",
  'culture.dailyUnassigned': "Sans créneau",
  'culture.dailySlot': "Créneau de lecture",
  'culture.dailyRandomCount': "Nombre à tirer",
  'culture.dailyRandom': "Sélection aléatoire",
  'culture.dailyManualHint': "Coche tes articles ou effectue un tirage aléatoire. Les tags des jours ne sont pas pris en compte.",
  'culture.dailyEmpty': "Aucun bookmark Raindrop non terminé disponible.",
  'culture.dailySelectionError': "Impossible d'enregistrer la sélection ou son créneau. Réessaie.",

  'culture.backToCulture': "Retour à la médiathèque",
  'culture.addExisting': "Ajouter un item existant",
  'culture.createItem': "Créer un nouvel item",
  'culture.filterStatus': "Filtrer par statut",
  'culture.statusLabel': "Statut",
  'culture.status.ALL': "Tous",
  'culture.status.NOT_STARTED': "Non commencé",
  'culture.status.IN_PROGRESS': "En cours",
  'culture.status.DONE': "Terminé",
  'culture.cultureLists': "Listes de la médiathèque",
  'culture.cultureList': "Liste de contenus de la médiathèque",
  'culture.raindropConfigMissing': "OAuth Raindrop non configuré : renseigne les secrets de la fonction locale (voir documentation).",
  'culture.raindropKeyInvalid': "Clé de chiffrement Raindrop invalide : une clé AES-256 encodée en base64 est nécessaire.",
  'culture.raindropFunctionUnavailable': "Fonction Supabase Raindrop inaccessible : démarre les Edge Functions locales.",
  'culture.configureType': "Modifier le type",
  'culture.fieldIdentifier': "Identifiant du champ",
  'culture.fieldText': "Texte",
  'culture.fieldNumber': "Nombre",
  'culture.fieldDate': "Date",
  'culture.fieldBoolean': "Oui / Non",
  'culture.connectRaindrop': "Connecter mon compte Raindrop",
  'culture.raindropConnected': "Compte Raindrop connecté",
  'culture.disconnectRaindrop': "Déconnecter Raindrop",
  'culture.raindropAuthError': "Connexion Raindrop impossible. Vérifie la configuration OAuth.",
  'culture.tagFilter': "Tag à synchroniser",
  'culture.filterBookmarksByTag': "Filtrer les favoris par tag",
  'culture.allBookmarkTags': "Tous les tags",
  'culture.noBookmarksWithTag': "Aucun favori ne correspond à ce tag.",
  'culture.addType': "Créer un type",
  'culture.lists': "Listes",
  'culture.listName': "Nom de la liste",
  'culture.createList': "Créer une liste",
  'culture.addField': "Ajouter un champ",
  'culture.fieldLabel': "Nom du champ",
  'culture.consumed': "Consommé",
  'culture.confirmDeleteBookmark': "Supprimer ce favori ?",
  'culture.removeFromList': "Retirer de la liste",
  'culture.plans': "Planification",
  'culture.planPool': "Planifier un pool",
  'culture.planBookmark': "Planifier le favori",
  'culture.targetCount': "Objectif d'éléments",
  'culture.date': "Date",
  'culture.emptyPlans': "Aucun contenu planifié.",
  'culture.poolBookmarks': "Contenus du pool",
  'culture.poolHelp': "Sélectionne une liste ci-dessus puis passe les éléments consultés à Terminé.",
  'culture.edit': "Modifier",
  'culture.delete': "Supprimer",
  'culture.confirmDelete': "Supprimer cette œuvre et son historique ?",
  'culture.addSeason': "Ajouter une saison",
  'culture.author': "Auteur",
  'culture.category': "Catégorie",
  'culture.theme': "Thème",
  'culture.year': "Année",
  'culture.language': "Langue",
  'culture.pages': "Pages",
  'culture.releaseDate': "Date de sortie",
  'culture.director': "Réalisateur",
  'culture.genre': "Genre",
  'culture.country': "Pays",
  'culture.seasonNumber': "Numéro de saison",
  'culture.episodeCount': "Nombre d'épisodes",
  'culture.addToList': "Ajouter à la liste",
  'culture.chooseList': "Choisir une liste",
  'culture.syncRaindrop': "Synchroniser Raindrop",
  'culture.syncHelp': "Connecte ton compte Raindrop pour synchroniser tes favoris.",
  'culture.token': "Jeton Raindrop",
  'culture.sync': "Synchroniser",
  'culture.syncing': "Synchronisation…",
  'culture.syncSuccess': "Favoris traités",
  'culture.syncFailed': "La synchronisation Raindrop a échoué.",
  'culture.chooseTag': "Choisir un tag",
  'culture.completeBookmark': "Terminer",
  'culture.reopenBookmark': "Remettre à consommer",
  'culture.showCompleted': 'Afficher les terminés',
  'culture.pickRandom': 'Sélection aléatoire',
  'culture.scheduleSelected': 'Planifier la sélection',
  'culture.selectBookmark': 'Sélectionner ce favori',
  'culture.selectAllFilteredRaindrops': 'Sélectionner tous les Raindrops filtrés',
  'culture.deselectAllFilteredRaindrops': 'Désélectionner les Raindrops filtrés',
  'culture.deleteAllSelectedRaindrops': 'Tout supprimer',
  'culture.deleteRaindrop': 'Supprimer ce Raindrop de LifeOps',
  'culture.confirmDeleteRaindrops': 'Supprimer définitivement ces Raindrops de LifeOps ?',
  'culture.raindropLocalDeleteHint': 'Les favoris resteront sur Raindrop.io. Une nouvelle synchronisation peut les réimporter.',
  'culture.raindropDeleteFailed': 'Suppression incomplète ou impossible. La liste a été rechargée : vérifie les favoris restants.',
  'culture.xlsxImportMode': "Mode d'import",
  'culture.xlsxImportFree': 'Import libre',
  'culture.xlsxImportList': 'Importer dans une liste',
  'culture.xlsxChooseList': 'Choisir une liste',
  'culture.xlsxNewList': 'Créer une liste',
  'culture.hideCompleted': 'Masquer les terminés',
  'culture.raindropStatusFailed': "La synchronisation du statut a échoué. Vérifie Raindrop et réessaie : LifeOps n'a pas confirmé la modification.",
  'culture.homeDescription': 'Découvre et suis tes livres, films, séries et articles.',
  'culture.title': "Médiathèque",
  'culture.add': "Ajouter",
  'culture.works': "Œuvres",
  'culture.history': "Historique",
  'culture.bookmarks': "Favoris web",
  'culture.loading': "Chargement…",
  'culture.loadError': "Impossible de charger les données.",
  'culture.saveError': "Enregistrement impossible.",
  'culture.emptyWorks': "Aucune œuvre enregistrée.",
  'culture.emptyHistory': "Aucune consommation enregistrée.",
  'culture.emptyBookmarks': "Aucun favori enregistré.",
  'culture.type': "Type",
  'culture.book': "Livre",
  'culture.movie': "Film",
  'culture.series': "Série",
  'culture.podcast': "Épisode de podcast",
  'culture.name': "Titre",
  'culture.choose': "Choisir une œuvre",
  'culture.startDate': "Date de début",
  'culture.endDate': "Date de fin",
  'culture.rating': "Note sur 10",
  'culture.comment': "Commentaire",
  'culture.article': "Article",
  'culture.video': "Vidéo",
  'culture.other': "Autre",
  'culture.backlog': "À consulter",
  'culture.planned': "Planifié",
  'culture.done': "Terminé",
  'culture.cancel': "Annuler",
  'culture.saving': "Enregistrement…",
  'culture.save': "Enregistrer",
  'mealsV2.addRecipeToSession': 'Ajouter recette',
  'mealsV2.addPreparedDish': 'Ajouter préparation',
  'mealsV2.addFoodToConsumption': 'Ajouter aliment',
  'mealsV2.viewDetails': 'Ouvrir le détail',
  'mealsV2.consumptionDetails': 'Détail de la consommation',
  'mealsV2.editConsumption': 'Modifier la consommation',
  'mealsV2.nutritionEstimate': 'Apport nutritionnel estimé',
  'mealsV2.macros': 'Macronutriments',
  'mealsV2.unknownNutrition': 'Non renseigné',
  'mealsV2.portionPlural': 'portions',
  'mealsV2.noConsumption': 'Aucun repas enregistré',
  'mealsV2.noLinesAvailable': 'Cette consommation ne peut pas être modifiée : sa préparation d’origine n’est plus disponible.',
  'mealsV2.sourceSnapshot': 'Valeurs enregistrées au moment de la consommation',
  'mealsV2.addMeal': 'Enregistrer un repas',
  'mealsV2.uncook': 'Remettre à non réalisée',
  'mealsV2.editSession': 'Modifier les plats et ingrédients',
  'mealsV2.shoppingResult': '{added} ingrédient(s) ajouté(s) · {skipped} déjà présent(s)',
  'mealsV2.saving': 'Enregistrement…',
  'mealsV2.addIngredientInRecipe': 'Créer un ingrédient',
  'mealsV2.unitPiece': 'Pièce',
  'mealsV2.unitFree': 'Libre',
  'mealsV2.title': 'Repas',
  'mealsV2.ingredients': 'Ingrédients',
  'mealsV2.recipes': 'Recettes',
  'mealsV2.consumed': 'Consommations',
  'mealsV2.shopping': 'Liste de courses',
  'mealsV2.name': 'Nom',
  'mealsV2.unit': 'Unité de référence',
  'mealsV2.kcal': 'Calories',
  'mealsV2.protein': 'Protéines',
  'mealsV2.carbs': 'Glucides',
  'mealsV2.fat': 'Lipides',
  'mealsV2.newIngredient': 'Nouvel ingrédient',
  'mealsV2.newRecipe': 'Nouvelle recette',
  'mealsV2.instructions': 'Instructions',
  'mealsV2.servings': 'Portions de la recette',
  'mealsV2.quantity': 'Quantité',
  'mealsV2.addLine': 'Ajouter un ingrédient',
  'mealsV2.add': 'Ajouter',
  'mealsV2.save': 'Enregistrer',
  'mealsV2.cancel': 'Annuler',
  'mealsV2.edit': 'Modifier',
  'mealsV2.delete': 'Supprimer',
  'mealsV2.date': 'Date',
  'mealsV2.portion': 'Portions consommées',
  'mealsV2.log': 'Enregistrer un repas',
  'mealsV2.choose': 'Choisir',
  'mealsV2.list': 'Liste',
  'mealsV2.toList': 'Ajouter les ingrédients sélectionnés',
  'mealsV2.selectAll': 'Tout sélectionner',
  'mealsV2.empty': 'Aucune donnée.',
  'mealsV2.confirm': 'Confirmer la suppression ?',
  'mealsV2.error': 'Opération impossible.',
  'mealsV2.nutrition': 'Valeurs estimées par recette',
  'mealsV2.g': 'g',
  'mealsV2.perUnit': 'Valeurs pour 1 unité de référence (g, ml ou pièce)',
  'mealsV2.shoppingHelp': 'Sélectionne les ingrédients nécessaires et ajoute-les à une liste existante.',
  'mealsV2.day': 'Jour prévu',
  'mealsV2.session': 'Session de cuisine',
  'mealsV2.newSession': 'Nouvelle session de cuisine',
  'mealsV2.cooked': 'Cuisinée',
  'mealsV2.markCooked': 'Marquer comme cuisinée',
  'mealsV2.produced': 'Portions réelles produites',
  'mealsV2.theoretical': 'Recettes théoriques',
  'mealsV2.realIngredients': 'Composition réelle (modifiable)',
  'mealsV2.addFood': 'Ajouter un aliment',
  'mealsV2.consumeReal': 'Consommation réelle',
  'mealsV2.cookedPreparation': 'Préparation cuisinée',
  'mealsV2.singleFood': 'Aliment seul',
  'mealsV2.portionUnit': 'Portion',
  'mealsV2.fractionUnit': 'Fraction du plat',
  'mealsV2.nutritionBasis': 'Base nutritionnelle',
  'mealsV2.optionalNutrition': 'Les nutriments sont optionnels. Laisser vide si inconnus.',
  'mealsV2.onePortion': 'Recette de référence pour une portion.',
  'mealsV2.partial': 'Estimation partielle',
  'mealsV2.recipeSelect': 'Choisir une recette',
  'mealsV2.addPreparation': 'Ajouter une préparation',
  'mealsV2.addSingleFood': 'Ajouter un aliment',
  'common.actions.add': 'Ajouter',
  'common.actions.archive': 'Archiver',
  'common.actions.back': 'Retour',
  'common.actions.cancel': 'Annuler',
  'common.actions.close': 'Fermer',
  'common.actions.create': 'Créer',
  'common.actions.delete': 'Supprimer',
  'common.actions.deleteForever': 'Supprimer définitivement',
  'common.actions.edit': 'Modifier',
  'common.actions.open': 'Ouvrir',
  'common.actions.remove': 'Retirer',
  'common.actions.rename': 'Renommer',
  'common.actions.reopen': 'Rouvrir',
  'common.actions.retry': 'Réessayer',
  'common.actions.save': 'Enregistrer',
  'common.actions.link': 'Lier',
  'common.actions.choose': 'Choisir…',
  'common.actions.up': 'Monter',
  'common.actions.down': 'Descendre',
  'common.loading': 'Chargement…',
  'common.saving': 'Enregistrement…',
  'common.deleting': 'Suppression…',
  'common.none': 'Aucune',
  'common.yes': 'Oui',
  'common.no': 'Non',
  'common.history': 'Historique',
  'common.title': 'Titre',
  'common.description': 'Description',
  'common.priority': 'Priorité',
  'common.actionsLabel': 'Actions',
  'common.actionFailed': 'L’action n’a pas pu être enregistrée. Réessaie.',

  'product.today': 'Today',
  'product.todo': 'To Do',
  'product.highlight': 'Highlight',
  'product.template': 'Template',
  'product.tasks': 'Tâches',
  'product.calendar': 'Calendrier',
  'product.goals': 'Objectifs',
  'product.lists': 'Listes',
  'product.notes': 'Notes',
  'product.activities': 'Activités',
  'product.sport': 'Sport',
  'product.routines': 'Routines',
  'product.settings': 'Paramètres',
  'product.meals': 'Repas',
  'product.domains': 'Domaines',
  'product.measurements': 'Mesures',
  'navigation.overview': 'Vue générale',


  'app.homeAria': 'Accueil LifeOps',
  'app.backHomeAria': 'Retour à l’accueil',
  'app.signOut': 'Se déconnecter',
  'app.signIn': 'Se connecter',
  'app.settings': 'Paramètres',
  'navigation.main': 'Navigation principale',
  'navigation.open': 'Ouvrir la navigation',
  'navigation.close': 'Fermer la navigation',
  'navigation.activeTimer.one': '{count} chrono actif',
  'navigation.activeTimer.many': '{count} chronos actifs',
  'navigation.backTo': 'Retour à {destination}',
  'navigation.destination.home': 'Accueil',
  'navigation.destination.previousPage': 'la page précédente',

  'auth.login.title': 'Connexion à LifeOps',
  'auth.login.subtitle': 'Connecte-toi avec ton adresse e-mail et ton mot de passe.',
  'auth.email': 'E-mail',
  'auth.password': 'Mot de passe',
  'auth.emailRequired': 'L’adresse e-mail est obligatoire.',
  'auth.emailInvalid': 'Saisis une adresse e-mail valide.',
  'auth.login.loading': 'Connexion…',
  'auth.login.submit': 'Se connecter',
  'auth.login.createAccount': 'Créer un compte',
  'auth.login.accountDeleted': 'Ton compte LifeOps et toutes ses données ont été supprimés définitivement.',
  'auth.login.forgotPassword': 'Mot de passe oublié ?',
  'auth.recovery.requestTitle': 'Réinitialiser le mot de passe',
  'auth.recovery.requestSubtitle': 'Indique ton adresse e-mail. Si un compte correspond, tu recevras un lien pour choisir un nouveau mot de passe.',
  'auth.recovery.requestSubmit': 'Envoyer le lien',
  'auth.recovery.requestLoading': 'Envoi…',
  'auth.recovery.requestSuccess': 'Si un compte correspond à cette adresse, un e-mail de récupération a été envoyé.',
  'auth.recovery.backToLogin': 'Retour à la connexion',
  'auth.recovery.updateTitle': 'Choisir un nouveau mot de passe',
  'auth.recovery.updateSubtitle': 'Choisis un nouveau mot de passe pour ton compte LifeOps.',
  'auth.recovery.checkingLink': 'Vérification du lien de récupération…',
  'auth.recovery.invalidTitle': 'Lien de récupération invalide',
  'auth.recovery.invalidLink': 'Ce lien est invalide, expiré ou a déjà été utilisé. Demande un nouveau lien de récupération.',
  'auth.recovery.requestAnother': 'Demander un nouveau lien',
  'auth.recovery.newPassword': 'Nouveau mot de passe',
  'auth.recovery.confirmPassword': 'Confirmer le nouveau mot de passe',
  'auth.recovery.updateSubmit': 'Enregistrer le nouveau mot de passe',
  'auth.recovery.updateLoading': 'Enregistrement…',
  'auth.recovery.updateError': 'Le mot de passe n’a pas pu être mis à jour. Demande un nouveau lien si le problème persiste.',
  'auth.signup.title': 'Créer un compte LifeOps',
  'auth.signup.subtitle': 'Chaque compte possède ses propres données privées.',
  'auth.signup.name': 'Nom',
  'auth.signup.language': 'Langue',
  'auth.signup.languageHelp': 'Cette langue sera utilisée pour l’interface et pour les noms initiaux des axes Calendar.',
  'auth.signup.confirmPassword': 'Confirmer le mot de passe',
  'auth.signup.loading': 'Création…',
  'auth.signup.submit': 'Créer mon compte',
  'auth.signup.enableHint': 'Pour activer « Créer mon compte » :',
  'auth.signup.nameRequired': 'renseigne ton nom.',
  'auth.signup.nameLength': 'le nom doit contenir entre 2 et 80 caractères.',
  'auth.signup.emailRequired': 'renseigne ton adresse e-mail.',
  'auth.signup.emailInvalid': 'saisis une adresse e-mail valide.',
  'auth.signup.passwordRequired': 'renseigne un mot de passe.',
  'auth.signup.passwordLength': 'utilise au moins 10 caractères pour le mot de passe.',
  'auth.signup.confirmRequired': 'confirme ton mot de passe.',
  'auth.signup.passwordsMatch': 'les deux mots de passe doivent être identiques.',
  'auth.signup.haveAccount': 'J’ai déjà un compte',
  'auth.signup.errorNameLength': 'Le nom doit contenir entre 2 et 80 caractères.',
  'auth.signup.errorPasswordLength': 'Le mot de passe doit contenir au moins 10 caractères.',
  'auth.signup.errorPasswordsMismatch': 'Les mots de passe ne correspondent pas.',
  'auth.signup.successConfirmEmail': 'Compte créé. Consulte ton e-mail pour confirmer ton inscription.',
  'auth.error.invalidCredentials': 'E-mail ou mot de passe incorrect.',
  'auth.error.emailRegistered': 'Un compte existe déjà avec cette adresse e-mail.',
  'auth.error.weakPassword': 'Le mot de passe ne respecte pas les exigences de sécurité.',
  'auth.error.network': 'Impossible de joindre LifeOps. Vérifie ta connexion Internet puis réessaie.',
  'auth.error.serviceUnavailable': 'Le service est momentanément indisponible. Réessaie dans quelques instants.',
  'auth.error.rateLimit': 'Trop de demandes ont été effectuées. Réessaie dans quelques instants.',
  'auth.error.signIn': 'La connexion a échoué. Réessaie.',
  'auth.error.signUp': 'La création du compte a échoué. Réessaie.',

  'home.personalSpace': 'Ton espace personnel',
  'home.intro': 'Tes espaces du quotidien réunis dans une navigation claire, sans hiérarchie entre les domaines.',
  'home.spacesAria': 'Les huit espaces LifeOps',
  'home.connectedSpaces': '8 espaces connectés',
  'home.oneVision': 'Une seule vision',
  'home.yourSpaces': 'Tes espaces',
  'home.whereStart': 'Par où veux-tu commencer ?',
  'home.chooseSpace': 'Choisis un espace pour passer de l’intention à l’action.',
  'home.todayDescription': 'Retrouve tout ce qui compte pour ta journée.',
  'home.todayAction': 'Ouvrir ma journée',
  'home.tasksDescription': 'Crée, programme et termine tes actions.',
  'home.explore': 'Explorer',
  'home.calendarDescription': 'Planifie tes semaines et retrouve tes événements.',
  'home.plan': 'Planifier',
  'home.goalsDescription': 'Définis tes objectifs et suis tes progrès.',
  'home.notesDescription': 'Conserve et organise tes notes personnelles.',
  'home.activitiesDescription': 'Retrouve tes activités et suis le temps consacré.',
  'home.sportDescription': 'Crée tes sports, planifie tes séances et enregistre tes résultats.',
  'home.listsDescription': 'Organise tes listes indépendamment des tâches.',
  'home.domainsDescription': 'Organise tes domaines et leurs propriétés.',
  'domains.subtitle': 'Regroupe tes éléments LifeOps par grands domaines de vie.',
  'domains.namePlaceholder': 'Ex. Sport, Travail, Culture…',
  'domains.color': 'Couleur du domaine',
  'domains.palettePreview': 'Aperçu des 5 tons',
  'domains.color.blue': 'Bleu',
  'domains.color.red': 'Rouge',
  'domains.color.orange': 'Orange',
  'domains.color.green': 'Vert',
  'domains.color.purple': 'Violet',
  'domains.color.teal': 'Turquoise',
  'domains.color.pink': 'Rose',
  'domains.color.gray': 'Gris',
  'domains.showArchived': 'Afficher les domaines archivés',
  'domains.createAction': 'Créer un domaine',
  'domains.editAction': 'Modifier le domaine',
  'domains.openDomain': 'Ouvrir le domaine',
  'domains.empty': 'Aucun domaine pour le moment.',
  'domains.assignment': 'Domaine',
  'domains.loadError': 'Impossible de charger les domaines.',
  'domains.deleteConfirm': 'Supprimer « {name} » ? Les éléments associés seront conservés sans domaine.',
  'domains.shortcutsTitle': 'Mes domaines',
  'domains.homeFilter': 'Filtrer par domaine',
  'domains.allDomains': 'Tous les domaines',
  'domains.entryHelp': 'Choisis un module pour l’ouvrir filtré sur ce domaine.',
  'domains.filteredModule': 'Afficher uniquement les éléments de {name}.',
  'domains.notFound': 'Ce domaine est introuvable.',
  'domains.hideShortcut': 'Masquer le raccourci',
  'domains.showShortcut': 'Afficher le raccourci',
  'home.progress': 'Voir mes progrès',
  'notes.navigationPlaceholder': 'L’espace Notes est maintenant accessible depuis la navigation. Sa gestion métier complète sera livrée séparément.',
  'activities.navigationPlaceholder': 'L’espace Activities est maintenant accessible depuis la navigation. Sa gestion métier complète sera livrée séparément.',
  'activities.eyebrow': 'Suivi du temps',
  'activities.subtitle': 'Planifie tes activités dans Calendar et mesure ici le temps réellement passé.',
  'activities.backToTasks': 'Retour aux tâches',
  'activities.taskSessionSource': 'Cette session est rattachée à une tâche et reste distincte des Activities.',
  'activities.quickCreateTitle': 'Créer rapidement',
  'activities.quickCreateHelp': 'Un nom suffit. La même activité pourra être planifiée plusieurs fois et chronométrée autant que nécessaire.',
  'activities.nameLabel': 'Nom de l’activité',
  'activities.namePlaceholder': 'Ex. Lecture',
  'activities.create': 'Créer l’activité',
  'activities.loading': 'Chargement des activités et des chronos…',
  'activities.loadError': 'Impossible de charger les activités ou le suivi du temps. Réessaie dans quelques instants.',
  'activities.activeTitle': 'Activités actives',
  'activities.activeHelp': 'Les activités disponibles pour le planning et les prochains chronos.',
  'activities.empty': 'Aucune activité active. Crée-en une ici ou depuis le planning.',
  'activities.reusable': 'Activité réutilisable',
  'activities.archived': 'Activité archivée',
  'activities.showArchived': 'Afficher les activités archivées ({count})',
  'activities.restore': 'Restaurer',
  'activities.archiveAria': 'Archiver {name}',
  'activities.restoreAria': 'Restaurer {name}',
  'activities.archiveConfirmTitle': 'Archiver cette activité ?',
  'activities.archiveConfirmMessage': 'Archiver « {name} » ? Son historique et ses chronos restent conservés. Un chrono déjà actif ne sera pas arrêté.',
  'activities.activeTimersTitle': 'Chronos actifs',
  'activities.activeTimersHelp': 'Plusieurs chronos peuvent tourner en même temps. Les durées sont cumulatives.',
  'activities.startTimer': 'Démarrer',
  'activities.startTimerAria': 'Démarrer un chrono pour {name}',
  'activities.stopTimer': 'Arrêter',
  'activities.cancelTimer': 'Annuler le chrono',
  'activities.cancelTimerConfirmTitle': 'Annuler ce chrono ?',
  'activities.cancelTimerConfirmMessage': 'Ce chrono actif sera supprimé sans créer de session historique.',
  'activities.elapsedTime': 'Temps écoulé',
  'activities.longTimerWarning': 'Chrono actif depuis plus de 12 h — vérifie l’heure de départ.',
  'activities.runningCount': '{count} actif(s)',
  'activities.today': 'Aujourd’hui',
  'activities.week': 'Cette semaine',
  'activities.totalsAria': 'Temps cumulé pour {name}',
  'activities.unknownActivity': 'Activité',
  'activities.historyTitle': 'Sessions',
  'activities.historyHelp': 'Consulte et corrige le temps suivi, jour par jour.',
  'activities.historyDate': 'Date de l’historique',
  'activities.previousDay': 'Jour précédent',
  'activities.nextDay': 'Jour suivant',
  'activities.historyEmpty': 'Aucune session terminée pour cette date.',
  'activities.sessionEditorEyebrow': 'SESSION',
  'activities.sessionTimezone': 'Fuseau historique : {timezone}',
  'activities.sessionStart': 'Début',
  'activities.sessionEnd': 'Fin',
  'activities.activeSessionEndHelp': 'Laisse vide pour conserver le chrono actif.',
  'activities.sessionNote': 'Commentaire',
  'activities.sessionNotePlaceholder': 'Ex. Travail concentré, chapitre lu…',
  'activities.tags': 'Tags',
  'activities.chooseExistingTag': 'Ajouter un tag existant…',
  'activities.newTagPlaceholder': 'Nouveau tag',
  'activities.createTag': 'Créer le tag',
  'activities.removeTagAria': 'Retirer le tag {name}',
  'activities.now': 'maintenant',
  'activities.deleteSessionConfirmTitle': 'Supprimer cette session ?',
  'activities.deleteSessionConfirmMessage': 'La session et ses associations de tags seront supprimées définitivement.',
  'tasks.time.sectionAria': 'Suivi du temps pour {title}',
  'tasks.time.start': 'Chrono',
  'tasks.time.openActivities': 'Voir dans Activités',
  'tasks.time.startAria': 'Démarrer un chrono pour {title}',
  'tasks.time.history': 'Temps suivi',
  'tasks.time.cancelTimerTitle': 'Annuler ce chrono ?',
  'tasks.time.cancelTimerMessage': 'Le chrono actif de « {title} » sera supprimé sans créer de session historique.',
  'tasks.time.activeOnClose': '{count} chrono(s) actif(s) sont liés à cette tâche. Choisis explicitement quoi en faire.',
  'tasks.time.completeKeepRunning': 'Terminer et laisser actif',
  'tasks.time.completeAndStop': 'Terminer et arrêter',
  'tasks.time.cancelKeepRunning': 'Annuler la tâche et laisser actif',
  'tasks.time.cancelAndStop': 'Annuler la tâche et arrêter',
  'tasks.time.changeStatusKeepRunning': 'Changer le statut et laisser actif',
  'tasks.time.changeStatusAndStop': 'Changer le statut et arrêter',
  'tasks.time.statusDecisionTitle': 'Que faire du chrono actif ?',
  'tasks.time.editInActivities': 'Les sessions peuvent être corrigées depuis l’historique Activities.',
  'tasks.time.deleteKeepsHistory': 'Cette tâche possède du temps suivi : elle sera retirée de Tasks, mais son historique temporel sera conservé.',
  'tasks.time.taskSession': 'Session de tâche',

  'settings.title': 'Paramètres',
  'settings.raindrop.title': "Raindrop",
  'settings.raindrop.description': "Gère la connexion de ton compte Raindrop à LifeOps.",
  'settings.raindrop.connected': "Compte Raindrop connecté",
  'settings.raindrop.notConnected': "Compte Raindrop non connecté",
  'settings.raindrop.unknown': "État de connexion indisponible",
  'settings.raindrop.connect': "Connecter Raindrop",
  'settings.raindrop.disconnect': "Déconnecter Raindrop",
  'settings.raindrop.retry': "Réessayer",
  'settings.raindrop.confirmTitle': "Déconnecter Raindrop ?",
  'settings.raindrop.confirmHelp': "LifeOps ne pourra plus synchroniser tes favoris jusqu’à une nouvelle connexion. Les favoris et l’historique déjà enregistrés dans LifeOps seront conservés.",
  'settings.raindrop.confirm': "Confirmer la déconnexion",
  'settings.raindrop.disconnecting': "Déconnexion…",
  'settings.raindrop.disconnected': "Raindrop a été déconnecté. Tu peux reconnecter ton compte à tout moment.",
  'settings.raindrop.loadError': "Impossible de vérifier la connexion Raindrop. Réessaie.",
  'settings.raindrop.connectError': "Impossible de démarrer la connexion Raindrop. Réessaie.",
  'settings.raindrop.disconnectError': "Impossible de déconnecter Raindrop. La connexion a été conservée.",
  'settings.profile.title': 'Profil',
  'settings.profile.description': 'Modifie le nom affiché dans LifeOps. Ton e-mail reste lié à ton compte et n’est pas modifiable ici.',
  'settings.profile.email': 'E-mail',
  'settings.profile.emailReadonly': 'L’adresse e-mail est en lecture seule.',
  'settings.profile.username': 'Nom affiché',
  'settings.profile.usernameHelp': 'Entre 2 et 80 caractères. Les espaces au début et à la fin sont supprimés.',
  'settings.profile.save': 'Enregistrer le profil',
  'settings.profile.saving': 'Enregistrement…',
  'settings.profile.saved': 'Profil enregistré.',
  'settings.profile.invalidUsername': 'Le nom affiché doit contenir entre 2 et 80 caractères après suppression des espaces au début et à la fin.',
  'settings.profile.loadError': 'Impossible de charger ton profil. Réessaie.',
  'settings.profile.error': 'Le profil n’a pas pu être enregistré. Réessaie.',
  'settings.deleteAccount.title': 'Zone sensible',
  'settings.deleteAccount.description': 'La suppression du compte est définitive et supprime toutes tes données LifeOps.',
  'settings.deleteAccount.open': 'Supprimer le compte',
  'settings.deleteAccount.eyebrow': 'SUPPRESSION DÉFINITIVE',
  'settings.deleteAccount.confirmTitle': 'Supprimer définitivement ton compte ?',
  'settings.deleteAccount.irreversible': 'Cette opération est irréversible. Tu ne pourras pas récupérer ton compte après sa suppression.',
  'settings.deleteAccount.deleteProfile': 'Ton profil LifeOps sera supprimé.',
  'settings.deleteAccount.deleteData': 'Toutes tes tâches, listes, notes, activités, calendriers, objectifs et autres données seront supprimés.',
  'settings.deleteAccount.deleteHistory': 'Tes préférences, historiques et templates seront supprimés.',
  'settings.deleteAccount.loseAccess': 'Toutes tes sessions seront révoquées et tes anciens identifiants ne permettront plus de te connecter.',
  'settings.deleteAccount.exportOffer': 'Tu peux télécharger une sauvegarde JSON avant de supprimer le compte. Cet export est facultatif.',
  'settings.deleteAccount.exportNow': 'Exporter mes données avant suppression',
  'settings.deleteAccount.confirmationLabel': 'Pour confirmer, saisis exactement cette phrase :',
  'settings.deleteAccount.passwordLabel': 'Mot de passe actuel',
  'settings.deleteAccount.finalWarning': 'En confirmant, les données existantes seront supprimées définitivement. Cette action ne peut pas être annulée.',
  'settings.deleteAccount.confirm': 'Supprimer définitivement',
  'settings.deleteAccount.deleting': 'Suppression…',
  'settings.deleteAccount.invalidPassword': 'Le mot de passe est incorrect.',
  'settings.deleteAccount.confirmationMismatch': 'La phrase de confirmation ne correspond pas exactement.',
  'settings.deleteAccount.confirmationMismatchHint': 'La phrase doit correspondre exactement à « SUPPRIMER MON COMPTE ». Les espaces avant ou après sont ignorés.',
  'settings.deleteAccount.reauthExpired': 'La réauthentification a expiré. Saisis de nouveau ton mot de passe.',
  'settings.deleteAccount.error': 'La suppression du compte a échoué. Le compte n’est pas considéré comme supprimé.',

  'settings.subtitle': 'Personnalise ton expérience LifeOps.',
  'settings.backHome': '← Accueil',
  'settings.language.title': 'Langue',
  'settings.language.description': 'La langue de l’interface est enregistrée sur ton profil et appliquée immédiatement.',
  'settings.language.label': 'Langue de l’interface',
  'settings.language.fr': 'Français',
  'settings.language.en': 'English',
  'settings.language.es': 'Español',
  'settings.language.saved': 'Langue enregistrée.',
  'settings.language.error': 'La langue n’a pas pu être enregistrée. Réessaie.',
  'settings.backup.title': 'Sauvegarde des données',
  'settings.backup.description': 'Télécharge une sauvegarde JSON complète et réimportable de tes données LifeOps.',
  'settings.backup.contentsTitle': 'Contenu de la sauvegarde',
  'settings.backup.contents': 'Profil LifeOps, tâches et historique, routines, listes, calendrier, activités et chronos, notes, repas, satisfaction, objectifs et tous les templates associés.',
  'settings.backup.restoreHelp': 'Le fichier conserve les identifiants et relations nécessaires à une future restauration. Les identifiants de propriétaire seront remappés vers le compte authentifié lors de la restauration.',
  'settings.backup.export': 'Exporter toutes mes données',
  'settings.backup.exporting': 'Création de la sauvegarde…',
  'settings.backup.success': 'Sauvegarde générée le {generatedAt}.',
  'settings.backup.error': 'La sauvegarde complète n’a pas pu être générée. Aucun fichier incomplet n’a été téléchargé.',
  'settings.restore.choose': 'Restaurer une sauvegarde',
  'settings.restore.preparing': 'Vérification de la sauvegarde…',
  'settings.restore.eyebrow': 'RESTAURATION',
  'settings.restore.confirmTitle': 'Restaurer les données à partir de la sauvegarde du {generatedAt} ?',
  'settings.restore.confirmHelp': 'Vérifie cette sauvegarde avant de continuer. Aucune donnée n’est écrite tant que tu ne confirmes pas.',
  'settings.restore.file': 'Fichier',
  'settings.restore.backupDate': 'Sauvegarde du',
  'settings.restore.rows': 'Éléments',
  'settings.restore.atomicWarning': 'La restauration est atomique : si une donnée ou une relation ne peut pas être restaurée, aucune modification n’est conservée.',
  'settings.restore.replaceExistingWarning': 'Ce compte contient déjà {count} ligne(s) de données métier. Elles seront remplacées par l’état de cette sauvegarde. Si la restauration échoue, les données actuelles seront conservées grâce au rollback transactionnel.',
  'settings.restore.confirm': 'Restaurer',
  'settings.restore.restoring': 'Restauration…',
  'settings.restore.success': 'Restauration terminée : {count} élément(s) restauré(s).',
  'settings.restore.targetNotEmpty': 'Ce compte contient déjà des données. La restauration V1 nécessite un compte vide.',
  'settings.restore.invalidFile': 'Ce fichier n’est pas une sauvegarde LifeOps compatible ou il est incomplet.',
  'settings.restore.error': 'La restauration a échoué. Aucune restauration partielle n’a été conservée.',

  'lists.myLists': 'Mes listes',
  'lists.new': 'Nouvelle liste',
  'lists.edit': 'Modifier la liste',
  'lists.type': 'Type de liste',
  'lists.kind.checklist': 'Checklist — éléments à cocher',
  'lists.kind.backlog': 'Backlog — file d’éléments ordonnée',
  'lists.kind.collection': 'Collection — éléments sans état terminé',
  'lists.kind.checklistShort': 'Checklist',
  'lists.kind.backlogShort': 'Backlog',
  'lists.kind.collectionShort': 'Collection',
  'lists.checklistHelp': 'Idéal pour une liste de courses permanente : coche les achats, puis purge les éléments achetés sans supprimer la liste.',
  'lists.archiveThis': 'Archiver cette liste',
  'lists.subtitle': 'Des listes permanentes, indépendantes des tâches, que tu peux réutiliser autant de fois que nécessaire.',
  'lists.loading': 'Chargement des listes…',
  'lists.empty': 'Aucune liste active. Crée par exemple une liste Courses et rattache-la à une tâche récurrente.',
  'lists.showArchived': 'Afficher les listes archivées ({count})',
  'lists.archived': 'Archivée',
  'lists.restore': 'Restaurer',
  'lists.summaryAria': 'Résumé de la liste',
  'lists.activeCount': '{count} actifs',
  'lists.completedCount': '{count} cochés',
  'lists.linkedTaskCount': '{count} tâches liées',
  'lists.back': '← Mes listes',
  'lists.loadingOne': 'Chargement de la liste…',
  'lists.archivedBanner': 'Cette liste est archivée. Son contenu et ses associations restent consultables, mais les modifications sont désactivées.',
  'lists.section.todo': 'À compléter',
  'lists.section.backlog': 'Backlog actif',
  'lists.section.items': 'Éléments',
  'lists.permanentHelp': 'La liste reste permanente : coche les achats au fur et à mesure, puis purge uniquement les éléments achetés.',
  'lists.newItem': 'Nouvel élément',
  'lists.itemPlaceholder': 'Ex. Lait',
  'lists.noActiveItems': 'Aucun élément actif dans cette liste.',
  'lists.markCompletedAria': 'Marquer {title} comme terminé',
  'lists.renameAria': 'Renommer {title}',
  'lists.subitem': 'Sous-item',
  'lists.subitemPlaceholder': 'Nom du sous-item',
  'lists.completedPurchased': 'Achetés / terminés',
  'lists.completed': 'Terminés',
  'lists.completedHelp': 'Ces éléments restent dans la liste tant que tu ne les purges pas.',
  'lists.purgeCompleted': 'Purger les éléments cochés',
  'lists.linkedTasks': 'Tâches liées',
  'lists.linkedTasksHelp': 'Le lien porte sur la définition de tâche : terminer ou annuler une occurrence ne modifie jamais cette liste.',
  'lists.noLinkedTasks': 'Aucune tâche liée.',
  'lists.linkExistingTask': 'Lier une tâche existante',
  'lists.chooseTask': 'Choisir une tâche…',
  'lists.detachAria': 'Détacher {title}',
  'lists.taskArchived': 'archivée',
  'lists.loadError': 'Impossible de charger les listes. Réessaie dans quelques instants.',
  'lists.loadOneError': 'Impossible de charger cette liste. Réessaie dans quelques instants.',
  'lists.confirm.removeItemTitle': 'Retirer cet élément ?',
  'lists.confirm.removeItem': 'Retirer cet élément de la liste active ? Ses sous-éléments seront également archivés.',
  'lists.confirm.removeSubitem': 'Retirer ce sous-élément de la liste active ?',
  'lists.confirm.purgeTitle': 'Retirer les éléments cochés ?',
  'lists.confirm.purge': 'Retirer tous les éléments cochés de la liste active ? Ils resteront archivés dans l’historique.',
  'lists.confirm.archiveTitle': 'Archiver la liste ?',
  'lists.confirm.deleteTitle': 'Supprimer la liste ?',
  'lists.confirm.archive': 'Cette liste possède un historique ou des tâches liées. Elle sera archivée et restera consultable. Continuer ?',
  'lists.confirm.delete': 'Supprimer définitivement cette liste vide ?',

  'tasks.title': 'Tâches',
  'tasks.subtitle': 'Actions ponctuelles, récurrentes et routines.',
  'tasks.typesAria': 'Types de tâches',
  'tasks.routines.defaultPeriod': 'Créneau par défaut',
  'tasks.routines.period.morning': 'Matin',
  'tasks.routines.period.afternoon': 'Après-midi',
  'tasks.routines.period.evening': 'Soirée',
  'tasks.routines.period.night': 'Nuit',
  'tasks.routines.measureType': 'Type de mesure',
  'tasks.routines.measureType.quantity': 'Quantité',
  'tasks.routines.measureType.time': 'Temps',
  'tasks.routines.measureUnit': 'Unité',
  'tasks.routines.quantityUnitRequired': 'Renseigne une unité pour une mesure de quantité.',
  'tasks.routines.defaultDuration': 'Durée par défaut (min)',
  'tasks.routines.durationCompleted': 'Durée réalisée',
  'tasks.routines.timerMeasured': 'Chrono actuellement associé : {value} min',
  'tasks.routines.useTimerValue': 'Utiliser la durée du chrono',
  'tasks.routines.measureUnitPlaceholder': 'Ex. min, pages, répétitions, ml',
  'tasks.routines.defaultQuantity': 'Quantité par défaut',
  'tasks.routines.measurePairRequired': 'Renseigne à la fois une unité et une quantité positive, ou laisse les deux vides.',
  'tasks.routines.quantityCompletedTitle': 'Réaliser « {title} »',
  'tasks.routines.quantityCompleted': 'Quantité réalisée',
  'tasks.routines.quantityPositive': 'La quantité doit être strictement positive.',
  'tasks.filters.search': 'Rechercher',
  'tasks.filters.searchPlaceholder': 'Titre ou description…',
  'tasks.filters.all': 'Tous',
  'tasks.filters.lastDate': 'Dernière',
  'tasks.filters.nextDate': 'Prochaine',
  'tasks.filters.activity': 'Suivi',
  'tasks.filters.withActivity': 'Avec activité / chrono',
  'tasks.filters.withoutActivity': 'Sans activité / chrono',
  'tasks.filters.reset': 'Réinitialiser',
  'tasks.recurrent': 'Récurrentes',
  'tasks.exchange.import': 'Importer depuis Excel / CSV',
  'tasks.exchange.exportActive': 'Exporter les configurations actives',
  'tasks.exchange.exportOne': 'Exporter {name}',
  'tasks.exchange.preview': '{count} configuration(s) reconnue(s). Aucun historique ne sera importé.',
  'tasks.exchange.upsertHelp': 'Même nom : la configuration existante est mise à jour. Nouveau nom : elle est créée. Les configurations absentes du fichier restent inchangées.',
  'tasks.exchange.upserted': '{updated} configuration(s) mise(s) à jour, {created} créée(s). Les autres configurations n’ont pas été modifiées.',
  'tasks.exchange.conflict': 'Si une configuration du même nom existe déjà',
  'tasks.exchange.replace': 'Remplacer la configuration',
  'tasks.exchange.copy': 'Importer comme nouvelle',
  'tasks.exchange.skip': 'Ignorer',
  'tasks.exchange.importConfirm': 'Importer',
  'tasks.exchange.imported': '{imported} configuration(s) importée(s), {skipped} ignorée(s).',
  'tasks.exchange.importError': 'L’import des configurations a échoué.',
  'tasks.exchange.exportError': 'L’export des configurations a échoué.',
  'tasks.newTodo': 'Nouvelle To Do',
  'tasks.loading': 'Chargement des tâches…',
  'tasks.todoEmpty': 'Aucune To Do. Crée ta première action, avec ou sans date.',
  'tasks.open': 'À faire',
  'tasks.deleteAria': 'Supprimer définitivement {title}',
  'tasks.completeAria': 'Terminer {title}',
  'tasks.scheduledFor': 'Prévue le',
  'tasks.changeDateAria': 'Modifier la date prévue de {title}',
  'tasks.cancelTask': 'Annuler la tâche',
  'tasks.loadingHistory': 'Chargement de l’historique…',
  'tasks.purgeHistory': 'Purger les tâches terminées et annulées',
  'tasks.historyEmpty': 'Aucune tâche dans l’historique.',
  'tasks.completedOn': 'Terminée le {date}',
  'tasks.cancelled': 'Annulée',
  'tasks.done': 'Réalisée',
  'tasks.notDone': 'Non réalisée',
  'tasks.editTodo': 'Modifier la To Do',
  'tasks.createTodo': 'Créer une To Do',
  'tasks.titleRequired': 'Le titre est obligatoire.',
  'tasks.scheduledDate': 'Date prévue',
  'tasks.subtasks': 'Sous-tâches',
  'tasks.subtaskAria': 'Sous-tâche {index}',
  'tasks.addSubtask': '+ Ajouter une sous-tâche',
  'tasks.completeDialogTitle': 'Terminer la tâche ?',
  'tasks.completeDialogBody': '« {title} » et ses sous-tâches seront marquées comme réalisées.',
  'tasks.deleteDialogTitle': 'Supprimer définitivement la tâche ?',
  'tasks.deleteDialogBody': '« {title} » et tout son historique seront supprimés. Cette action est irréversible.',
  'tasks.purgeDialogTitle': 'Purger tout l’historique clos ?',
  'tasks.purgeDialogBody': '{count} tâche(s) terminée(s) ou annulée(s) seront supprimées définitivement.',
  'tasks.cancelDialogTitle': 'Annuler cette tâche ?',
  'tasks.cancelDialogBody': 'Elle sera conservée dans l’historique sans être considérée comme réalisée.',
  'tasks.cancelReason': 'Motif facultatif',
  'tasks.recurrentDescription': 'Actions à refaire selon un intervalle calculé depuis leur réalisation réelle.',
  'tasks.newRecurrent': 'Nouvelle récurrente',
  'tasks.editRecurrent': 'Modifier la récurrente',
  'tasks.createRecurrent': 'Créer une récurrente',
  'tasks.intervalDays': 'Intervalle en jours',
  'tasks.firstDate': 'Première date facultative',
  'tasks.futureOccurrences': 'des prochaines occurrences',
  'tasks.noActiveRecurrent': 'Aucune tâche récurrente active.',
  'tasks.task': 'Tâche',
  'tasks.frequency': 'Fréquence',
  'tasks.last': 'Dernière',
  'tasks.next': 'Prochaine',
  'tasks.steps': 'Étapes',
  'tasks.priority.urgent': 'P1 — Urgent',
  'tasks.priority.high': 'P2 — Haute',
  'tasks.priority.normal': 'P3 — Normale',
  'tasks.priority.low': 'P4 — Basse',
  'tasks.priority.someday': 'P5 — Un jour',
  'tasks.loadError': 'Impossible de charger les tâches. Réessaie dans quelques instants.',
  'tasks.historyLoadError': 'Impossible de charger l’historique des tâches.',
  'tasks.saveError': 'L’enregistrement a échoué. Aucune modification supplémentaire ne sera envoyée.',
  'tasks.recurrentLoadError': 'Impossible de charger les tâches récurrentes.',
  'tasks.recurrentSaveError': 'L’enregistrement de la tâche récurrente a échoué.',
  'tasks.recurrentDetailError': 'Le détail de « {title} » n’a pas pu être chargé.',
  'tasks.completedDateRequired': 'La date de réalisation est obligatoire.',
  'tasks.routineStatus.completed': 'Réalisée',
  'tasks.routineStatus.notCompleted': 'Non réalisée',
  'tasks.routineStatus.cancelled': 'Annulée',
  'tasks.routineStatus.notRecorded': 'Non renseignée',
  'tasks.routineStatus.notPlanned': 'Non prévue',
  'tasks.routineSaveError': 'L’enregistrement de la routine a échoué.',
  'tasks.routineResultError': 'Le résultat de la routine n’a pas pu être enregistré.',
  'tasks.subtaskSaveError': 'La sous-tâche n’a pas pu être enregistrée.',
  'tasks.routinesLoadError': 'Impossible de charger les routines.',
  'tasks.routinesDateLoadError': 'Impossible de charger les routines pour cette date.',

  'tasks.recurrent.currentSubtasks': 'Sous-tâches de l’occurrence actuelle',
  'tasks.recurrent.noSubtasks': 'Aucune sous-tâche pour cette occurrence.',
  'tasks.recurrent.occurrences': 'Occurrences',
  'tasks.recurrent.cancelCurrent': 'Annuler l’occurrence actuelle',
  'tasks.recurrent.planned': 'Prévue',
  'tasks.recurrent.status': 'Statut',
  'tasks.recurrent.completedOn': 'Réalisée le',
  'tasks.recurrent.noHistory': 'Aucune occurrence passée.',
  'tasks.recurrent.inactive': 'Désactivées',
  'tasks.recurrent.reactivate': 'Réactiver',
  'tasks.recurrent.planNext': 'Planifier la prochaine occurrence',
  'tasks.recurrent.nextDate': 'Prochaine date',
  'tasks.recurrent.cancelOccurrenceQuestion': 'Annuler cette occurrence ?',
  'tasks.recurrent.planFollowing': 'Planifier l’occurrence suivante',
  'tasks.recurrent.cancelOccurrence': 'Annuler l’occurrence',
  'tasks.recurrent.date': 'Date',
  'tasks.recurrent.plan': 'Planifier',
  'tasks.recurrent.editOccurrence': 'Modifier l’occurrence',
  'tasks.recurrent.completed': 'Réalisée',
  'tasks.recurrent.cancelled': 'Annulée',
  'tasks.recurrent.realCompletionDate': 'Date réelle de réalisation',
  'tasks.recurrent.cancellationReason': 'Motif d’annulation',
  'tasks.recurrent.recalculateNext': 'Recalculer également la prochaine occurrence',
  'tasks.recurrent.deleteOccurrenceQuestion': 'Supprimer cette occurrence ?',
  'tasks.recurrent.deleteOccurrenceHelp': 'Cette suppression est définitive. L’occurrence et ses sous-tâches disparaîtront de l’historique.',
  'tasks.recurrent.deactivateQuestion': 'Désactiver cette récurrente ?',
  'tasks.recurrent.deactivateHelp': 'L’occurrence ouverte sera annulée. L’historique sera conservé et aucune nouvelle occurrence ne sera créée.',
  'tasks.recurrent.deactivate': 'Désactiver',
  'tasks.recurrent.deleteTaskHelp': 'La tâche, toutes ses occurrences, son historique et ses sous-tâches seront définitivement supprimés.',
  'tasks.recurrent.irreversible': 'Cette action est irréversible.',
  'tasks.recurrent.markDone': 'Marquer comme réalisée',
  'tasks.recurrent.showDetails': 'Afficher les détails',
  'tasks.recurrent.completeQuestion': 'Terminer « {title} » ?',
  'tasks.recurrent.everyDay': 'Tous les jours',
  'tasks.recurrent.everyDays': 'Tous les {count} jours',
  'tasks.recurrent.lateDays': '+{count} j',
  'tasks.recurrent.deleteOccurrenceAria': 'Supprimer cette occurrence',
  'tasks.routines.dateNavigation': 'Navigation par date',
  'tasks.routines.previousDay': 'Jour précédent',
  'tasks.routines.nextDay': 'Jour suivant',
  'tasks.routines.historyFiveDays': 'Historique des cinq derniers jours',
  'tasks.routines.cancelOccurrence': 'Annuler cette occurrence',
  'tasks.routines.resetStatus': 'Remettre à non renseignée',
  'tasks.routines.inactiveBadge': 'Inactive',
  'tasks.routines.stepSingular': 'étape',
  'tasks.routines.stepPlural': 'étapes',
  'tasks.routines.markCompletedAria': 'Marquer {title} comme réalisée',
  'tasks.routines.markNotCompletedAria': 'Marquer {title} comme non réalisée',
  'tasks.routines.resetAria': 'Remettre {title} à non renseignée',
  'tasks.routines.dailyTracking': 'Suivi quotidien',
  'tasks.routines.today': 'Aujourd’hui',
  'tasks.routines.futureReadOnly': 'Date future — consultation uniquement',
  'tasks.routines.chooseDate': 'Choisir une date',
  'tasks.routines.configuration': 'Configuration',
  'tasks.routines.new': '+ Nouvelle routine',
  'tasks.routines.active': 'Actives',
  'tasks.routines.inactive': 'Inactives',
  'tasks.routines.historyKept': 'Historique conservé',
  'tasks.routines.archive': 'Archiver',
  'tasks.routines.emptyConfig': 'Aucune routine configurée',
  'tasks.routines.emptyConfigHelp': 'Crée ta première routine pour commencer le suivi quotidien.',
  'tasks.routines.loading': 'Chargement des routines…',
  'tasks.routines.retryToday': 'Réessayer aujourd’hui',
  'tasks.routines.archived': 'Archivée',
  'tasks.routines.fiveDays': '5 jours',
  'tasks.routines.emptyDay': 'Aucune routine prévue pour cette date',
  'tasks.routines.noRollover': 'Les routines ne sont jamais reportées d’un jour sur l’autre.',
  'tasks.routines.create': 'Créer une routine',
  'tasks.routines.daySteps': 'Étapes du jour',
  'tasks.routines.stepsLocked': 'Les étapes ne sont modifiables que tant que le résultat de la routine n’est pas renseigné.',
  'tasks.routines.activeFrom': 'Active à partir du',
  'tasks.routines.dailySteps': 'Étapes quotidiennes',
  'tasks.routines.optionalSteps': 'Facultatives, remises à zéro pour chaque nouvelle date.',
  'tasks.routines.historyDeactivateHelp': 'L’historique est conservé. Aucune nouvelle journée ne sera créée à partir d’aujourd’hui.',
  'tasks.routines.resumeFrom': 'Reprendre à partir du',
  'tasks.routines.noRetroactive': 'La période d’inactivité ne sera pas recréée rétroactivement.',
  'tasks.routines.archiveHelp': 'La routine disparaîtra de la configuration, mais ses journées déjà enregistrées resteront consultables dans l’historique.',
  'tasks.routines.closeConfig': 'Fermer la configuration',
  'tasks.routines.configure': 'Configurer les routines',
  'tasks.routines.completedCount': 'routines réalisées sur',
  'tasks.routines.plannedCount': 'prévues',

  'today.title': 'Today',
  'today.today': 'Aujourd’hui',
  'today.loading': 'Chargement de la journée…',
  'today.loadUnavailable': 'Impossible de charger la journée. Les données restent intactes.',
  'today.retryLoading': 'Réessayer',
  'today.dayPriority': 'Priorité du jour',
  'today.openCalendar': 'Voir dans Calendrier →',
  'today.highlightUnavailable': 'Le highlight est indisponible pour le moment.',
  'today.noHighlight': 'Aucun highlight défini pour cette journée',
  'today.chooseHighlight': 'Highlight du jour',
  'today.chooseHighlightAria': 'Choisir le Highlight de la journée',
  'today.clearHighlight': 'Retirer le Highlight',
  'today.clearHighlightAria': 'Retirer le Highlight de la journée',
  'today.setHighlightTo': 'Définir comme Highlight :',
  'today.removeHighlightFrom': 'Retirer du Highlight :',
  'today.startActivityTimer': 'Démarrer le chrono',
  'today.error.startActivityTimer': 'Impossible de démarrer le chrono pour {title}.',
  'today.clearMealAria': 'Effacer le repas pour',
  'today.noHighlightCandidate': 'Aucune activité planifiée n’est disponible comme Highlight.',
  'today.error.highlightSave': 'Le Highlight n’a pas pu être enregistré.',
  'today.reschedule': 'Replanifier',
  'today.changeActivityPeriod': 'Changer la période de',
  'today.error.rescheduleActivity': 'Impossible de replanifier {title}.',
  'today.mealFor': 'Repas pour',
  'today.noMealSelected': 'Aucun repas sélectionné',
  'today.noMealAvailable': 'Aucun repas disponible',
  'today.toPlan': 'À planifier',
  'today.tasksPartialError': 'Certaines tâches n’ont pas pu être chargées.',
  'today.plan': 'Planifier…',
  'today.postpone': 'Reporter',
  'today.skip': 'Ignorer',
  'today.noSubtasks': 'Aucune sous-tâche.',
  'today.hideSubtasks': 'Masquer les sous-tâches',
  'today.planning': 'Planning',
  'today.myDay': 'Ma journée',
  'today.openCalendarShort': 'Ouvrir Calendrier →',
  'today.calendarUnavailable': 'Le planning Calendrier est indisponible.',
  'today.plannedTasksPartialError': 'Certaines tâches planifiées n’ont pas pu être chargées.',
  'today.calendarActivity': 'Activité Calendrier',
  'today.dropTaskHere': 'Dépose ou affecte une tâche ici.',
  'today.noCalendarPeriod': 'Aucune période Calendrier active n’est disponible pour cette journée.',
  'today.myMeals': 'Mes repas',
  'today.mealsUnavailable': 'Les repas sont indisponibles pour le moment.',
  'today.noMealType': 'Aucun type de repas actif. Ajoute ou réactive un axe Repas dans Calendrier.',
  'today.wellbeing': 'Bien-être',
  'today.satisfaction': 'Satisfaction de la journée',
  'today.clear': 'Effacer',
  'today.satisfactionUnavailable': 'L’indice de satisfaction est indisponible pour le moment.',
  'today.goalsProgress': 'Progression du jour',
  'today.openGoals': 'Voir Objectifs →',
  'today.partialUnavailable': 'Certains blocs sont temporairement indisponibles. Les autres restent utilisables.',
  'today.recurrentTask': 'Tâche récurrente',
  'today.completedOn': 'Réalisée le',
  'today.createNextOccurrence': 'Créer la prochaine occurrence',
  'today.nextOccurrence': 'Prochaine occurrence',
  'today.navigationAria': 'Navigation de la journée',
  'today.previousDayAria': 'Jour précédent',
  'today.chooseDateAria': 'Choisir une date',
  'today.nextDayAria': 'Jour suivant',
  'today.highlightDoneAria': 'Highlight réalisé',
  'today.moveTaskAria': 'Déplacer la tâche',
  'today.mealPlaceholder': 'Repas / recette…',
  'today.satisfactionAria': 'Satisfaction de la journée de moins trois à plus trois',
  'today.error.completeRecurrent': 'La récurrente n’a pas pu être terminée.',
  'today.error.placeTask': 'La tâche n’a pas pu être affectée à cette période.',
  'today.error.moveTask': 'Le déplacement de la tâche a échoué.',
  'today.error.unplanTask': 'La tâche n’a pas pu être remise dans À planifier.',
  'today.error.reorder': 'L’ordre de la période n’a pas pu être enregistré.',
  'today.highlightFallback': 'Élément mis en avant',
  'today.recurrent': 'Récurrente',
  'today.routine': 'Routine',
  'today.satisfaction.minus3': 'Journée extrêmement insatisfaisante',
  'today.satisfaction.minus2': 'Mauvaise journée',
  'today.satisfaction.minus1': 'Plutôt insatisfaisante',
  'today.satisfaction.zero': 'Neutre',
  'today.satisfaction.plus1': 'Plutôt satisfaisante',
  'today.satisfaction.plus2': 'Bonne journée',
  'today.satisfaction.plus3': 'Excellente journée',
  'today.error.subtasks': 'Les sous-tâches de « {title} » n’ont pas pu être chargées.',
  'today.error.subtaskUpdate': 'La sous-tâche « {title} » n’a pas pu être mise à jour.',
  'today.error.mealSave': 'Le repas « {name} » n’a pas pu être enregistré.',
  'today.error.satisfactionSave': 'La satisfaction de la journée n’a pas pu être enregistrée.',
  'today.error.satisfactionClear': 'La satisfaction de la journée n’a pas pu être effacée.',
  'today.error.futureDate': 'Choisis une date postérieure à la journée affichée.',
  'today.error.postpone': 'La tâche « {title} » n’a pas pu être reportée.',
  'today.error.skip': 'La routine « {title} » n’a pas pu être ignorée.',
  'today.error.completeTask': 'La tâche n’a pas pu être terminée. Réessaie.',
  'today.error.reopenTask': 'La tâche « {title} » n’a pas pu être rouverte.',
  'today.error.completeActivity': 'L’activité n’a pas pu être terminée. Réessaie.',
  'today.error.reopenActivity': 'L’activité n’a pas pu être rouverte. Réessaie.',

  'calendar.title': 'Calendrier',
  'calendar.planWeek': 'Planifier la semaine',
  'calendar.manageAxes': 'Gérer les axes',
  'calendar.addAxis': 'Ajouter un axe',
  'calendar.addingAxis': 'Ajout…',
  'calendar.axisUp': 'Déplacer l’axe vers le haut',
  'calendar.axisDown': 'Déplacer l’axe vers le bas',
  'calendar.today': 'Aujourd’hui',
  'calendar.chooseDate': 'Choisir une date',
  'calendar.consultation': 'Consultation',
  'calendar.editing': 'Édition',
  'calendar.editMode': 'Mode édition',
  'calendar.finishEditing': 'Terminer l’édition',
  'calendar.mealForDay': '{meal} — {day}',
  'calendar.configuration': 'Configuration',
  'calendar.axesTitle': 'Axes du calendrier',
  'calendar.name': 'Nom',
  'calendar.type': 'Type',
  'calendar.axisThematic': 'Axe thématique',
  'calendar.timeSlot': 'Créneau temporel',
  'calendar.slot': 'Créneau',
  'calendar.axis': 'Axe',
  'calendar.initial': 'Initial',
  'calendar.archived': 'Archivé',
  'calendar.visible': 'Visible',
  'calendar.restore': 'Restaurer',
  'calendar.loadingWeek': 'Chargement de la semaine…',
  'calendar.planning': 'Planning',
  'calendar.weekPlanning': 'Planning de la semaine',
  'calendar.dayPlanning': 'Planning du jour',
  'calendar.openToday': 'Ouvrir Today →',
  'calendar.moveCopyHelp': 'Une entrée libre se copie ; une To Do ou récurrente se déplace. Une routine reste liée à sa journée. Les axes Repas sont renseignés depuis Today.',
  'calendar.noVisibleAxes': 'Tous les axes sont masqués ou archivés. Ouvre « Gérer les axes » pour en réafficher un.',
  'calendar.nothingPlanned': 'Rien de prévu.',
  'calendar.noPlanningAxis': 'Aucun axe de planning visible pour le moment.',
  'calendar.scheduling': 'Planification',
  'calendar.placeExistingOccurrence': 'Placer une occurrence existante',
  'calendar.chooseTaskType': 'Choisis directement le type puis l’occurrence à placer dans cette case.',
  'calendar.or': 'ou',
  'calendar.createFreeEntry': 'Planifier une activité',
  'calendar.reuseActivity': 'Réutiliser une activité',
  'calendar.newActivity': 'Nouvelle activité…',
  'calendar.activitySuggestionsHelp': 'Les activités actives sont réutilisables dans plusieurs placements du planning.',
  'calendar.chooseAxis': 'Choisir un axe',
  'calendar.date': 'Date',
  'calendar.deleteLogicalHelp': 'Elle disparaîtra des vues normales mais restera supprimée logiquement en base.',
  'calendar.keepCurrentState': 'Garder l’état actuel',
  'calendar.recurrentTask': 'Tâche récurrente',
  'calendar.recurrentCompletionHelp': 'Le Calendrier utilise le même parcours métier que Tâches : date réelle de réalisation puis choix immédiat de la prochaine occurrence.',
  'calendar.realCompletionDate': 'Date réelle de réalisation',
  'calendar.createNextOccurrence': 'Créer la prochaine occurrence',
  'calendar.nextDate': 'Prochaine date',
  'calendar.navigationAria': 'Navigation du calendrier',
  'calendar.previousWeek': 'Semaine précédente',
  'calendar.nextWeek': 'Semaine suivante',
  'calendar.closeAria': 'Fermer',
  'calendar.axisLeft': 'Déplacer l’axe vers la gauche',
  'calendar.axisRight': 'Déplacer l’axe vers la droite',
  'calendar.weekView': 'Vue semaine',
  'calendar.mobileDayView': 'Vue jour mobile',
  'calendar.previousDay': 'Jour précédent',
  'calendar.nextDay': 'Jour suivant',
  'calendar.notePlaceholder': 'Contexte, lieu, précision…',
  'calendar.cancelledAria': 'Annulée',
  'calendar.setHighlight': 'Mettre en highlight',
  'calendar.moveEntryUp': 'Monter l’entrée',
  'calendar.moveEntryDown': 'Descendre l’entrée',
  'calendar.unplanTask': 'Déplanifier sans supprimer la tâche',
  'calendar.noDate': 'Sans date',
  'calendar.routineOn': 'Routine du {date}',
  'calendar.postponedDays': 'Reportée de {count} j',
  'calendar.lateDays': 'En retard de {count} j',
  'calendar.scheduled': 'Prévue {date}',
  'calendar.unplaced': 'Non placée',
  'calendar.axisUnavailable': 'Axe indisponible',
  'calendar.error.load': 'Impossible de charger le calendrier. Réessaie dans quelques instants.',
  'calendar.error.entrySave': 'L’entrée n’a pas pu être enregistrée. Les autres éléments n’ont pas été modifiés.',
  'calendar.error.tasksLoad': 'Les tâches disponibles n’ont pas pu être chargées.',
  'calendar.error.routineDate': 'Une routine doit être placée sur la date de son occurrence quotidienne.',
  'calendar.error.taskPlace': 'La tâche n’a pas pu être placée. Aucun déplacement partiel n’a été conservé.',
  'calendar.error.copy': 'La copie de l’activité n’a pas pu être enregistrée. Réessaie.',
  'calendar.error.routineMove': 'Une routine quotidienne ne peut pas être déplacée vers une autre date.',
  'calendar.error.taskMove': 'Le déplacement de la tâche a échoué. Tasks et Calendar sont restés dans leur état précédent.',
  'calendar.error.taskUnplan': 'La tâche n’a pas pu être déplanifiée. Elle reste disponible dans Tasks.',
  'calendar.error.taskComplete': 'La tâche n’a pas pu être terminée depuis Calendar.',
  'calendar.error.taskReopen': 'La tâche n’a pas pu être rouverte depuis Calendrier.',
  'calendar.error.recurrentComplete': 'La récurrente n’a pas pu être terminée. Aucune prochaine occurrence partielle n’a été conservée.',
  'calendar.error.highlightUpdate': 'Le highlight n’a pas pu être mis à jour.',
  'calendar.error.highlightSave': 'Le highlight n’a pas pu être enregistré.',
  'calendar.error.highlightRemove': 'Le highlight n’a pas pu être retiré.',
  'calendar.error.axisCreate': 'L’axe n’a pas pu être créé.',
  'calendar.error.axisOrder': 'L’ordre des axes n’a pas pu être enregistré.',
  'calendar.error.axisUpdate': 'La modification de l’axe n’a pas pu être enregistrée.',
  'calendar.mealsLoadError': 'Les repas de la semaine n’ont pas pu être chargés.',
  'calendar.mealSaveError': 'Le repas n’a pas pu être enregistré. Les autres cases restent inchangées.',
  'calendar.templatesLoadError': 'Les templates du calendrier n’ont pas pu être chargés.',
  'calendar.templateItemAddError': 'L’activité n’a pas pu être ajoutée au template.',
  'calendar.templateItemRemoveError': 'L’activité n’a pas pu être retirée du template.',
  'calendar.templateApplied': '{count} activité(s) ajoutée(s) à la semaine.',
  'calendar.templateAlreadyApplied': 'Ce template est déjà présent sur cette semaine.',
  'calendar.templateApplyError': 'Le template n’a pas pu être chargé. La semaine existante n’a pas été supprimée.',
  'calendar.templateDeleted': 'Template supprimé. Les semaines déjà chargées restent inchangées.',
  'calendar.templateDeleteError': 'Le template n’a pas pu être supprimé.',
  'calendar.templateCreatedFromWeek': 'Template créé avec {count} activité(s) libre(s).',
  'calendar.templateCreatedBlank': 'Template vide créé. Ajoute maintenant ses activités.',
  'calendar.templateCreateError': 'Le template n’a pas pu être créé. Vérifie notamment que son nom est unique.',
  'calendar.meals': 'Repas',
  'calendar.weekMenus': 'Menus de la semaine',
  'calendar.loadingMeals': 'Chargement des repas…',
  'calendar.history': 'Historique',
  'calendar.mealPlaceholder': 'Repas…',
  'calendar.clearMeal': 'Effacer le repas',
  'calendar.noMealAxes': 'Aucun type de repas actif. Ajoute-en un depuis « Gérer les axes » en choisissant le type Repas.',
  'calendar.weekModel': 'Modèle de semaine',
  'calendar.chooseTemplate': 'Choisir…',
  'calendar.noTemplate': 'Aucun template',
  'calendar.load': 'Charger',
  'calendar.manageTemplates': 'Gérer les templates',
  'calendar.templates': 'Templates',
  'calendar.manageWeekModels': 'Gérer les modèles de semaine',
  'calendar.templateImport': 'Importer des modèles Excel / CSV',
  'calendar.exportAllTemplates': 'Exporter tous les modèles',
  'calendar.exportTemplate': 'Exporter {name}',
  'calendar.templateImportSummary': '{templates} modèle(s), {axes} axe(s) à vérifier.',
  'calendar.associateAxis': 'Associer à « {name} »',
  'calendar.createAxisOnImport': 'Créer l’axe « {name} »',
  'calendar.templateConflict': 'Si un modèle du même nom existe déjà',
  'calendar.templateConflictReplace': 'Remplacer',
  'calendar.templateConflictCopy': 'Importer comme nouveau',
  'calendar.templateConflictSkip': 'Ignorer',
  'calendar.importTemplates': 'Importer les modèles',
  'calendar.templateImported': '{imported} modèle(s) importé(s), {skipped} ignoré(s).',
  'calendar.templateImportError': 'L’import des modèles Calendrier a échoué.',
  'calendar.templateImportInvalidItem': 'Une activité du fichier est incomplète ou invalide.',
  'calendar.templateExported': '{count} modèle exporté.',
  'calendar.templatesExported': '{count} modèles exportés.',
  'calendar.templateName': 'Nom du template',
  'calendar.modelNamePlaceholder': 'Nom du modèle',
  'calendar.createBlank': 'Créer vide',
  'calendar.fromWeek': 'Depuis cette semaine',
  'calendar.createdFromWeek': 'Créé depuis la semaine du {date}',
  'calendar.createdBlank': 'Créé à partir de zéro',
  'calendar.deleteTemplate': 'Supprimer le template',
  'calendar.day': 'Jour',
  'calendar.activity': 'Activité',
  'calendar.optionalNote': 'Note facultative',
  'calendar.addToTemplate': 'Ajouter au template',
  'calendar.emptyTemplate': 'Template vide. Ajoute sa première activité ci-dessus.',
  'calendar.loadTemplateQuestion': 'Charger {name} ?',
  'calendar.loadTemplateHelp': 'Les activités libres manquantes seront ajoutées à la semaine affichée. Les entrées déjà présentes et toutes les tâches restent intactes.',
  'calendar.loadTemplate': 'Charger le template',
  'calendar.deleteTemplateQuestion': 'Supprimer {name} ?',
  'calendar.deleteTemplateHelp': 'Le template sera supprimé, mais les semaines sur lesquelles il a déjà été chargé ne seront pas modifiées.',

  'goals.title': 'Objectifs',
  'goals.nonApplicable': 'Non applicable',
  'goals.unavailable': 'Indisponible',
  'goals.error': 'Erreur',
  'goals.correctionValueRequired': 'Renseigne une valeur de correction.',
  'goals.negativeReplacement': 'Une valeur de remplacement ne peut pas être négative.',
  'goals.booleanReplacement': 'Un remplacement oui/non accepte uniquement 0 ou 1.',
  'goals.correctionSaved': 'Correction enregistrée.',
  'goals.correctionDeleted': 'Correction supprimée.',
  'goals.targetChanged': 'Cible modifiée pour cette date.',
  'goals.removedFromDate': 'Objectif retiré de cette date.',
  'goals.removedFromPeriod': 'Objectif retiré de cette période.',
  'goals.targetPositive': 'La cible doit être strictement positive.',
  'goals.booleanTarget': 'La cible d’un objectif oui/non doit être égale à 1.',
  'goals.actionFailed': 'L’action Goals a échoué. Réessaie.',
  'goals.addGoal': 'Ajouter un objectif',
  'goals.templateEmpty': 'La semaine type enregistrée est vide. Ajoute des objectifs puis enregistre-la avant de la charger.',
  'goals.weekAlreadyPresent': 'La semaine type est déjà entièrement présente sur cette semaine. Les personnalisations existantes sont conservées.',
  'goals.editorCleared': 'Semaine type vidée dans l’éditeur. Enregistre pour appliquer ce modèle aux prochaines journées.',
  'goals.sourceWeekEmpty': 'Cette semaine ne contient aucune journée Goals déjà enregistrée.',
  'goals.goalUnavailable': 'Objectif indisponible',
  'goals.modelUnavailable': 'Un objectif du modèle n’est plus disponible.',
  'goals.templateSaved': 'Semaine type enregistrée. Les journées déjà existantes restent inchangées tant que tu ne charges pas explicitement le modèle sur une semaine.',
  'goals.eachTargetPositive': 'Chaque cible doit être strictement positive.',
  'goals.booleanTemplateTarget': 'Une cible oui/non doit être égale à 1.',
  'goals.templateSaveFailed': 'Le modèle hebdomadaire n’a pas pu être enregistré.',

  'goals.subtitle': 'Résultat, cible et progression pour la journée.',
  'goals.weeklyTemplate': 'Semaine type',
  'goals.add': 'Ajouter',
  'goals.navigationAria': 'Navigation entre les dates',
  'goals.previousDay': 'Jour précédent',
  'goals.today': 'Aujourd’hui',
  'goals.nextDay': 'Jour suivant',
  'goals.loading': 'Chargement des objectifs…',
  'goals.summaryAria': 'Résumé de la journée',
  'goals.periodSummaryAria': 'Résumé de la période',
  'goals.scoreProvisional': 'score provisoire',
  'goals.scoreDay': 'score du jour',
  'goals.scorePeriod': 'score de la période',
  'goals.achieved': 'atteints',
  'goals.measured': 'renseignés',
  'goals.refresh': 'Actualiser',
  'goals.dayGoalsAria': 'Objectifs du jour',
  'goals.goal': 'Objectif',
  'goals.result': 'Résultat',
  'goals.automatic': 'Automatique',
  'goals.corrected': 'corrigé',
  'goals.addedForDay': 'Ajouté pour ce jour',
  'goals.sourceUnavailable': 'Source indisponible',
  'goals.resultAria': 'Résultat {name}',
  'goals.calculated': 'calculé',
  'goals.optionsAria': 'Options de {name}',
  'goals.editGoal': 'Modifier l’objectif',
  'goals.targetForDay': 'Cible pour ce jour',
  'goals.changeTarget': 'Modifier la cible',
  'goals.correctAutomatic': 'Corriger le résultat automatique',
  'goals.calculatedValue': 'Valeur calculée : {value}',
  'goals.mode': 'Mode',
  'goals.adjust': 'Ajuster',
  'goals.replace': 'Remplacer',
  'goals.value': 'Valeur',
  'goals.apply': 'Appliquer',
  'goals.clearCorrection': 'Effacer la correction',
  'goals.removeForDay': 'Retirer de ce jour',
  'goals.removeForPeriod': 'Retirer de cette période',
  'goals.emptyDay': 'Aucun objectif pour cette date.',
  'goals.emptyDayHelp': 'Ajoute un objectif ici ou prépare ta semaine type.',
  'goals.addToDate': 'Ajouter à {date}',
  'goals.goalEdited': 'Objectif modifié.',
  'goals.newGoalAdded': 'Nouvel objectif ajouté à cette date.',
  'goals.goalAdded': 'Objectif ajouté à cette date.',
  'goals.automaticRefreshed': 'Résultats automatiques actualisés.',
  'goals.manualNonNegative': 'Le résultat doit être positif ou nul.',
  'goals.booleanResult': 'Un objectif oui/non accepte uniquement 0 ou 1.',
  'goals.noOccurrence': 'Aucune occurrence n’est prévue pour cette date : le résultat est non applicable.',
  'goals.template.subtitle': 'Prépare les objectifs habituels de chaque jour, puis charge ce modèle sur les semaines voulues.',
  'goals.template.backDay': 'Retour au jour',
  'goals.template.saving': 'Enregistrement…',
  'goals.template.save': 'Enregistrer',
  'goals.template.loading': 'Chargement de la semaine type…',
  'goals.template.startEyebrow': 'POINT DE DÉPART',
  'goals.template.createModel': 'Créer le modèle',
  'goals.template.createHelp': 'Pars de zéro ou reprends les objectifs et cibles d’une semaine déjà enregistrée.',
  'goals.template.startBlank': 'Partir de zéro',
  'goals.template.previousWeek': 'Semaine précédente',
  'goals.template.chooseExistingWeek': 'Choisir une semaine existante',
  'goals.template.nextWeek': 'Semaine suivante',
  'goals.template.loadingShort': 'Chargement…',
  'goals.template.fromWeek': 'Depuis cette semaine',
  'goals.template.loadEyebrow': 'CHARGER LE MODÈLE',
  'goals.template.applyTitle': 'Appliquer la semaine type',
  'goals.template.applyHelp': 'Ajoute le modèle enregistré à une semaine réelle sans supprimer ni écraser les personnalisations déjà présentes.',
  'goals.template.previousTargetWeek': 'Semaine cible précédente',
  'goals.template.chooseTargetWeek': 'Choisir la semaine sur laquelle charger le modèle',
  'goals.template.nextTargetWeek': 'Semaine cible suivante',
  'goals.template.loadThisWeek': 'Charger sur cette semaine',
  'goals.template.confirmQuestion': 'Charger la semaine type sur {week} ?',
  'goals.template.confirmHelp': 'Les objectifs manquants seront ajoutés. Les objectifs, résultats et cibles déjà personnalisés resteront inchangés.',
  'goals.template.load': 'Charger la semaine type',
  'goals.template.editorAria': 'Objectifs de la semaine type',
  'goals.template.goalSingular': 'objectif',
  'goals.template.goalPlural': 'objectifs',
  'goals.template.moveUp': 'Monter {name}',
  'goals.template.moveDown': 'Descendre {name}',
  'goals.template.removeFromDay': 'Retirer {name} du {day}',
  'goals.template.target': 'Cible',
  'goals.template.noGoal': 'Aucun objectif.',
  'goals.template.addToDay': 'Ajouter au {day}',
  'goals.template.appliedCount': '{count} objectifs ajoutés ou restaurés sur la semaine.',
  'goals.template.copiedWeek': 'Semaine du {date} reprise dans l’éditeur. Rien n’est enregistré tant que tu ne cliques pas sur Enregistrer.',
  'goals.templateInline.day': 'jour',
  'goals.templateInline.saveDay': 'Sauvegarder jour',
  'goals.templateInline.loadDay': 'Charger jour',
  'goals.templateInline.savePeriod': 'Sauvegarder template {period}',
  'goals.templateInline.loadPeriod': 'Charger template {period}',
  'goals.templateInline.saveWeeklyType': 'Sauvegarder semaine type',
  'goals.templateInline.loadWeeklyType': 'Charger semaine type',
  'goals.templateInline.savedDay': 'Template du jour sauvegardé ({count} objectif(s)).',
  'goals.templateInline.loadedDay': 'Template du jour chargé ({count} objectif(s)).',
  'goals.templateInline.savedPeriod': 'Template {period} sauvegardé ({count} objectif(s)).',
  'goals.templateInline.loadedPeriod': 'Template {period} chargé ({count} objectif(s)).',
  'goals.templateInline.savedWeeklyType': 'Semaine type sauvegardée à partir de la semaine affichée.',
  'goals.templateInline.loadedWeeklyType': 'Semaine type chargée ({count} objectif(s)).',
  'goals.templateInline.emptyWeek': 'La semaine affichée ne contient aucun objectif à sauvegarder.',
  'goals.templateLibrary.eyebrow': 'BIBLIOTHÈQUE DE TEMPLATES',
  'goals.templateLibrary.saveDayTitle': 'Sauvegarder ce jour comme template',
  'goals.templateLibrary.loadDayTitle': 'Charger un jour type',
  'goals.templateLibrary.savePeriodTitle': 'Sauvegarder un template {period}',
  'goals.templateLibrary.loadPeriodTitle': 'Charger un template {period}',
  'goals.templateLibrary.saveWeekTitle': 'Sauvegarder une semaine type',
  'goals.templateLibrary.loadWeekTitle': 'Charger une semaine type',
  'goals.templateLibrary.name': 'Nom du template',
  'goals.templateLibrary.namePlaceholder': 'Ex. Jour type bureau',
  'goals.templateLibrary.template': 'Template',
  'goals.templateLibrary.load': 'Charger',
  'goals.templateLibrary.none': 'Aucun template enregistré pour ce contexte.',
  'goals.templateLibrary.nameRequired': 'Donne un nom au template.',
  'goals.templateLibrary.choose': 'Choisis un template à charger.',
  'goals.templateLibrary.saved': 'Template « {name} » sauvegardé.',
  'goals.templateLibrary.loaded': 'Template chargé.',
  'goals.templateLibrary.weekDirect': 'Objectifs directement définis pour chaque jour',
  'goals.templateLibrary.weekDayTypes': 'Composer la semaine avec des jours types',
  'goals.templateLibrary.weekDirectHelp': 'La semaine affichée sera copiée telle quelle dans ce template.',
  'goals.templateLibrary.weekDirectShort': 'objectifs directs',
  'goals.templateLibrary.weekDayTypesShort': 'jours types',
  'goals.templateLibrary.sevenDaysRequired': 'Sélectionne un jour type pour chacun des 7 jours.',
  'goals.templateLibrary.exportExcel': 'Exporter en CSV pour Excel',
  'goals.templateLibrary.importExcel': 'Importer depuis Excel / CSV',
  'goals.templateLibrary.exportAll': 'Exporter tous les templates',
  'goals.templateLibrary.exported': 'Template exporté ({count} ligne(s)).',
  'goals.templateLibrary.exportedAll': '{count} template(s) exporté(s).',
  'goals.templateLibrary.exportEmpty': 'Ce template ne contient aucun objectif à exporter.',
  'goals.templateLibrary.importPreview': '{count} ligne(s) reconnue(s). Vérifie le traitement des conflits avant import.',
  'goals.templateLibrary.conflictLabel': 'Si un template du même nom existe',
  'goals.templateLibrary.conflictReplace': 'Remplacer',
  'goals.templateLibrary.conflictCopy': 'Importer comme nouveau',
  'goals.templateLibrary.conflictSkip': 'Ignorer',
  'goals.templateLibrary.importConfirm': 'Importer',
  'goals.templateLibrary.imported': '{imported} template(s) importé(s), {skipped} ignoré(s). {manualized} source(s) automatique(s) non portable(s) ont été importées en manuel et doivent être réassociées.',
  'goals.templateLibrary.manage': 'Gérer les templates',
  'goals.templateLibrary.manageTitle': 'Gérer les templates',
  'goals.templateLibrary.emptyDay': 'Aucun template — jour sans objectif',
  'goals.templateLibrary.emptyDayHelp': 'Un jour sans template sera volontairement vide quand la semaine type sera chargée.',
  'goals.templateLibrary.kindDay': 'Jour type',
  'goals.templateLibrary.kindWeek': 'Semaine type',
  'goals.templateLibrary.kindPeriod': 'Template {period}',
  'goals.templateLibrary.noneAny': 'Aucun template sauvegardé.',
  'goals.templateLibrary.backToList': 'Liste des templates',
  'goals.templateLibrary.weekday': 'Jour',
  'goals.templateLibrary.goal': 'Objectif',
  'goals.templateLibrary.target': 'Cible',
  'goals.templateLibrary.removeGoal': 'Retirer',
  'goals.templateLibrary.addGoal': 'Ajouter un objectif',
  'goals.templateLibrary.saveChanges': 'Enregistrer les modifications',
  'goals.templateLibrary.updated': 'Template modifié.',
  'goals.templateLibrary.weekdayRequired': 'Choisis un jour pour chaque objectif de la semaine.',
  'goals.templateLibrary.exportOne': 'Exporter {name}',
  'goals.periodTemplate.eyebrow': 'TEMPLATES DE PÉRIODE',
  'goals.periodTemplate.title': 'Objectifs hebdomadaires et mensuels',
  'goals.periodTemplate.help': 'Crée un template depuis une semaine ou un mois déjà renseigné, puis charge-le sur une période actuelle ou future.',
  'goals.periodTemplate.weeklyTitle': 'Template hebdomadaire',
  'goals.periodTemplate.monthlyTitle': 'Template mensuel',
  'goals.periodTemplate.savedCount': '{count} objectif(s) enregistré(s)',
  'goals.periodTemplate.sourceWeek': 'Semaine source',
  'goals.periodTemplate.targetWeek': 'Semaine cible',
  'goals.periodTemplate.sourceMonth': 'Mois source',
  'goals.periodTemplate.targetMonth': 'Mois cible',
  'goals.periodTemplate.createFromPeriod': 'Créer depuis cette période',
  'goals.periodTemplate.load': 'Charger le template',
  'goals.periodTemplate.empty': 'Aucun template enregistré.',
  'goals.periodTemplate.saved': 'Template créé depuis {period} avec {count} objectif(s).',
  'goals.periodTemplate.applied': 'Template chargé sur {period} avec {count} objectif(s).',
  'goals.periodTemplate.confirmQuestion': 'Charger ce template sur {period} ?',
  'goals.periodTemplate.confirmHelp': 'Les objectifs de même période seront remplacés par le snapshot du template. Les périodes historiques restent protégées.',
  'goals.periodTemplate.confirmLoad': 'Charger sur cette période',
  'goals.weekday.monday': 'Lundi',
  'goals.weekday.tuesday': 'Mardi',
  'goals.weekday.wednesday': 'Mercredi',
  'goals.weekday.thursday': 'Jeudi',
  'goals.weekday.friday': 'Vendredi',
  'goals.weekday.saturday': 'Samedi',
  'goals.weekday.sunday': 'Dimanche',
  'goals.dialog.addEyebrow': 'AJOUT',
  'goals.dialog.editEyebrow': 'MODIFICATION',
  'goals.dialog.close': 'Fermer',
  'goals.dialog.addTypeAria': 'Type d’ajout',
  'goals.dialog.existing': 'Existant',
  'goals.dialog.newManual': 'Nouveau manuel',
  'goals.dialog.newAutomatic': 'Nouveau automatique',
  'goals.dialog.fromShorterGoal': 'Depuis un objectif plus court',
  'goals.dialog.dailyResults': 'Résultat des objectifs quotidiens',
  'goals.dialog.sourceGoal': 'Objectif source',
  'goals.dialog.sameNameByDefault': 'Même nom par défaut',
  'goals.dialog.derivedAggregationHint': 'Les valeurs sont additionnées ; les pourcentages sont moyennés.',
  'goals.dialog.dailyResultsHelp': 'Moyenne du score global des objectifs quotidiens sur la période.',
  'goals.dialog.derivedSourceLocked': 'La période et la source sont verrouillées pour conserver la cohérence de la dérivation.',
  'goals.dialog.chooseGoalTarget': 'Choisis un objectif et une cible.',
  'goals.dialog.selectedUnavailable': 'L’objectif sélectionné n’est plus disponible.',
  'goals.dialog.nameRequired': 'Donne un nom à l’objectif.',
  'goals.dialog.definitionMissing': 'Cet objectif n’est plus disponible.',
  'goals.dialog.goal': 'Objectif',
  'goals.dialog.name': 'Nom',
  'goals.dialog.target': 'Cible',
  'goals.dialog.period': 'Période',
  'goals.period.daily': 'Quotidien',
  'goals.period.weekly': 'Hebdomadaire',
  'goals.period.monthly': 'Mensuel',
  'goals.period.quarterly': 'Trimestriel',
  'goals.period.yearly': 'Annuel',
  'goals.period.activeGoals': 'Objectifs de période',
  'goals.period.progress': 'Progression sur la période',
  'goals.period.lastDay': 'Dernier jour',
  'goals.period.daysRemaining': '{count} jours restants',
  'goals.period.tabsAria': 'Périodes des objectifs',
  'goals.period.addTab': 'Ajouter une période',
  'goals.period.empty': 'Aucun objectif pour cette période',
  'goals.period.emptyHelp': 'Ajoute un objectif pour commencer à suivre cette période.',
  'goals.period.addForPeriod': 'Ajouter un objectif — {period}',
  'goals.dialog.description': 'Description',
  'goals.dialog.optional': 'facultatif',
  'goals.dialog.unit': 'Unité',
  'goals.dialog.quantity': 'Quantité',
  'goals.dialog.duration': 'Durée',
  'goals.dialog.distance': 'Distance',
  'goals.dialog.yesNo': 'Oui / non',
  'goals.dialog.percentage': 'Pourcentage',
  'goals.dialog.unitLabel': 'Libellé de l’unité',
  'goals.dialog.loadingSources': 'Chargement des sources…',
  'goals.dialog.source': 'Source',
  'goals.dialog.tasks': 'Tâches',
  'goals.dialog.routines': 'Routines',
  'goals.dialog.activities': 'Activités',
  'goals.dialog.highlight': 'Highlight',
  'goals.dialog.highlightMetric': 'Mesure du Highlight',
  'goals.dialog.highlightDefined': 'Highlight défini',
  'goals.dialog.highlightCompleted': 'Highlight réalisé',
  'goals.dialog.calculation': 'Calcul',
  'goals.dialog.countCompleted': 'Nombre réalisé',
  'goals.dialog.sumRoutineQuantity': 'Somme des quantités de routines',
  'goals.dialog.sumRoutineTime': 'Temps mesuré',
  'goals.dialog.linkMeasuredRoutine': 'Alimenter automatiquement cet objectif depuis une routine mesurée',
  'goals.dialog.sourceUnit': 'unité de la routine',
  'goals.dialog.quantifiedRoutineRequired': 'Sélectionne au moins une routine quantifiée.',
  'goals.dialog.sameRoutineUnitRequired': 'Les routines sélectionnées doivent utiliser la même unité.',
  'goals.dialog.completionPercent': '% réalisé / prévu',
  'goals.dialog.atLeastOne': 'Au moins une réalisée',
  'goals.dialog.scope': 'Périmètre',
  'goals.dialog.allOccurrences': 'Toutes les occurrences',
  'goals.dialog.oneTaskType': 'Un type de tâche',
  'goals.dialog.selectedTasks': 'Des tâches sélectionnées',
  'goals.dialog.oneList': 'Une liste',
  'goals.dialog.type': 'Type',
  'goals.dialog.recurrent': 'Récurrentes',
  'goals.dialog.list': 'Liste',
  'goals.dialog.tasksIncluded': 'Tâches prises en compte',
  'goals.dialog.allRoutines': 'Toutes les routines',
  'goals.dialog.selectedRoutines': 'Des routines sélectionnées',
  'goals.dialog.routinesIncluded': 'Routines prises en compte',
  'goals.dialog.creating': 'Création…',
  'goals.dialog.createAdd': 'Créer et ajouter',
  'goals.dialog.editTitle': 'Modifier l’objectif',
  'goals.dialog.editLoading': 'Chargement de l’objectif…',
  'goals.dialog.automatic': 'Automatique',
  'goals.dialog.manual': 'Manuel',
  'goals.dialog.mode': 'Mode de collecte',
  'goals.dialog.historyPreserved': 'Les changements s’appliquent aux futures périodes ; l’historique existant est conservé.',
  'goals.dialog.historyLocked': 'L’unité et le type de calcul sont verrouillés car cet objectif possède déjà un historique.',
  'goals.dialog.saveChanges': 'Enregistrer les modifications',
  'goals.dialog.chooseTaskList': 'Choisis une liste Tasks.',
  'goals.dialog.selectTask': 'Sélectionne au moins une tâche.',
  'goals.dialog.selectRoutine': 'Sélectionne au moins une routine.',
  'goals.dialog.selectActivity': 'Sélectionne au moins une activité.',
  'goals.dialog.activitiesIncluded': 'Activités incluses',
  'goals.dialog.unitLocked': 'L’unité ne peut plus être modifiée car cet objectif possède déjà un historique.',
  'goals.dialog.invalidSourceConfig': 'La configuration de la source est incompatible avec le calcul choisi.',
  'goals.dialog.createFailed': 'L’objectif n’a pas pu être créé.',
  'goals.dialog.editFailed': 'L’objectif n’a pas pu être modifié.',
  'shared.confirm.title': 'Confirmation',
  'shared.confirm.confirm': 'Confirmer',
  'shared.confirm.cancel': 'Annuler',
  'shared.state.retry': 'Réessayer'
} as const;

export type TranslationKey = keyof typeof FR_TRANSLATIONS;
export type TranslationParams = Record<string, string | number>;

export const EN_TRANSLATION_OVERRIDES: Partial<Record<TranslationKey, string>> = {
  'notes.links.categoriesTitle': 'Linked note categories',
  'notes.links.categoriesHelp': 'Notes in these categories are available from this item.',
  'notes.links.categoryEmpty': 'No linked categories.',
  'notes.links.categoriesLoading': 'Loading categories…',
  'notes.links.chooseCategory': 'Choose a category',
  'notes.links.chooseCategoryPlaceholder': 'Select a category…',
  'notes.links.link': 'Link',
  'notes.links.remove': 'Remove',
  'notes.links.notesTitle': 'Linked notes',
  'notes.links.notesEmpty': 'No linked notes.',
  'notes.links.notesLoading': 'Loading notes…',
  'notes.links.chooseNote': 'Choose a note',
  'notes.links.chooseNotePlaceholder': 'Select an existing note…',
  'notes.links.newNotePlaceholder': 'New linked note',
  'notes.links.create': 'Create',
  'notes.links.categoryUpdateError': 'Could not update the category.',
  'notes.links.categoryLoadError': 'Could not load categories.',
  'notes.links.noteUpdateError': 'Could not update the link.',
  'notes.links.noteLoadError': 'Could not load notes.',
  'tasks.recurrent.defaultPeriod': 'Default time slot',
  'today.noteCategory': 'Category',
  'today.noteLinksLoadError': 'Note links are unavailable.',
  'culture.xlsxExport': "Export Excel",
  'culture.xlsxImport': "Import Excel",
  'culture.xlsxInvalid': "Invalid XLSX file or incompatible LifeOps Culture format.",
  'culture.xlsxExportError': "Could not export Culture data.",
  'culture.xlsxImportError': "Could not import the Culture workbook. Check the sheets and references.",
  'culture.xlsxImportResult': "Import summary",
  'culture.xlsxItems': "works",
  'culture.xlsxSeasons': "seasons",
  'culture.xlsxHistory': "consumptions",
  'culture.xlsxLists': "lists",
  'culture.xlsxLinks': "references",
  'culture.xlsxSkipped': "already present",
  'culture.xlsxPreview': "Workbook contents",
  'culture.xlsxImportHint': "Existing items are reused where possible. Dates, types, references and statuses must match the LifeOps schema.",
  'culture.xlsxConfirmImport': "Confirm import",
  'culture.syncAllRaindrop': "Sync all Raindrop bookmarks",
  'culture.dailyChoose': "Choose today's reading",
  'culture.dailySelected': "Bookmarks selected for this day",
  'culture.dailyUnassigned': "No time slot",
  'culture.dailySlot': "Reading time slot",
  'culture.dailyRandomCount': "Number to pick",
  'culture.dailyRandom': "Pick randomly",
  'culture.dailyManualHint': "Select articles manually or pick randomly. Weekday tags are ignored.",
  'culture.dailyEmpty': "No unfinished Raindrop bookmarks available.",
  'culture.dailySelectionError': "Could not save the selection or its time slot. Try again.",

  'culture.backToCulture': "Back to Media Library",
  'culture.addExisting': "Add existing item",
  'culture.createItem': "Create new item",
  'culture.filterStatus': "Filter by status",
  'culture.statusLabel': "Status",
  'culture.status.ALL': "All",
  'culture.status.NOT_STARTED': "Not started",
  'culture.status.IN_PROGRESS': "In progress",
  'culture.status.DONE': "Finished",
  'culture.cultureLists': "Media library lists",
  'culture.cultureList': "Media library content list",
  'culture.raindropConfigMissing': "Raindrop OAuth is not configured: set the local function secrets (see documentation).",
  'culture.raindropKeyInvalid': "Invalid Raindrop encryption key: use a base64-encoded AES-256 key.",
  'culture.raindropFunctionUnavailable': "Raindrop Supabase function is unavailable: start the local Edge Functions.",
  'culture.configureType': "Edit type",
  'culture.fieldIdentifier': "Field identifier",
  'culture.fieldText': "Text",
  'culture.fieldNumber': "Number",
  'culture.fieldDate': "Date",
  'culture.fieldBoolean': "Yes / No",
  'culture.connectRaindrop': "Connect Raindrop account",
  'culture.raindropConnected': "Raindrop account connected",
  'culture.disconnectRaindrop': "Disconnect Raindrop",
  'culture.raindropAuthError': "Unable to connect Raindrop. Check OAuth configuration.",
  'culture.tagFilter': "Tag to sync",
  'culture.filterBookmarksByTag': "Filter bookmarks by tag",
  'culture.allBookmarkTags': "All tags",
  'culture.noBookmarksWithTag': "No bookmarks match this tag.",
  'culture.addType': "Create type",
  'culture.lists': "Lists",
  'culture.listName': "List name",
  'culture.createList': "Create list",
  'culture.addField': "Add field",
  'culture.fieldLabel': "Field name",
  'culture.consumed': "Consumed",
  'culture.confirmDeleteBookmark': "Delete this bookmark?",
  'culture.removeFromList': "Remove from list",
  'culture.plans': "Planning",
  'culture.planPool': "Schedule a pool",
  'culture.planBookmark': "Schedule bookmark",
  'culture.targetCount': "Target items",
  'culture.date': "Date",
  'culture.emptyPlans': "Nothing scheduled.",
  'culture.poolBookmarks': "Pool contents",
  'culture.poolHelp': "Select a list above and mark consumed items as Done.",
  'culture.edit': "Edit",
  'culture.delete': "Delete",
  'culture.confirmDelete': "Delete this work and its history?",
  'culture.addSeason': "Add season",
  'culture.author': "Author",
  'culture.category': "Category",
  'culture.theme': "Theme",
  'culture.year': "Year",
  'culture.language': "Language",
  'culture.pages': "Pages",
  'culture.releaseDate': "Release date",
  'culture.director': "Director",
  'culture.genre': "Genre",
  'culture.country': "Country",
  'culture.seasonNumber': "Season number",
  'culture.episodeCount': "Episode count",
  'culture.addToList': "Add to list",
  'culture.chooseList': "Choose a list",
  'culture.syncRaindrop': "Sync Raindrop",
  'culture.syncHelp': "Use your Raindrop test token temporarily. LifeOps does not store this token.",
  'culture.token': "Raindrop token",
  'culture.sync': "Synchronize",
  'culture.syncing': "Synchronizing…",
  'culture.syncSuccess': "Bookmarks processed",
  'culture.syncFailed': "Raindrop synchronization failed.",
  'culture.chooseTag': "Choose a tag",
  'culture.completeBookmark': "Complete",
  'culture.reopenBookmark': "Mark as unread",
  'culture.showCompleted': 'Show completed',
  'culture.pickRandom': 'Pick randomly',
  'culture.scheduleSelected': 'Schedule selection',
  'culture.selectBookmark': 'Select this bookmark',
  'culture.selectAllFilteredRaindrops': 'Select all filtered Raindrops',
  'culture.deselectAllFilteredRaindrops': 'Deselect filtered Raindrops',
  'culture.deleteAllSelectedRaindrops': 'Delete all selected',
  'culture.deleteRaindrop': 'Delete this Raindrop from LifeOps',
  'culture.confirmDeleteRaindrops': 'Permanently delete these Raindrops from LifeOps?',
  'culture.raindropLocalDeleteHint': 'Bookmarks remain on Raindrop.io. A future sync may import them again.',
  'culture.raindropDeleteFailed': 'Deletion failed or was partial. The list has been reloaded: check remaining bookmarks.',
  'culture.xlsxImportMode': 'Import mode',
  'culture.xlsxImportFree': 'Free import',
  'culture.xlsxImportList': 'Import into a list',
  'culture.xlsxChooseList': 'Choose a list',
  'culture.xlsxNewList': 'Create a list',
  'culture.hideCompleted': 'Hide completed',
  'culture.raindropStatusFailed': "Status synchronization failed. Check Raindrop and retry; LifeOps has not confirmed the change.",
  'culture.homeDescription': 'Track books, movies, series and articles.',
  'culture.title': "Media Library",
  'culture.add': "Add",
  'culture.works': "Works",
  'culture.history': "History",
  'culture.bookmarks': "Web bookmarks",
  'culture.loading': "Loading…",
  'culture.loadError': "Unable to load data.",
  'culture.saveError': "Unable to save.",
  'culture.emptyWorks': "No works saved.",
  'culture.emptyHistory': "No consumption history.",
  'culture.emptyBookmarks': "No bookmarks saved.",
  'culture.type': "Type",
  'culture.book': "Book",
  'culture.movie': "Movie",
  'culture.series': "Series",
  'culture.podcast': "Podcast episode",
  'culture.name': "Title",
  'culture.choose': "Choose a work",
  'culture.startDate': "Start date",
  'culture.endDate': "End date",
  'culture.rating': "Rating out of 10",
  'culture.comment': "Comment",
  'culture.article': "Article",
  'culture.video': "Video",
  'culture.other': "Other",
  'culture.backlog': "Backlog",
  'culture.planned': "Planned",
  'culture.done': "Done",
  'culture.cancel': "Cancel",
  'culture.saving': "Saving…",
  'culture.save': "Save",
  'mealsV2.addRecipeToSession': 'Add recipe',
  'mealsV2.addPreparedDish': 'Add preparation',
  'mealsV2.addFoodToConsumption': 'Add food',
  'mealsV2.viewDetails': 'View details',
  'mealsV2.consumptionDetails': 'Consumption details',
  'mealsV2.editConsumption': 'Edit consumption',
  'mealsV2.nutritionEstimate': 'Estimated nutritional intake',
  'mealsV2.macros': 'Macronutrients',
  'mealsV2.unknownNutrition': 'Not available',
  'mealsV2.portionPlural': 'portions',
  'mealsV2.noConsumption': 'No meals logged',
  'mealsV2.noLinesAvailable': 'This consumption cannot be edited because its original preparation is no longer available.',
  'mealsV2.sourceSnapshot': 'Values saved when the meal was logged',
  'mealsV2.addMeal': 'Log a meal',
  'mealsV2.uncook': 'Mark as not cooked',
  'mealsV2.editSession': 'Edit dishes and ingredients',
  'mealsV2.shoppingResult': '{added} item(s) added · {skipped} already on list',
  'mealsV2.saving': 'Saving…',
  'mealsV2.addIngredientInRecipe': 'Create ingredient',
  'mealsV2.unitPiece': 'Item',
  'mealsV2.unitFree': 'Unspecified',
  'mealsV2.title': 'Meals',
  'mealsV2.ingredients': 'Ingredients',
  'mealsV2.recipes': 'Recipes',
  'mealsV2.consumed': 'Consumed meals',
  'mealsV2.shopping': 'Shopping list',
  'mealsV2.name': 'Name',
  'mealsV2.unit': 'Reference unit',
  'mealsV2.kcal': 'Calories',
  'mealsV2.protein': 'Protein',
  'mealsV2.carbs': 'Carbs',
  'mealsV2.fat': 'Fat',
  'mealsV2.newIngredient': 'New ingredient',
  'mealsV2.newRecipe': 'New recipe',
  'mealsV2.instructions': 'Instructions',
  'mealsV2.servings': 'Recipe servings',
  'mealsV2.quantity': 'Quantity',
  'mealsV2.addLine': 'Add ingredient',
  'mealsV2.add': 'Add',
  'mealsV2.save': 'Save',
  'mealsV2.cancel': 'Cancel',
  'mealsV2.edit': 'Edit',
  'mealsV2.delete': 'Delete',
  'mealsV2.date': 'Date',
  'mealsV2.portion': 'Servings eaten',
  'mealsV2.log': 'Log meal',
  'mealsV2.choose': 'Choose',
  'mealsV2.list': 'List',
  'mealsV2.toList': 'Add selected ingredients',
  'mealsV2.selectAll': 'Select all',
  'mealsV2.empty': 'No data yet.',
  'mealsV2.confirm': 'Confirm deletion?',
  'mealsV2.error': 'Operation failed.',
  'mealsV2.nutrition': 'Estimated recipe nutrition',
  'mealsV2.g': 'g',
  'mealsV2.perUnit': 'Values per reference unit (g, ml, or item)',
  'mealsV2.shoppingHelp': 'Select needed ingredients and add them to an existing list.',
  'mealsV2.day': 'Planned day',
  'mealsV2.session': 'Cooking session',
  'mealsV2.newSession': 'New cooking session',
  'mealsV2.cooked': 'Cooked',
  'mealsV2.markCooked': 'Mark as cooked',
  'mealsV2.produced': 'Actual portions produced',
  'mealsV2.theoretical': 'Theoretical recipes',
  'mealsV2.realIngredients': 'Actual composition (editable)',
  'mealsV2.addFood': 'Add food',
  'mealsV2.consumeReal': 'Actual consumption',
  'mealsV2.cookedPreparation': 'Cooked preparation',
  'mealsV2.singleFood': 'Individual food',
  'mealsV2.portionUnit': 'Portion',
  'mealsV2.fractionUnit': 'Fraction of entire dish',
  'mealsV2.nutritionBasis': 'Nutrition reference basis',
  'mealsV2.optionalNutrition': 'Nutrition information is optional. Leave blank if unknown.',
  'mealsV2.onePortion': 'Reference recipe for one portion.',
  'mealsV2.partial': 'Partial estimate',
  'mealsV2.recipeSelect': 'Choose recipe',
  'mealsV2.addPreparation': 'Add preparation',
  'mealsV2.addSingleFood': 'Add food',
  'today.title': 'Today',
  'calendar.title': 'Calendar',
  'product.today': 'Today',
  'product.todo': 'To Do',
  'product.highlight': 'Highlight',
  'product.template': 'Template',
  'common.actions.add': 'Add',
  'common.actions.archive': 'Archive',
  'common.actions.back': 'Back',
  'common.actions.cancel': 'Cancel',
  'common.actions.close': 'Close',
  'common.actions.create': 'Create',
  'common.actions.delete': 'Delete',
  'common.actions.deleteForever': 'Delete permanently',
  'common.actions.edit': 'Edit',
  'common.actions.open': 'Open',
  'common.actions.remove': 'Remove',
  'common.actions.rename': 'Rename',
  'common.actions.reopen': 'Reopen',
  'common.actions.retry': 'Retry',
  'common.actions.save': 'Save',
  'common.actions.link': 'Link',
  'common.actions.choose': 'Choose…',
  'common.actions.up': 'Move up',
  'common.actions.down': 'Move down',
  'common.loading': 'Loading…',
  'common.saving': 'Saving…',
  'common.deleting': 'Deleting…',
  'common.none': 'None',
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.history': 'History',
  'common.title': 'Title',
  'common.description': 'Description',
  'common.priority': 'Priority',
  'common.actionsLabel': 'Actions',
  'common.actionFailed': 'The action could not be saved. Try again.',
  'product.tasks': 'Tasks',
  'product.calendar': 'Calendar',
  'product.goals': 'Goals',
  'product.lists': 'Lists',
  'product.domains': 'Domains',
  'product.measurements': 'Measurements',
  'navigation.overview': 'Overview',

  'product.notes': 'Notes',
  'product.activities': 'Activities',
  'product.sport': 'Sport',
  'product.routines': 'Routines',
  'product.settings': 'Settings',
  'product.meals': 'Meals',
  'app.homeAria': 'LifeOps home',
  'app.backHomeAria': 'Back to home',
  'app.signOut': 'Sign out',
  'app.signIn': 'Sign in',
  'app.settings': 'Settings',
  'navigation.main': 'Main navigation',
  'navigation.open': 'Open navigation',
  'navigation.close': 'Close navigation',
  'navigation.activeTimer.one': '{count} active timer',
  'navigation.activeTimer.many': '{count} active timers',
  'navigation.backTo': 'Back to {destination}',
  'navigation.destination.home': 'Home',
  'navigation.destination.previousPage': 'previous page',
  'auth.login.title': 'Sign in to LifeOps',
  'auth.login.subtitle': 'Sign in with your email address and password.',
  'auth.password': 'Password',
  'auth.emailRequired': 'Email is required.',
  'auth.emailInvalid': 'Enter a valid email address.',
  'auth.login.loading': 'Signing in…',
  'auth.login.submit': 'Sign in',
  'auth.login.createAccount': 'Create an account',
  'auth.login.accountDeleted': 'Your LifeOps account and all its data have been permanently deleted.',
  'auth.login.forgotPassword': 'Forgot password?',
  'auth.recovery.requestTitle': 'Reset your password',
  'auth.recovery.requestSubtitle': 'Enter your email address. If an account matches, you will receive a link to choose a new password.',
  'auth.recovery.requestSubmit': 'Send reset link',
  'auth.recovery.requestLoading': 'Sending…',
  'auth.recovery.requestSuccess': 'If an account matches this address, a password recovery email has been sent.',
  'auth.recovery.backToLogin': 'Back to sign in',
  'auth.recovery.updateTitle': 'Choose a new password',
  'auth.recovery.updateSubtitle': 'Choose a new password for your LifeOps account.',
  'auth.recovery.checkingLink': 'Checking the recovery link…',
  'auth.recovery.invalidTitle': 'Invalid recovery link',
  'auth.recovery.invalidLink': 'This link is invalid, expired, or has already been used. Request a new recovery link.',
  'auth.recovery.requestAnother': 'Request a new link',
  'auth.recovery.newPassword': 'New password',
  'auth.recovery.confirmPassword': 'Confirm new password',
  'auth.recovery.updateSubmit': 'Save new password',
  'auth.recovery.updateLoading': 'Saving…',
  'auth.recovery.updateError': 'The password could not be updated. Request a new link if the problem continues.',
  'auth.signup.title': 'Create a LifeOps account',
  'auth.signup.subtitle': 'Each account has its own private data.',
  'auth.signup.name': 'Name',
  'auth.signup.language': 'Language',
  'auth.signup.languageHelp': 'This language will be used for the interface and the initial Calendar axis names.',
  'auth.signup.confirmPassword': 'Confirm password',
  'auth.signup.loading': 'Creating…',
  'auth.signup.submit': 'Create my account',
  'auth.signup.enableHint': 'To enable “Create my account”:',
  'auth.signup.nameRequired': 'enter your name.',
  'auth.signup.nameLength': 'the name must contain between 2 and 80 characters.',
  'auth.signup.emailRequired': 'enter your email address.',
  'auth.signup.emailInvalid': 'enter a valid email address.',
  'auth.signup.passwordRequired': 'enter a password.',
  'auth.signup.passwordLength': 'use at least 10 characters for the password.',
  'auth.signup.confirmRequired': 'confirm your password.',
  'auth.signup.passwordsMatch': 'both passwords must match.',
  'auth.signup.haveAccount': 'I already have an account',
  'auth.signup.errorNameLength': 'The name must contain between 2 and 80 characters.',
  'auth.signup.errorPasswordLength': 'The password must contain at least 10 characters.',
  'auth.signup.errorPasswordsMismatch': 'The passwords do not match.',
  'auth.signup.successConfirmEmail': 'Account created. Check your email to confirm your registration.',
  'auth.error.invalidCredentials': 'Incorrect email or password.',
  'auth.error.emailRegistered': 'An account already exists with this email address.',
  'auth.error.weakPassword': 'The password does not meet the security requirements.',
  'auth.error.network': 'LifeOps cannot be reached. Check your internet connection and try again.',
  'auth.error.serviceUnavailable': 'The service is temporarily unavailable. Try again in a few moments.',
  'auth.error.rateLimit': 'Too many requests have been made. Try again in a few moments.',
  'auth.error.signIn': 'Sign-in failed. Try again.',
  'auth.error.signUp': 'Account creation failed. Try again.',
  'home.personalSpace': 'Your personal space',
  'home.intro': 'Your everyday spaces brought together in one clear navigation, with no hierarchy between domains.',
  'home.spacesAria': 'The eight LifeOps spaces',
  'home.connectedSpaces': '8 connected spaces',
  'home.oneVision': 'One view',
  'home.yourSpaces': 'Your spaces',
  'home.whereStart': 'Where do you want to start?',
  'home.chooseSpace': 'Choose a space to move from intention to action.',
  'home.todayDescription': 'See everything that matters for your day.',
  'home.todayAction': 'Open my day',
  'home.tasksDescription': 'Create, schedule and complete your actions.',
  'home.explore': 'Explore',
  'home.calendarDescription': 'Plan and browse your weeks.',
  'home.plan': 'Plan',
  'home.goalsDescription': 'Set your goals and track your progress.',
  'home.notesDescription': 'Keep your personal notes in a dedicated space.',
  'home.activitiesDescription': 'Access your activities and time tracking.',
  'home.sportDescription': 'Create your sports, plan sessions, and record real results.',
  'home.listsDescription': 'Manage permanent lists independently from tasks.',
  'home.domainsDescription': 'Manage your domains and their properties.',
  'domains.subtitle': 'Group your LifeOps items by major areas of life.',
  'domains.namePlaceholder': 'E.g. Sport, Work, Culture…',
  'domains.color': 'Domain color',
  'domains.palettePreview': '5-tone preview',
  'domains.color.blue': 'Blue',
  'domains.color.red': 'Red',
  'domains.color.orange': 'Orange',
  'domains.color.green': 'Green',
  'domains.color.purple': 'Purple',
  'domains.color.teal': 'Teal',
  'domains.color.pink': 'Pink',
  'domains.color.gray': 'Gray',
  'domains.showArchived': 'Show archived domains',
  'domains.createAction': 'Create domain',
  'domains.editAction': 'Edit domain',
  'domains.openDomain': 'Open domain',
  'domains.empty': 'No domains yet.',
  'domains.assignment': 'Domain',
  'domains.loadError': 'Unable to load domains.',
  'domains.deleteConfirm': 'Delete “{name}”? Linked items will be kept without a domain.',
  'domains.shortcutsTitle': 'My domains',
  'domains.homeFilter': 'Filter by domain',
  'domains.allDomains': 'All domains',
  'domains.entryHelp': 'Choose a module to open it filtered to this domain.',
  'domains.filteredModule': 'Show only items from {name}.',
  'domains.notFound': 'This domain could not be found.',
  'domains.hideShortcut': 'Hide shortcut',
  'domains.showShortcut': 'Show shortcut',
  'home.progress': 'View my progress',
  'notes.navigationPlaceholder': 'Notes is now available from the main navigation. Full note management will be delivered separately.',
  'activities.navigationPlaceholder': 'Activities is now available from the main navigation. Full activity management will be delivered separately.',
  'activities.eyebrow': 'Time tracking',
  'activities.subtitle': 'Plan activities in Calendar and measure the time actually spent here.',
  'activities.backToTasks': 'Back to tasks',
  'activities.taskSessionSource': 'This session belongs to a task and remains separate from Activities.',
  'activities.quickCreateTitle': 'Quick create',
  'activities.quickCreateHelp': 'A name is enough. The same activity can be planned several times and tracked whenever needed.',
  'activities.nameLabel': 'Activity name',
  'activities.namePlaceholder': 'e.g. Reading',
  'activities.create': 'Create activity',
  'activities.loading': 'Loading activities and timers…',
  'activities.loadError': 'Activities or time tracking could not be loaded. Try again in a moment.',
  'activities.activeTitle': 'Active activities',
  'activities.activeHelp': 'Activities available for Calendar planning and new timers.',
  'activities.empty': 'No active activity yet. Create one here or from Calendar.',
  'activities.reusable': 'Reusable activity',
  'activities.archived': 'Archived activity',
  'activities.showArchived': 'Show archived activities ({count})',
  'activities.restore': 'Restore',
  'activities.archiveAria': 'Archive {name}',
  'activities.restoreAria': 'Restore {name}',
  'activities.archiveConfirmTitle': 'Archive this activity?',
  'activities.archiveConfirmMessage': 'Archive “{name}”? Its history and timers are kept. An already running timer will not be stopped.',
  'activities.activeTimersTitle': 'Active timers',
  'activities.activeTimersHelp': 'Several timers may run at the same time. Durations are cumulative.',
  'activities.startTimer': 'Start',
  'activities.startTimerAria': 'Start a timer for {name}',
  'activities.stopTimer': 'Stop',
  'activities.cancelTimer': 'Cancel timer',
  'activities.cancelTimerConfirmTitle': 'Cancel this timer?',
  'activities.cancelTimerConfirmMessage': 'This active timer will be deleted without creating a historical session.',
  'activities.elapsedTime': 'Elapsed time',
  'activities.longTimerWarning': 'Timer active for more than 12 hours — check its start time.',
  'activities.runningCount': '{count} running',
  'activities.today': 'Today',
  'activities.week': 'This week',
  'activities.totalsAria': 'Cumulative time for {name}',
  'activities.unknownActivity': 'Activity',
  'activities.historyTitle': 'Sessions',
  'activities.historyHelp': 'Review and correct tracked time, one day at a time.',
  'activities.historyDate': 'History date',
  'activities.previousDay': 'Previous day',
  'activities.nextDay': 'Next day',
  'activities.historyEmpty': 'No completed session for this date.',
  'activities.sessionEditorEyebrow': 'SESSION',
  'activities.sessionTimezone': 'Historical timezone: {timezone}',
  'activities.sessionStart': 'Start',
  'activities.sessionEnd': 'End',
  'activities.activeSessionEndHelp': 'Leave empty to keep the timer running.',
  'activities.sessionNote': 'Comment',
  'activities.sessionNotePlaceholder': 'e.g. Focused work, chapter read…',
  'activities.tags': 'Tags',
  'activities.chooseExistingTag': 'Add an existing tag…',
  'activities.newTagPlaceholder': 'New tag',
  'activities.createTag': 'Create tag',
  'activities.removeTagAria': 'Remove tag {name}',
  'activities.now': 'now',
  'activities.deleteSessionConfirmTitle': 'Delete this session?',
  'activities.deleteSessionConfirmMessage': 'The session and its tag links will be permanently deleted.',
  'tasks.time.sectionAria': 'Time tracking for {title}',
  'tasks.time.start': 'Timer',
  'tasks.time.openActivities': 'Open Activities',
  'tasks.time.startAria': 'Start a timer for {title}',
  'tasks.time.history': 'Tracked time',
  'tasks.time.cancelTimerTitle': 'Cancel this timer?',
  'tasks.time.cancelTimerMessage': 'The active timer for “{title}” will be deleted without creating a historical session.',
  'tasks.time.activeOnClose': '{count} active timer(s) are linked to this task. Choose explicitly what to do with them.',
  'tasks.time.completeKeepRunning': 'Complete and keep running',
  'tasks.time.completeAndStop': 'Complete and stop',
  'tasks.time.cancelKeepRunning': 'Cancel task and keep running',
  'tasks.time.cancelAndStop': 'Cancel task and stop',
  'tasks.time.changeStatusKeepRunning': 'Change status and keep running',
  'tasks.time.changeStatusAndStop': 'Change status and stop',
  'tasks.time.statusDecisionTitle': 'What should happen to the active timer?',
  'tasks.time.editInActivities': 'Sessions can be corrected from the Activities history.',
  'tasks.time.deleteKeepsHistory': 'This task has tracked time: it will be removed from Tasks, while its time history is preserved.',
  'tasks.time.taskSession': 'Task session',
  'settings.title': 'Settings',
  'settings.raindrop.title': "Raindrop",
  'settings.raindrop.description': "Manage your Raindrop account connection to LifeOps.",
  'settings.raindrop.connected': "Raindrop account connected",
  'settings.raindrop.notConnected': "Raindrop account not connected",
  'settings.raindrop.unknown': "Connection status unavailable",
  'settings.raindrop.connect': "Connect Raindrop",
  'settings.raindrop.disconnect': "Disconnect Raindrop",
  'settings.raindrop.retry': "Try again",
  'settings.raindrop.confirmTitle': "Disconnect Raindrop?",
  'settings.raindrop.confirmHelp': "LifeOps will no longer sync your bookmarks until you reconnect. Bookmarks and history already saved in LifeOps will be preserved.",
  'settings.raindrop.confirm': "Confirm disconnection",
  'settings.raindrop.disconnecting': "Disconnecting…",
  'settings.raindrop.disconnected': "Raindrop has been disconnected. You can reconnect at any time.",
  'settings.raindrop.loadError': "Unable to check the Raindrop connection. Please try again.",
  'settings.raindrop.connectError': "Unable to start Raindrop sign-in. Please try again.",
  'settings.raindrop.disconnectError': "Unable to disconnect Raindrop. The connection has been kept.",
  'settings.profile.title': 'Profile',
  'settings.profile.description': 'Change the name displayed in LifeOps. Your email remains linked to your account and cannot be changed here.',
  'settings.profile.email': 'Email',
  'settings.profile.emailReadonly': 'The email address is read-only.',
  'settings.profile.username': 'Display name',
  'settings.profile.usernameHelp': 'Between 2 and 80 characters. Leading and trailing spaces are removed.',
  'settings.profile.save': 'Save profile',
  'settings.profile.saving': 'Saving…',
  'settings.profile.saved': 'Profile saved.',
  'settings.profile.invalidUsername': 'The display name must contain between 2 and 80 characters after leading and trailing spaces are removed.',
  'settings.profile.loadError': 'Your profile could not be loaded. Try again.',
  'settings.profile.error': 'The profile could not be saved. Try again.',
  'settings.deleteAccount.title': 'Danger zone',
  'settings.deleteAccount.description': 'Account deletion is permanent and removes all your LifeOps data.',
  'settings.deleteAccount.open': 'Delete account',
  'settings.deleteAccount.eyebrow': 'PERMANENT DELETION',
  'settings.deleteAccount.confirmTitle': 'Permanently delete your account?',
  'settings.deleteAccount.irreversible': 'This action is irreversible. You will not be able to recover your account after deletion.',
  'settings.deleteAccount.deleteProfile': 'Your LifeOps profile will be deleted.',
  'settings.deleteAccount.deleteData': 'All your tasks, lists, notes, activities, calendars, goals and other data will be deleted.',
  'settings.deleteAccount.deleteHistory': 'Your preferences, history and templates will be deleted.',
  'settings.deleteAccount.loseAccess': 'All your sessions will be revoked and your old credentials will no longer sign you in.',
  'settings.deleteAccount.exportOffer': 'You can download a JSON backup before deleting the account. This export is optional.',
  'settings.deleteAccount.exportNow': 'Export my data before deletion',
  'settings.deleteAccount.confirmationLabel': 'To confirm, type this exact phrase:',
  'settings.deleteAccount.passwordLabel': 'Current password',
  'settings.deleteAccount.finalWarning': 'By confirming, your existing data will be permanently deleted. This action cannot be undone.',
  'settings.deleteAccount.confirm': 'Delete permanently',
  'settings.deleteAccount.deleting': 'Deleting…',
  'settings.deleteAccount.invalidPassword': 'The password is incorrect.',
  'settings.deleteAccount.confirmationMismatch': 'The confirmation phrase does not match exactly.',
  'settings.deleteAccount.confirmationMismatchHint': 'The phrase must exactly match “SUPPRIMER MON COMPTE”. Leading and trailing spaces are ignored.',
  'settings.deleteAccount.reauthExpired': 'Reauthentication expired. Enter your password again.',
  'settings.deleteAccount.error': 'Account deletion failed. The account is not considered deleted.',

  'settings.subtitle': 'Customise your LifeOps experience.',
  'settings.backHome': '← Home',
  'settings.language.title': 'Language',
  'settings.language.description': 'The interface language is saved to your profile and applied immediately.',
  'settings.language.label': 'Interface language',
  'settings.language.fr': 'Français',
  'settings.language.saved': 'Language saved.',
  'settings.language.error': 'The language could not be saved. Try again.',
  'settings.backup.title': 'Data backup',
  'settings.backup.description': 'Download a complete, restorable JSON backup of your LifeOps data.',
  'settings.backup.contentsTitle': 'Backup contents',
  'settings.backup.contents': 'LifeOps profile, tasks and history, routines, lists, calendar, activities and timers, notes, meals, satisfaction, goals and all related templates.',
  'settings.backup.restoreHelp': 'The file keeps the source identifiers and relationships required for a future restore. Ownership identifiers will be remapped to the authenticated account during restore.',
  'settings.backup.export': 'Export all my data',
  'settings.backup.exporting': 'Creating backup…',
  'settings.backup.success': 'Backup generated on {generatedAt}.',
  'settings.backup.error': 'The complete backup could not be generated. No incomplete file was downloaded.',
  'settings.restore.choose': 'Restore a backup',
  'settings.restore.preparing': 'Checking backup…',
  'settings.restore.eyebrow': 'RESTORE',
  'settings.restore.confirmTitle': 'Restore data from the backup dated {generatedAt}?',
  'settings.restore.confirmHelp': 'Review this backup before continuing. No data is written until you confirm.',
  'settings.restore.file': 'File',
  'settings.restore.backupDate': 'Backup date',
  'settings.restore.rows': 'Items',
  'settings.restore.atomicWarning': 'Restore is atomic: if any data or relationship cannot be restored, no change is kept.',
  'settings.restore.replaceExistingWarning': 'This account already contains {count} business data row(s). They will be replaced by this backup state. If restore fails, the current data will be kept by the transactional rollback.',
  'settings.restore.confirm': 'Restore',
  'settings.restore.restoring': 'Restoring…',
  'settings.restore.success': 'Restore completed: {count} item(s) restored.',
  'settings.restore.targetNotEmpty': 'This account already contains data. Restore V1 requires an empty account.',
  'settings.restore.invalidFile': 'This file is not a compatible LifeOps backup or it is incomplete.',
  'settings.restore.error': 'Restore failed. No partial restore was kept.',
  'lists.myLists': 'My lists',
  'lists.new': 'New list',
  'lists.edit': 'Edit list',
  'lists.type': 'List type',
  'lists.kind.checklist': 'Checklist — items to tick off',
  'lists.kind.backlog': 'Backlog — ordered item queue',
  'lists.kind.collection': 'Collection — items without a completed state',
  'lists.checklistHelp': 'Ideal for a permanent shopping list: tick purchases, then clear purchased items without deleting the list.',
  'lists.archiveThis': 'Archive this list',
  'lists.subtitle': 'Permanent lists, independent from tasks, that you can reuse as often as needed.',
  'lists.loading': 'Loading lists…',
  'lists.empty': 'No active list. For example, create a Shopping list and link it to a recurring task.',
  'lists.showArchived': 'Show archived lists ({count})',
  'lists.archived': 'Archived',
  'lists.restore': 'Restore',
  'lists.summaryAria': 'List summary',
  'lists.activeCount': '{count} active',
  'lists.completedCount': '{count} checked',
  'lists.linkedTaskCount': '{count} linked tasks',
  'lists.back': '← My lists',
  'lists.loadingOne': 'Loading list…',
  'lists.archivedBanner': 'This list is archived. Its content and links remain visible, but changes are disabled.',
  'lists.section.todo': 'To complete',
  'lists.section.backlog': 'Active backlog',
  'lists.section.items': 'Items',
  'lists.permanentHelp': 'The list stays permanent: tick purchases as you go, then clear only purchased items.',
  'lists.newItem': 'New item',
  'lists.itemPlaceholder': 'e.g. Milk',
  'lists.noActiveItems': 'No active item in this list.',
  'lists.markCompletedAria': 'Mark {title} as completed',
  'lists.renameAria': 'Rename {title}',
  'lists.subitem': 'Sub-item',
  'lists.subitemPlaceholder': 'Sub-item name',
  'lists.completedPurchased': 'Purchased / completed',
  'lists.completed': 'Completed',
  'lists.completedHelp': 'These items stay in the list until you clear them.',
  'lists.purgeCompleted': 'Clear checked items',
  'lists.linkedTasks': 'Linked tasks',
  'lists.linkedTasksHelp': 'The link targets the task definition: completing or cancelling an occurrence never changes this list.',
  'lists.noLinkedTasks': 'No linked task.',
  'lists.linkExistingTask': 'Link an existing task',
  'lists.chooseTask': 'Choose a task…',
  'lists.detachAria': 'Unlink {title}',
  'lists.taskArchived': 'archived',
  'lists.loadError': 'The lists could not be loaded. Try again in a few moments.',
  'lists.loadOneError': 'This list could not be loaded. Try again in a few moments.',
  'lists.confirm.removeItemTitle': 'Remove this item?',
  'lists.confirm.removeItem': 'Remove this item from the active list? Its sub-items will also be archived.',
  'lists.confirm.removeSubitem': 'Remove this sub-item from the active list?',
  'lists.confirm.purgeTitle': 'Remove checked items?',
  'lists.confirm.purge': 'Remove all checked items from the active list? They will remain archived in history.',
  'lists.confirm.archiveTitle': 'Archive the list?',
  'lists.confirm.deleteTitle': 'Delete the list?',
  'lists.confirm.archive': 'This list has history or linked tasks. It will be archived and remain available. Continue?',
  'lists.confirm.delete': 'Permanently delete this empty list?',
  'tasks.title': 'Tasks',
  'tasks.subtitle': 'One-off actions, recurring tasks and routines.',
  'tasks.typesAria': 'Task types',
  'tasks.routines.defaultPeriod': 'Default time slot',
  'tasks.routines.period.morning': 'Morning',
  'tasks.routines.period.afternoon': 'Afternoon',
  'tasks.routines.period.evening': 'Evening',
  'tasks.routines.period.night': 'Night',
  'tasks.routines.measureType': 'Measurement type',
  'tasks.routines.measureType.quantity': 'Quantity',
  'tasks.routines.measureType.time': 'Time',
  'tasks.routines.measureUnit': 'Unit',
  'tasks.routines.quantityUnitRequired': 'Provide a unit for quantity measurements.',
  'tasks.routines.defaultDuration': 'Default duration (min)',
  'tasks.routines.durationCompleted': 'Duration completed',
  'tasks.routines.timerMeasured': 'Current linked timer: {value} min',
  'tasks.routines.useTimerValue': 'Use timer duration',
  'tasks.routines.measureUnitPlaceholder': 'E.g. min, pages, reps, ml',
  'tasks.routines.defaultQuantity': 'Default quantity',
  'tasks.routines.measurePairRequired': 'Provide both a unit and a positive quantity, or leave both empty.',
  'tasks.routines.quantityCompletedTitle': 'Complete “{title}”',
  'tasks.routines.quantityCompleted': 'Quantity completed',
  'tasks.routines.quantityPositive': 'Quantity must be greater than zero.',
  'tasks.filters.search': 'Search',
  'tasks.filters.searchPlaceholder': 'Title or description…',
  'tasks.filters.all': 'All',
  'tasks.filters.lastDate': 'Last',
  'tasks.filters.nextDate': 'Next',
  'tasks.filters.activity': 'Tracking',
  'tasks.filters.withActivity': 'With activity / timer',
  'tasks.filters.withoutActivity': 'Without activity / timer',
  'tasks.filters.reset': 'Reset',
  'tasks.recurrent': 'Recurring',
  'tasks.exchange.import': 'Import from Excel / CSV',
  'tasks.exchange.exportActive': 'Export active configurations',
  'tasks.exchange.exportOne': 'Export {name}',
  'tasks.exchange.preview': '{count} configuration(s) recognized. No history will be imported.',
  'tasks.exchange.upsertHelp': 'Same name: the existing configuration is updated. New name: it is created. Configurations absent from the file are left unchanged.',
  'tasks.exchange.upserted': '{updated} configuration(s) updated, {created} created. Other configurations were not changed.',
  'tasks.exchange.conflict': 'If a configuration with the same name already exists',
  'tasks.exchange.replace': 'Replace configuration',
  'tasks.exchange.copy': 'Import as new',
  'tasks.exchange.skip': 'Skip',
  'tasks.exchange.importConfirm': 'Import',
  'tasks.exchange.imported': '{imported} configuration(s) imported, {skipped} skipped.',
  'tasks.exchange.importError': 'Configuration import failed.',
  'tasks.exchange.exportError': 'Configuration export failed.',
  'tasks.newTodo': 'New To Do',
  'tasks.loading': 'Loading tasks…',
  'tasks.todoEmpty': 'No To Do. Create your first action, with or without a date.',
  'tasks.open': 'To do',
  'tasks.deleteAria': 'Delete {title} permanently',
  'tasks.completeAria': 'Complete {title}',
  'tasks.scheduledFor': 'Scheduled for',
  'tasks.changeDateAria': 'Change scheduled date for {title}',
  'tasks.cancelTask': 'Cancel task',
  'tasks.loadingHistory': 'Loading history…',
  'tasks.purgeHistory': 'Clear completed and cancelled tasks',
  'tasks.historyEmpty': 'No task in history.',
  'tasks.completedOn': 'Completed on {date}',
  'tasks.cancelled': 'Cancelled',
  'tasks.done': 'Completed',
  'tasks.notDone': 'Not completed',
  'tasks.editTodo': 'Edit To Do',
  'tasks.createTodo': 'Create a To Do',
  'tasks.titleRequired': 'Title is required.',
  'tasks.scheduledDate': 'Scheduled date',
  'tasks.subtasks': 'Subtasks',
  'tasks.subtaskAria': 'Subtask {index}',
  'tasks.addSubtask': '+ Add a subtask',
  'tasks.completeDialogTitle': 'Complete task?',
  'tasks.completeDialogBody': '“{title}” and its subtasks will be marked as completed.',
  'tasks.deleteDialogTitle': 'Delete task permanently?',
  'tasks.deleteDialogBody': '“{title}” and all its history will be deleted. This action cannot be undone.',
  'tasks.purgeDialogTitle': 'Clear all closed history?',
  'tasks.purgeDialogBody': '{count} completed or cancelled task(s) will be deleted permanently.',
  'tasks.cancelDialogTitle': 'Cancel this task?',
  'tasks.cancelDialogBody': 'It will stay in history without being counted as completed.',
  'tasks.cancelReason': 'Optional reason',
  'tasks.recurrentDescription': 'Actions repeated at an interval calculated from their actual completion.',
  'tasks.newRecurrent': 'New recurring task',
  'tasks.editRecurrent': 'Edit recurring task',
  'tasks.createRecurrent': 'Create recurring task',
  'tasks.intervalDays': 'Interval in days',
  'tasks.firstDate': 'Optional first date',
  'tasks.futureOccurrences': 'for future occurrences',
  'tasks.noActiveRecurrent': 'No active recurring task.',
  'tasks.task': 'Task',
  'tasks.frequency': 'Frequency',
  'tasks.last': 'Last',
  'tasks.next': 'Next',
  'tasks.steps': 'Steps',
  'tasks.priority.urgent': 'P1 — Urgent',
  'tasks.priority.high': 'P2 — High',
  'tasks.priority.normal': 'P3 — Normal',
  'tasks.priority.low': 'P4 — Low',
  'tasks.priority.someday': 'P5 — Someday',
  'tasks.loadError': 'Tasks could not be loaded. Try again in a few moments.',
  'tasks.historyLoadError': 'Task history could not be loaded.',
  'tasks.saveError': 'Saving failed. No additional change will be sent.',
  'tasks.recurrentLoadError': 'Recurring tasks could not be loaded.',
  'tasks.recurrentSaveError': 'The recurring task could not be saved.',
  'tasks.recurrentDetailError': 'Details for “{title}” could not be loaded.',
  'tasks.completedDateRequired': 'Completion date is required.',
  'tasks.routineStatus.completed': 'Completed',
  'tasks.routineStatus.notCompleted': 'Not completed',
  'tasks.routineStatus.cancelled': 'Cancelled',
  'tasks.routineStatus.notRecorded': 'Not recorded',
  'tasks.routineStatus.notPlanned': 'Not planned',
  'tasks.routineSaveError': 'The routine could not be saved.',
  'tasks.routineResultError': 'The routine result could not be saved.',
  'tasks.subtaskSaveError': 'The subtask could not be saved.',
  'tasks.routinesLoadError': 'Routines could not be loaded.',
  'tasks.routinesDateLoadError': 'Routines could not be loaded for this date.',
  'tasks.recurrent.currentSubtasks': 'Subtasks for the current occurrence',
  'tasks.recurrent.noSubtasks': 'No subtask for this occurrence.',
  'tasks.recurrent.occurrences': 'Occurrences',
  'tasks.recurrent.cancelCurrent': 'Cancel current occurrence',
  'tasks.recurrent.planned': 'Scheduled',
  'tasks.recurrent.status': 'Status',
  'tasks.recurrent.completedOn': 'Completed on',
  'tasks.recurrent.noHistory': 'No past occurrence.',
  'tasks.recurrent.inactive': 'Deactivated',
  'tasks.recurrent.reactivate': 'Reactivate',
  'tasks.recurrent.planNext': 'Schedule next occurrence',
  'tasks.recurrent.nextDate': 'Next date',
  'tasks.recurrent.cancelOccurrenceQuestion': 'Cancel this occurrence?',
  'tasks.recurrent.planFollowing': 'Schedule the following occurrence',
  'tasks.recurrent.cancelOccurrence': 'Cancel occurrence',
  'tasks.recurrent.date': 'Date',
  'tasks.recurrent.plan': 'Schedule',
  'tasks.recurrent.editOccurrence': 'Edit occurrence',
  'tasks.recurrent.completed': 'Completed',
  'tasks.recurrent.cancelled': 'Cancelled',
  'tasks.recurrent.realCompletionDate': 'Actual completion date',
  'tasks.recurrent.cancellationReason': 'Cancellation reason',
  'tasks.recurrent.recalculateNext': 'Also recalculate the next occurrence',
  'tasks.recurrent.deleteOccurrenceQuestion': 'Delete this occurrence?',
  'tasks.recurrent.deleteOccurrenceHelp': 'This deletion is permanent. The occurrence and its subtasks will disappear from history.',
  'tasks.recurrent.deactivateQuestion': 'Deactivate this recurring task?',
  'tasks.recurrent.deactivateHelp': 'The open occurrence will be cancelled. History will be kept and no new occurrence will be created.',
  'tasks.recurrent.deactivate': 'Deactivate',
  'tasks.recurrent.deleteTaskHelp': 'The task, all occurrences, history and subtasks will be permanently deleted.',
  'tasks.recurrent.irreversible': 'This action cannot be undone.',
  'tasks.recurrent.markDone': 'Mark as completed',
  'tasks.recurrent.showDetails': 'Show details',
  'tasks.recurrent.completeQuestion': 'Complete “{title}”?',
  'tasks.recurrent.everyDay': 'Every day',
  'tasks.recurrent.everyDays': 'Every {count} days',
  'tasks.recurrent.lateDays': '+{count} d',
  'tasks.recurrent.deleteOccurrenceAria': 'Delete this occurrence',
  'tasks.routines.dateNavigation': 'Date navigation',
  'tasks.routines.previousDay': 'Previous day',
  'tasks.routines.nextDay': 'Next day',
  'tasks.routines.historyFiveDays': 'History for the last five days',
  'tasks.routines.cancelOccurrence': 'Cancel this occurrence',
  'tasks.routines.resetStatus': 'Reset to not recorded',
  'tasks.routines.inactiveBadge': 'Inactive',
  'tasks.routines.stepSingular': 'step',
  'tasks.routines.stepPlural': 'steps',
  'tasks.routines.markCompletedAria': 'Mark {title} as completed',
  'tasks.routines.markNotCompletedAria': 'Mark {title} as not completed',
  'tasks.routines.resetAria': 'Reset {title} to not recorded',
  'tasks.routines.dailyTracking': 'Daily tracking',
  'tasks.routines.today': 'Today',
  'tasks.routines.futureReadOnly': 'Future date — read only',
  'tasks.routines.chooseDate': 'Choose a date',
  'tasks.routines.configuration': 'Configuration',
  'tasks.routines.new': '+ New routine',
  'tasks.routines.active': 'Active',
  'tasks.routines.inactive': 'Inactive',
  'tasks.routines.historyKept': 'History kept',
  'tasks.routines.archive': 'Archive',
  'tasks.routines.emptyConfig': 'No routine configured',
  'tasks.routines.emptyConfigHelp': 'Create your first routine to start daily tracking.',
  'tasks.routines.loading': 'Loading routines…',
  'tasks.routines.retryToday': 'Retry today',
  'tasks.routines.archived': 'Archived',
  'tasks.routines.fiveDays': '5 days',
  'tasks.routines.emptyDay': 'No routine scheduled for this date',
  'tasks.routines.noRollover': 'Routines are never carried over from one day to the next.',
  'tasks.routines.create': 'Create a routine',
  'tasks.routines.daySteps': 'Steps for the day',
  'tasks.routines.stepsLocked': 'Steps can only be changed while the routine result is not recorded.',
  'tasks.routines.activeFrom': 'Active from',
  'tasks.routines.dailySteps': 'Daily steps',
  'tasks.routines.optionalSteps': 'Optional, reset for each new date.',
  'tasks.routines.historyDeactivateHelp': 'History is kept. No new day will be created from today onward.',
  'tasks.routines.resumeFrom': 'Resume from',
  'tasks.routines.noRetroactive': 'The inactive period will not be recreated retroactively.',
  'tasks.routines.archiveHelp': 'The routine will disappear from configuration, but recorded days remain available in history.',
  'tasks.routines.closeConfig': 'Close configuration',
  'tasks.routines.configure': 'Configure routines',
  'tasks.routines.completedCount': 'routines completed out of',
  'tasks.routines.plannedCount': 'scheduled',

  'today.highlightFallback': 'Highlighted item',
  'today.today': 'Today',
  'today.loading': 'Loading the day…',
  'today.loadUnavailable': 'The day could not be loaded. Your data is unchanged.',
  'today.retryLoading': 'Retry',
  'today.dayPriority': 'Day priority',
  'today.openCalendar': 'View in Calendar →',
  'today.highlightUnavailable': 'Highlight is temporarily unavailable.',
  'today.noHighlight': 'No highlight set for this day',
  'today.chooseHighlight': 'Daily Highlight',
  'today.chooseHighlightAria': 'Choose the Highlight for the day',
  'today.clearHighlight': 'Clear Highlight',
  'today.clearHighlightAria': 'Clear the Highlight for the day',
  'today.setHighlightTo': 'Set as Highlight:',
  'today.removeHighlightFrom': 'Remove from Highlight:',
  'today.startActivityTimer': 'Start timer',
  'today.error.startActivityTimer': 'Could not start the timer for {title}.',
  'today.clearMealAria': 'Clear meal for',
  'today.noHighlightCandidate': 'No planned activity is available as a Highlight.',
  'today.error.highlightSave': 'The Highlight could not be saved.',
  'today.reschedule': 'Reschedule',
  'today.changeActivityPeriod': 'Change period for',
  'today.error.rescheduleActivity': 'Could not reschedule {title}.',
  'today.mealFor': 'Meal for',
  'today.noMealSelected': 'No meal selected',
  'today.noMealAvailable': 'No meal available',
  'today.toPlan': 'To plan',
  'today.tasksPartialError': 'Some tasks could not be loaded.',
  'today.plan': 'Plan…',
  'today.postpone': 'Postpone',
  'today.skip': 'Skip',
  'today.noSubtasks': 'No subtask.',
  'today.hideSubtasks': 'Hide subtasks',
  'today.planning': 'Planning',
  'today.myDay': 'My day',
  'today.openCalendarShort': 'Open Calendar →',
  'today.calendarUnavailable': 'Calendar planning is unavailable.',
  'today.plannedTasksPartialError': 'Some scheduled tasks could not be loaded.',
  'today.calendarActivity': 'Calendar activity',
  'today.dropTaskHere': 'Drop or assign a task here.',
  'today.noCalendarPeriod': 'No active Calendar period is available for this day.',
  'today.myMeals': 'My meals',
  'today.mealsUnavailable': 'Meals are temporarily unavailable.',
  'today.noMealType': 'No active meal type. Add or reactivate a Meal axis in Calendar.',
  'today.wellbeing': 'Well-being',
  'today.satisfaction': 'Day satisfaction',
  'today.clear': 'Clear',
  'today.satisfactionUnavailable': 'The satisfaction score is temporarily unavailable.',
  'today.goalsProgress': 'Today’s progress',
  'today.openGoals': 'View Goals →',
  'today.partialUnavailable': 'Some blocks are temporarily unavailable. The others remain usable.',
  'today.recurrentTask': 'Recurring task',
  'today.completedOn': 'Completed on',
  'today.createNextOccurrence': 'Create next occurrence',
  'today.nextOccurrence': 'Next occurrence',
  'today.navigationAria': 'Day navigation',
  'today.previousDayAria': 'Previous day',
  'today.chooseDateAria': 'Choose a date',
  'today.nextDayAria': 'Next day',
  'today.highlightDoneAria': 'Highlight completed',
  'today.moveTaskAria': 'Move task',
  'today.mealPlaceholder': 'Meal / recipe…',
  'today.satisfactionAria': 'Day satisfaction from minus three to plus three',
  'today.error.completeRecurrent': 'The recurring task could not be completed.',
  'today.error.placeTask': 'The task could not be assigned to this period.',
  'today.error.moveTask': 'The task could not be moved.',
  'today.error.unplanTask': 'The task could not be moved back to To plan.',
  'today.error.reorder': 'The period order could not be saved.',
  'today.recurrent': 'Recurring',
  'today.satisfaction.minus3': 'Extremely unsatisfying day',
  'today.satisfaction.minus2': 'Bad day',
  'today.satisfaction.minus1': 'Rather unsatisfying',
  'today.satisfaction.zero': 'Neutral',
  'today.satisfaction.plus1': 'Rather satisfying',
  'today.satisfaction.plus2': 'Good day',
  'today.satisfaction.plus3': 'Excellent day',
  'today.error.subtasks': 'The subtasks for “{title}” could not be loaded.',
  'today.error.subtaskUpdate': 'The subtask “{title}” could not be updated.',
  'today.error.mealSave': 'The meal “{name}” could not be saved.',
  'today.error.satisfactionSave': 'The day satisfaction could not be saved.',
  'today.error.satisfactionClear': 'The day satisfaction could not be cleared.',
  'today.error.futureDate': 'Choose a date after the displayed day.',
  'today.error.postpone': 'The task “{title}” could not be postponed.',
  'today.error.skip': 'The routine “{title}” could not be skipped.',
  'today.error.completeTask': 'The task could not be completed. Try again.',
  'today.error.reopenTask': 'The task “{title}” could not be reopened.',
  'today.error.completeActivity': 'The activity could not be completed. Try again.',
  'today.error.reopenActivity': 'The activity could not be reopened. Try again.',
  'calendar.meals': 'Meals',
  'calendar.planWeek': 'Plan the week',
  'calendar.manageAxes': 'Manage axes',
  'calendar.addAxis': 'Add axis',
  'calendar.addingAxis': 'Adding…',
  'calendar.axisUp': 'Move axis up',
  'calendar.axisDown': 'Move axis down',
  'calendar.today': 'Today',
  'calendar.chooseDate': 'Choose a date',
  'calendar.consultation': 'View',
  'calendar.editing': 'Editing',
  'calendar.editMode': 'Edit mode',
  'calendar.finishEditing': 'Finish editing',
  'calendar.mealForDay': '{meal} — {day}',
  'calendar.configuration': 'Configuration',
  'calendar.axesTitle': 'Calendar axes',
  'calendar.name': 'Name',
  'calendar.type': 'Type',
  'calendar.axisThematic': 'Thematic axis',
  'calendar.timeSlot': 'Time slot',
  'calendar.slot': 'Slot',
  'calendar.axis': 'Axis',
  'calendar.initial': 'Initial',
  'calendar.archived': 'Archived',
  'calendar.visible': 'Visible',
  'calendar.restore': 'Restore',
  'calendar.loadingWeek': 'Loading week…',
  'calendar.planning': 'Planning',
  'calendar.weekPlanning': 'Week planning',
  'calendar.dayPlanning': 'Day planning',
  'calendar.openToday': 'Open Today →',
  'calendar.moveCopyHelp': 'A free entry is copied; a To Do or recurring task is moved. A routine stays linked to its day. Meal axes are filled from Today.',
  'calendar.noVisibleAxes': 'All axes are hidden or archived. Open “Manage axes” to show one again.',
  'calendar.nothingPlanned': 'Nothing planned.',
  'calendar.noPlanningAxis': 'No planning axis is visible right now.',
  'calendar.scheduling': 'Scheduling',
  'calendar.placeExistingOccurrence': 'Place an existing occurrence',
  'calendar.chooseTaskType': 'Choose the type and then the occurrence to place in this cell.',
  'calendar.or': 'or',
  'calendar.createFreeEntry': 'Plan an activity',
  'calendar.reuseActivity': 'Reuse an activity',
  'calendar.newActivity': 'New activity…',
  'calendar.activitySuggestionsHelp': 'Active activities can be reused across multiple Calendar placements.',
  'calendar.chooseAxis': 'Choose an axis',
  'calendar.date': 'Date',
  'calendar.deleteLogicalHelp': 'It will disappear from normal views but remain logically deleted in the database.',
  'calendar.keepCurrentState': 'Keep current state',
  'calendar.recurrentTask': 'Recurring task',
  'calendar.recurrentCompletionHelp': 'Calendar uses the same workflow as Tasks: actual completion date, then immediate choice of the next occurrence.',
  'calendar.realCompletionDate': 'Actual completion date',
  'calendar.createNextOccurrence': 'Create next occurrence',
  'calendar.nextDate': 'Next date',
  'calendar.navigationAria': 'Calendar navigation',
  'calendar.previousWeek': 'Previous week',
  'calendar.nextWeek': 'Next week',
  'calendar.closeAria': 'Close',
  'calendar.axisLeft': 'Move axis left',
  'calendar.axisRight': 'Move axis right',
  'calendar.weekView': 'Week view',
  'calendar.mobileDayView': 'Mobile day view',
  'calendar.previousDay': 'Previous day',
  'calendar.nextDay': 'Next day',
  'calendar.notePlaceholder': 'Context, location, details…',
  'calendar.cancelledAria': 'Cancelled',
  'calendar.setHighlight': 'Set as Highlight',
  'calendar.moveEntryUp': 'Move entry up',
  'calendar.moveEntryDown': 'Move entry down',
  'calendar.unplanTask': 'Unplan without deleting task',
  'calendar.noDate': 'No date',
  'calendar.routineOn': 'Routine on {date}',
  'calendar.postponedDays': 'Postponed by {count} d',
  'calendar.lateDays': '{count} d late',
  'calendar.scheduled': 'Scheduled {date}',
  'calendar.unplaced': 'Unplaced',
  'calendar.axisUnavailable': 'Axis unavailable',
  'calendar.error.load': 'Calendar could not be loaded. Try again in a few moments.',
  'calendar.error.entrySave': 'The entry could not be saved. Other items were not changed.',
  'calendar.error.tasksLoad': 'Available tasks could not be loaded.',
  'calendar.error.routineDate': 'A routine must be placed on the date of its daily occurrence.',
  'calendar.error.taskPlace': 'The task could not be placed. No partial move was kept.',
  'calendar.error.copy': 'The activity copy could not be saved. Try again.',
  'calendar.error.routineMove': 'A daily routine cannot be moved to another date.',
  'calendar.error.taskMove': 'Moving the task failed. Tasks and Calendar stayed in their previous state.',
  'calendar.error.taskUnplan': 'The task could not be unplanned. It remains available in Tasks.',
  'calendar.error.taskComplete': 'The task could not be completed from Calendar.',
  'calendar.error.taskReopen': 'The task could not be reopened from Calendar.',
  'calendar.error.recurrentComplete': 'The recurring task could not be completed. No partial next occurrence was kept.',
  'calendar.error.highlightUpdate': 'Highlight could not be updated.',
  'calendar.error.highlightSave': 'Highlight could not be saved.',
  'calendar.error.highlightRemove': 'Highlight could not be removed.',
  'calendar.error.axisCreate': 'The axis could not be created.',
  'calendar.error.axisOrder': 'The axis order could not be saved.',
  'calendar.error.axisUpdate': 'The axis change could not be saved.',
  'calendar.mealsLoadError': 'Meals for the week could not be loaded.',
  'calendar.mealSaveError': 'The meal could not be saved. Other cells remain unchanged.',
  'calendar.templatesLoadError': 'Calendar templates could not be loaded.',
  'calendar.templateItemAddError': 'The activity could not be added to the template.',
  'calendar.templateItemRemoveError': 'The activity could not be removed from the template.',
  'calendar.templateApplied': '{count} activity/activities added to the week.',
  'calendar.templateAlreadyApplied': 'This template is already present on this week.',
  'calendar.templateApplyError': 'The template could not be loaded. The existing week was not deleted.',
  'calendar.templateDeleted': 'Template deleted. Previously loaded weeks remain unchanged.',
  'calendar.templateDeleteError': 'The template could not be deleted.',
  'calendar.templateCreatedFromWeek': 'Template created with {count} free activity/activities.',
  'calendar.templateCreatedBlank': 'Empty template created. Add its activities now.',
  'calendar.templateCreateError': 'The template could not be created. Check in particular that its name is unique.',
  'calendar.weekMenus': 'Weekly menus',
  'calendar.loadingMeals': 'Loading meals…',
  'calendar.mealPlaceholder': 'Meal…',
  'calendar.clearMeal': 'Clear meal',
  'calendar.noMealAxes': 'No active meal type. Add one from “Manage axes” and choose the Meal type.',
  'calendar.weekModel': 'Week model',
  'calendar.chooseTemplate': 'Choose…',
  'calendar.noTemplate': 'No template',
  'calendar.load': 'Load',
  'calendar.manageTemplates': 'Manage templates',
  'calendar.templates': 'Templates',
  'calendar.manageWeekModels': 'Manage week models',
  'calendar.templateImport': 'Import Excel / CSV templates',
  'calendar.exportAllTemplates': 'Export all templates',
  'calendar.exportTemplate': 'Export {name}',
  'calendar.templateImportSummary': '{templates} template(s), {axes} axis/axes to review.',
  'calendar.associateAxis': 'Map to “{name}”',
  'calendar.createAxisOnImport': 'Create axis “{name}”',
  'calendar.templateConflict': 'If a template with the same name already exists',
  'calendar.templateConflictReplace': 'Replace',
  'calendar.templateConflictCopy': 'Import as new',
  'calendar.templateConflictSkip': 'Skip',
  'calendar.importTemplates': 'Import templates',
  'calendar.templateImported': '{imported} template(s) imported, {skipped} skipped.',
  'calendar.templateImportError': 'Calendar template import failed.',
  'calendar.templateImportInvalidItem': 'An activity in the file is incomplete or invalid.',
  'calendar.templateExported': '{count} template exported.',
  'calendar.templatesExported': '{count} templates exported.',
  'calendar.templateName': 'Template name',
  'calendar.modelNamePlaceholder': 'Model name',
  'calendar.createBlank': 'Create blank',
  'calendar.fromWeek': 'From this week',
  'calendar.createdFromWeek': 'Created from week of {date}',
  'calendar.createdBlank': 'Created from scratch',
  'calendar.deleteTemplate': 'Delete template',
  'calendar.day': 'Day',
  'calendar.activity': 'Activity',
  'calendar.optionalNote': 'Optional note',
  'calendar.addToTemplate': 'Add to template',
  'calendar.emptyTemplate': 'Empty template. Add its first activity above.',
  'calendar.loadTemplateQuestion': 'Load {name}?',
  'calendar.loadTemplateHelp': 'Missing free activities will be added to the displayed week. Existing entries and all tasks remain unchanged.',
  'calendar.loadTemplate': 'Load template',
  'calendar.deleteTemplateQuestion': 'Delete {name}?',
  'calendar.deleteTemplateHelp': 'The template will be deleted, but weeks where it was already loaded will not be changed.',
  'goals.title': 'Goals',
  'goals.nonApplicable': 'Not applicable',
  'goals.unavailable': 'Unavailable',
  'goals.error': 'Error',
  'goals.correctionValueRequired': 'Enter a correction value.',
  'goals.negativeReplacement': 'A replacement value cannot be negative.',
  'goals.booleanReplacement': 'A yes/no replacement accepts only 0 or 1.',
  'goals.correctionSaved': 'Correction saved.',
  'goals.correctionDeleted': 'Correction deleted.',
  'goals.targetChanged': 'Target changed for this date.',
  'goals.removedFromDate': 'Goal removed from this date.',
  'goals.removedFromPeriod': 'Goal removed from this period.',
  'goals.targetPositive': 'The target must be strictly positive.',
  'goals.booleanTarget': 'The target for a yes/no goal must equal 1.',
  'goals.actionFailed': 'The Goals action failed. Try again.',
  'goals.addGoal': 'Add a goal',
  'goals.templateEmpty': 'The saved template week is empty. Add goals and save it before loading it.',
  'goals.weekAlreadyPresent': 'The template week is already fully present on this week. Existing customisations are kept.',
  'goals.editorCleared': 'Template week cleared in the editor. Save it to apply this model to future days.',
  'goals.sourceWeekEmpty': 'This week contains no saved Goals day.',
  'goals.goalUnavailable': 'Goal unavailable',
  'goals.modelUnavailable': 'A goal in the model is no longer available.',
  'goals.templateSaved': 'Template week saved. Existing days remain unchanged until you explicitly load the model onto a week.',
  'goals.eachTargetPositive': 'Each target must be strictly positive.',
  'goals.booleanTemplateTarget': 'A yes/no target must equal 1.',
  'goals.templateSaveFailed': 'The weekly model could not be saved.',
  'goals.subtitle': 'Result, target and progress for the day.',
  'goals.weeklyTemplate': 'Template week',
  'goals.add': 'Add',
  'goals.navigationAria': 'Navigate between dates',
  'goals.previousDay': 'Previous day',
  'goals.today': 'Today',
  'goals.nextDay': 'Next day',
  'goals.loading': 'Loading goals…',
  'goals.summaryAria': 'Day summary',
  'goals.periodSummaryAria': 'Period summary',
  'goals.scoreProvisional': 'provisional score',
  'goals.scoreDay': 'daily score',
  'goals.scorePeriod': 'period score',
  'goals.achieved': 'achieved',
  'goals.measured': 'filled in',
  'goals.refresh': 'Refresh',
  'goals.dayGoalsAria': 'Goals for the day',
  'goals.goal': 'Goal',
  'goals.result': 'Result',
  'goals.automatic': 'Automatic',
  'goals.corrected': 'corrected',
  'goals.addedForDay': 'Added for this day',
  'goals.sourceUnavailable': 'Source unavailable',
  'goals.resultAria': 'Result {name}',
  'goals.calculated': 'calculated',
  'goals.optionsAria': 'Options for {name}',
  'goals.editGoal': 'Edit goal',
  'goals.targetForDay': 'Target for this day',
  'goals.changeTarget': 'Change target',
  'goals.correctAutomatic': 'Correct automatic result',
  'goals.calculatedValue': 'Calculated value: {value}',
  'goals.mode': 'Mode',
  'goals.adjust': 'Adjust',
  'goals.replace': 'Replace',
  'goals.value': 'Value',
  'goals.apply': 'Apply',
  'goals.clearCorrection': 'Clear correction',
  'goals.removeForDay': 'Remove from this day',
  'goals.removeForPeriod': 'Remove from this period',
  'goals.emptyDay': 'No goal for this date.',
  'goals.emptyDayHelp': 'Add a goal here or prepare your template week.',
  'goals.addToDate': 'Add to {date}',
  'goals.goalEdited': 'Goal updated.',
  'goals.newGoalAdded': 'New goal added to this date.',
  'goals.goalAdded': 'Goal added to this date.',
  'goals.automaticRefreshed': 'Automatic results refreshed.',
  'goals.manualNonNegative': 'The result must be zero or positive.',
  'goals.booleanResult': 'A yes/no goal only accepts 0 or 1.',
  'goals.noOccurrence': 'No occurrence is planned for this date: the result is not applicable.',
  'goals.template.subtitle': 'Prepare the usual goals for each day, then load this model onto the weeks you want.',
  'goals.template.backDay': 'Back to day',
  'goals.template.saving': 'Saving…',
  'goals.template.save': 'Save',
  'goals.template.loading': 'Loading template week…',
  'goals.template.startEyebrow': 'STARTING POINT',
  'goals.template.createModel': 'Create the model',
  'goals.template.createHelp': 'Start from scratch or reuse the goals and targets from an existing week.',
  'goals.template.startBlank': 'Start from scratch',
  'goals.template.previousWeek': 'Previous week',
  'goals.template.chooseExistingWeek': 'Choose an existing week',
  'goals.template.nextWeek': 'Next week',
  'goals.template.loadingShort': 'Loading…',
  'goals.template.fromWeek': 'From this week',
  'goals.template.loadEyebrow': 'LOAD MODEL',
  'goals.template.applyTitle': 'Apply template week',
  'goals.template.applyHelp': 'Add the saved model to a real week without deleting or overwriting existing customisations.',
  'goals.template.previousTargetWeek': 'Previous target week',
  'goals.template.chooseTargetWeek': 'Choose the week on which to load the model',
  'goals.template.nextTargetWeek': 'Next target week',
  'goals.template.loadThisWeek': 'Load on this week',
  'goals.template.confirmQuestion': 'Load the template week onto {week}?',
  'goals.template.confirmHelp': 'Missing goals will be added. Existing customised goals, results and targets will remain unchanged.',
  'goals.template.load': 'Load template week',
  'goals.template.editorAria': 'Template week goals',
  'goals.template.goalSingular': 'goal',
  'goals.template.goalPlural': 'goals',
  'goals.template.moveUp': 'Move {name} up',
  'goals.template.moveDown': 'Move {name} down',
  'goals.template.removeFromDay': 'Remove {name} from {day}',
  'goals.template.target': 'Target',
  'goals.template.noGoal': 'No goal.',
  'goals.template.addToDay': 'Add to {day}',
  'goals.template.appliedCount': '{count} goals added or restored on the week.',
  'goals.template.copiedWeek': 'Week of {date} loaded into the editor. Nothing is saved until you click Save.',
  'goals.templateInline.day': 'day',
  'goals.templateInline.saveDay': 'Save day',
  'goals.templateInline.loadDay': 'Load day',
  'goals.templateInline.savePeriod': 'Save {period} template',
  'goals.templateInline.loadPeriod': 'Load {period} template',
  'goals.templateInline.saveWeeklyType': 'Save weekly template',
  'goals.templateInline.loadWeeklyType': 'Load weekly template',
  'goals.templateInline.savedDay': 'Day template saved ({count} goal(s)).',
  'goals.templateInline.loadedDay': 'Day template loaded ({count} goal(s)).',
  'goals.templateInline.savedPeriod': '{period} template saved ({count} goal(s)).',
  'goals.templateInline.loadedPeriod': '{period} template loaded ({count} goal(s)).',
  'goals.templateInline.savedWeeklyType': 'Weekly template saved from the displayed week.',
  'goals.templateInline.loadedWeeklyType': 'Weekly template loaded ({count} goal(s)).',
  'goals.templateInline.emptyWeek': 'The displayed week has no goals to save.',
  'goals.templateLibrary.eyebrow': 'TEMPLATE LIBRARY',
  'goals.templateLibrary.saveDayTitle': 'Save this day as a template',
  'goals.templateLibrary.loadDayTitle': 'Load a day template',
  'goals.templateLibrary.savePeriodTitle': 'Save a {period} template',
  'goals.templateLibrary.loadPeriodTitle': 'Load a {period} template',
  'goals.templateLibrary.saveWeekTitle': 'Save a weekly template',
  'goals.templateLibrary.loadWeekTitle': 'Load a weekly template',
  'goals.templateLibrary.name': 'Template name',
  'goals.templateLibrary.namePlaceholder': 'E.g. Office day',
  'goals.templateLibrary.template': 'Template',
  'goals.templateLibrary.load': 'Load',
  'goals.templateLibrary.none': 'No template saved for this context.',
  'goals.templateLibrary.nameRequired': 'Give the template a name.',
  'goals.templateLibrary.choose': 'Choose a template to load.',
  'goals.templateLibrary.saved': 'Template “{name}” saved.',
  'goals.templateLibrary.loaded': 'Template loaded.',
  'goals.templateLibrary.weekDirect': 'Goals defined directly for each day',
  'goals.templateLibrary.weekDayTypes': 'Build the week from day templates',
  'goals.templateLibrary.weekDirectHelp': 'The displayed week will be copied as-is into this template.',
  'goals.templateLibrary.weekDirectShort': 'direct goals',
  'goals.templateLibrary.weekDayTypesShort': 'day templates',
  'goals.templateLibrary.sevenDaysRequired': 'Choose a day template for all 7 days.',
  'goals.templateLibrary.exportExcel': 'Export as Excel-friendly CSV',
  'goals.templateLibrary.importExcel': 'Import from Excel / CSV',
  'goals.templateLibrary.exportAll': 'Export all templates',
  'goals.templateLibrary.exported': 'Template exported ({count} row(s)).',
  'goals.templateLibrary.exportedAll': '{count} template(s) exported.',
  'goals.templateLibrary.exportEmpty': 'This template contains no goal to export.',
  'goals.templateLibrary.importPreview': '{count} row(s) recognized. Check conflict handling before importing.',
  'goals.templateLibrary.conflictLabel': 'If a template with the same name exists',
  'goals.templateLibrary.conflictReplace': 'Replace',
  'goals.templateLibrary.conflictCopy': 'Import as new',
  'goals.templateLibrary.conflictSkip': 'Skip',
  'goals.templateLibrary.importConfirm': 'Import',
  'goals.templateLibrary.imported': '{imported} template(s) imported, {skipped} skipped. {manualized} non-portable automatic source(s) were imported as manual and must be re-linked.',
  'goals.templateLibrary.manage': 'Manage templates',
  'goals.templateLibrary.manageTitle': 'Manage templates',
  'goals.templateLibrary.emptyDay': 'No template — day without goals',
  'goals.templateLibrary.emptyDayHelp': 'A day without a template will deliberately contain no goals when the weekly template is loaded.',
  'goals.templateLibrary.kindDay': 'Day template',
  'goals.templateLibrary.kindWeek': 'Weekly template',
  'goals.templateLibrary.kindPeriod': '{period} template',
  'goals.templateLibrary.noneAny': 'No saved template.',
  'goals.templateLibrary.backToList': 'Template list',
  'goals.templateLibrary.weekday': 'Day',
  'goals.templateLibrary.goal': 'Goal',
  'goals.templateLibrary.target': 'Target',
  'goals.templateLibrary.removeGoal': 'Remove',
  'goals.templateLibrary.addGoal': 'Add a goal',
  'goals.templateLibrary.saveChanges': 'Save changes',
  'goals.templateLibrary.updated': 'Template updated.',
  'goals.templateLibrary.weekdayRequired': 'Choose a day for each weekly goal.',
  'goals.templateLibrary.exportOne': 'Export {name}',
  'goals.periodTemplate.eyebrow': 'PERIOD TEMPLATES',
  'goals.periodTemplate.title': 'Weekly and monthly goals',
  'goals.periodTemplate.help': 'Create a template from an existing week or month, then load it onto a current or future period.',
  'goals.periodTemplate.weeklyTitle': 'Weekly template',
  'goals.periodTemplate.monthlyTitle': 'Monthly template',
  'goals.periodTemplate.savedCount': '{count} saved goal(s)',
  'goals.periodTemplate.sourceWeek': 'Source week',
  'goals.periodTemplate.targetWeek': 'Target week',
  'goals.periodTemplate.sourceMonth': 'Source month',
  'goals.periodTemplate.targetMonth': 'Target month',
  'goals.periodTemplate.createFromPeriod': 'Create from this period',
  'goals.periodTemplate.load': 'Load template',
  'goals.periodTemplate.empty': 'No template saved.',
  'goals.periodTemplate.saved': 'Template created from {period} with {count} goal(s).',
  'goals.periodTemplate.applied': 'Template loaded onto {period} with {count} goal(s).',
  'goals.periodTemplate.confirmQuestion': 'Load this template onto {period}?',
  'goals.periodTemplate.confirmHelp': 'Goals for the same period type will be replaced by the template snapshot. Historical periods stay protected.',
  'goals.periodTemplate.confirmLoad': 'Load on this period',
  'goals.weekday.monday': 'Monday',
  'goals.weekday.tuesday': 'Tuesday',
  'goals.weekday.wednesday': 'Wednesday',
  'goals.weekday.thursday': 'Thursday',
  'goals.weekday.friday': 'Friday',
  'goals.weekday.saturday': 'Saturday',
  'goals.weekday.sunday': 'Sunday',
  'goals.dialog.addEyebrow': 'ADD',
  'goals.dialog.editEyebrow': 'EDIT',
  'goals.dialog.close': 'Close',
  'goals.dialog.addTypeAria': 'Add type',
  'goals.dialog.existing': 'Existing',
  'goals.dialog.newManual': 'New manual',
  'goals.dialog.newAutomatic': 'New automatic',
  'goals.dialog.fromShorterGoal': 'From a shorter-period goal',
  'goals.dialog.dailyResults': 'Daily goals result',
  'goals.dialog.sourceGoal': 'Source goal',
  'goals.dialog.sameNameByDefault': 'Same name by default',
  'goals.dialog.derivedAggregationHint': 'Values are summed; percentages are averaged.',
  'goals.dialog.dailyResultsHelp': 'Average overall daily-goal score across the period.',
  'goals.dialog.derivedSourceLocked': 'The period and source are locked to preserve the derivation.',
  'goals.dialog.chooseGoalTarget': 'Choose a goal and a target.',
  'goals.dialog.selectedUnavailable': 'The selected goal is no longer available.',
  'goals.dialog.nameRequired': 'Give the goal a name.',
  'goals.dialog.definitionMissing': 'This goal is no longer available.',
  'goals.dialog.goal': 'Goal',
  'goals.dialog.name': 'Name',
  'goals.dialog.target': 'Target',
  'goals.dialog.period': 'Period',
  'goals.period.daily': 'Daily',
  'goals.period.weekly': 'Weekly',
  'goals.period.monthly': 'Monthly',
  'goals.period.quarterly': 'Quarterly',
  'goals.period.yearly': 'Yearly',
  'goals.period.activeGoals': 'Period goals',
  'goals.period.progress': 'Period progress',
  'goals.period.lastDay': 'Last day',
  'goals.period.daysRemaining': '{count} days remaining',
  'goals.period.tabsAria': 'Goal periods',
  'goals.period.addTab': 'Add a period',
  'goals.period.empty': 'No goals for this period',
  'goals.period.emptyHelp': 'Add a goal to start tracking this period.',
  'goals.period.addForPeriod': 'Add a goal — {period}',
  'goals.dialog.description': 'Description',
  'goals.dialog.optional': 'optional',
  'goals.dialog.unit': 'Unit',
  'goals.dialog.quantity': 'Quantity',
  'goals.dialog.duration': 'Duration',
  'goals.dialog.distance': 'Distance',
  'goals.dialog.yesNo': 'Yes / no',
  'goals.dialog.percentage': 'Percentage',
  'goals.dialog.unitLabel': 'Unit label',
  'goals.dialog.loadingSources': 'Loading sources…',
  'goals.dialog.source': 'Source',
  'goals.dialog.tasks': 'Tasks',
  'goals.dialog.routines': 'Routines',
  'goals.dialog.activities': 'Activities',
  'goals.dialog.highlight': 'Highlight',
  'goals.dialog.highlightMetric': 'Highlight metric',
  'goals.dialog.highlightDefined': 'Highlight defined',
  'goals.dialog.highlightCompleted': 'Highlight completed',
  'goals.dialog.calculation': 'Calculation',
  'goals.dialog.countCompleted': 'Completed count',
  'goals.dialog.sumRoutineQuantity': 'Sum routine quantities',
  'goals.dialog.sumRoutineTime': 'Tracked time',
  'goals.dialog.linkMeasuredRoutine': 'Automatically feed this goal from a measured routine',
  'goals.dialog.sourceUnit': 'routine unit',
  'goals.dialog.quantifiedRoutineRequired': 'Select at least one quantified routine.',
  'goals.dialog.sameRoutineUnitRequired': 'Selected routines must use the same unit.',
  'goals.dialog.completionPercent': '% completed / planned',
  'goals.dialog.atLeastOne': 'At least one completed',
  'goals.dialog.scope': 'Scope',
  'goals.dialog.allOccurrences': 'All occurrences',
  'goals.dialog.oneTaskType': 'One task type',
  'goals.dialog.selectedTasks': 'Selected tasks',
  'goals.dialog.oneList': 'One list',
  'goals.dialog.type': 'Type',
  'goals.dialog.recurrent': 'Recurring',
  'goals.dialog.list': 'List',
  'goals.dialog.tasksIncluded': 'Included tasks',
  'goals.dialog.allRoutines': 'All routines',
  'goals.dialog.selectedRoutines': 'Selected routines',
  'goals.dialog.routinesIncluded': 'Included routines',
  'goals.dialog.creating': 'Creating…',
  'goals.dialog.createAdd': 'Create and add',
  'goals.dialog.editTitle': 'Edit goal',
  'goals.dialog.editLoading': 'Loading goal…',
  'goals.dialog.automatic': 'Automatic',
  'goals.dialog.manual': 'Manual',
  'goals.dialog.mode': 'Collection mode',
  'goals.dialog.historyPreserved': 'Changes apply to future periods; existing history is preserved.',
  'goals.dialog.historyLocked': 'The unit and calculation type are locked because this goal already has history.',
  'goals.dialog.saveChanges': 'Save changes',
  'goals.dialog.chooseTaskList': 'Choose a Tasks list.',
  'goals.dialog.selectTask': 'Select at least one task.',
  'goals.dialog.selectRoutine': 'Select at least one routine.',
  'goals.dialog.selectActivity': 'Select at least one activity.',
  'goals.dialog.activitiesIncluded': 'Included activities',
  'goals.dialog.unitLocked': 'The unit can no longer be changed because this goal already has history.',
  'goals.dialog.invalidSourceConfig': 'The source configuration is incompatible with the selected calculation.',
  'goals.dialog.createFailed': 'The goal could not be created.',
  'goals.dialog.editFailed': 'The goal could not be updated.',
  'shared.confirm.title': 'Confirmation',
  'shared.confirm.confirm': 'Confirm',
  'shared.confirm.cancel': 'Cancel'
};

export const EN_TRANSLATIONS: Record<TranslationKey, string> = {

  ...FR_TRANSLATIONS,
  ...EN_TRANSLATION_OVERRIDES
};

export const ES_TRANSLATION_OVERRIDES: Partial<Record<TranslationKey, string>> = {
  'notes.links.categoriesTitle': 'Categorías de notas vinculadas',
  'notes.links.categoriesHelp': 'Las notas de estas categorías son accesibles desde este elemento.',
  'notes.links.categoryEmpty': 'Sin categorías vinculadas.',
  'notes.links.categoriesLoading': 'Cargando categorías…',
  'notes.links.chooseCategory': 'Seleccionar categoría',
  'notes.links.chooseCategoryPlaceholder': 'Seleccionar una categoría…',
  'notes.links.link': 'Vincular',
  'notes.links.remove': 'Quitar',
  'notes.links.notesTitle': 'Notas vinculadas',
  'notes.links.notesEmpty': 'Sin notas vinculadas.',
  'notes.links.notesLoading': 'Cargando notas…',
  'notes.links.chooseNote': 'Seleccionar nota',
  'notes.links.chooseNotePlaceholder': 'Seleccionar una nota existente…',
  'notes.links.newNotePlaceholder': 'Nueva nota vinculada',
  'notes.links.create': 'Crear',
  'notes.links.categoryUpdateError': 'No se pudo actualizar la categoría.',
  'notes.links.categoryLoadError': 'No se han podido cargar las categorías.',
  'notes.links.noteUpdateError': 'No se pudo actualizar el vínculo.',
  'notes.links.noteLoadError': 'No se han podido cargar las notas.',
  'tasks.recurrent.defaultPeriod': 'Franja horaria por defecto',
  'today.noteCategory': 'Categoría',
  'today.noteLinksLoadError': 'Los enlaces a notas no están disponibles.',
  'culture.xlsxExport': "Exportar Excel",
  'culture.xlsxImport': "Importar Excel",
  'culture.xlsxInvalid': "Archivo XLSX no válido o incompatible con el formato Cultura de LifeOps.",
  'culture.xlsxExportError': "No se pudieron exportar los datos de Cultura.",
  'culture.xlsxImportError': "No se pudo importar el libro de Cultura. Comprueba las hojas y referencias.",
  'culture.xlsxImportResult': "Resumen de importación",
  'culture.xlsxItems': "obras",
  'culture.xlsxSeasons': "temporadas",
  'culture.xlsxHistory': "consumos",
  'culture.xlsxLists': "listas",
  'culture.xlsxLinks': "referencias",
  'culture.xlsxSkipped': "ya existentes",
  'culture.xlsxPreview': "Contenido del archivo",
  'culture.xlsxImportHint': "Se reutilizan los elementos existentes cuando es posible. Las fechas, los tipos, las referencias y los estados deben respetar el esquema LifeOps.",
  'culture.xlsxConfirmImport': "Confirmar importación",
  'culture.syncAllRaindrop': "Sincronizar todos los marcadores de Raindrop",
  'culture.dailyChoose': "Elegir las lecturas del día",
  'culture.dailySelected': "Marcadores seleccionados para este día",
  'culture.dailyUnassigned': "Sin franja horaria",
  'culture.dailySlot': "Franja de lectura",
  'culture.dailyRandomCount': "Cantidad para sortear",
  'culture.dailyRandom': "Selección aleatoria",
  'culture.dailyManualHint': "Selecciona artículos manualmente o al azar. No se usan las etiquetas de días.",
  'culture.dailyEmpty': "No hay marcadores de Raindrop pendientes.",
  'culture.dailySelectionError': "No se pudo guardar la selección o su franja. Inténtalo de nuevo.",

  'culture.backToCulture': "Volver a la mediateca",
  'culture.addExisting': "Añadir elemento existente",
  'culture.createItem': "Crear elemento nuevo",
  'culture.filterStatus': "Filtrar por estado",
  'culture.statusLabel': "Estado",
  'culture.status.ALL': "Todos",
  'culture.status.NOT_STARTED': "No empezado",
  'culture.status.IN_PROGRESS': "En curso",
  'culture.status.DONE': "Terminado",
  'culture.cultureLists': "Listas de la mediateca",
  'culture.cultureList': "Lista de contenidos de la mediateca",
  'culture.raindropConfigMissing': "OAuth de Raindrop sin configurar: define los secretos locales de la función (consulta la documentación).",
  'culture.raindropKeyInvalid': "Clave de cifrado de Raindrop inválida: se requiere una clave AES-256 en base64.",
  'culture.raindropFunctionUnavailable': "La función Raindrop de Supabase no está disponible: inicia las Edge Functions locales.",
  'culture.configureType': "Modificar tipo",
  'culture.fieldIdentifier': "Identificador del campo",
  'culture.fieldText': "Texto",
  'culture.fieldNumber': "Número",
  'culture.fieldDate': "Fecha",
  'culture.fieldBoolean': "Sí / No",
  'culture.connectRaindrop': "Conectar cuenta Raindrop",
  'culture.raindropConnected': "Cuenta Raindrop conectada",
  'culture.disconnectRaindrop': "Desconectar Raindrop",
  'culture.raindropAuthError': "No se pudo conectar Raindrop. Comprueba la configuración OAuth.",
  'culture.tagFilter': "Etiqueta a sincronizar",
  'culture.filterBookmarksByTag': "Filtrar marcadores por etiqueta",
  'culture.allBookmarkTags': "Todas las etiquetas",
  'culture.noBookmarksWithTag': "Ningún marcador coincide con esta etiqueta.",
  'culture.addType': "Crear tipo",
  'culture.lists': "Listas",
  'culture.listName': "Nombre de la lista",
  'culture.createList': "Crear lista",
  'culture.addField': "Añadir campo",
  'culture.fieldLabel': "Nombre del campo",
  'culture.consumed': "Consumido",
  'culture.confirmDeleteBookmark': "¿Eliminar este marcador?",
  'culture.removeFromList': "Quitar de la lista",
  'culture.plans': "Planificación",
  'culture.planPool': "Planificar un grupo",
  'culture.planBookmark': "Planificar marcador",
  'culture.targetCount': "Objetivo de elementos",
  'culture.date': "Fecha",
  'culture.emptyPlans': "No hay contenido planificado.",
  'culture.poolBookmarks': "Contenidos del grupo",
  'culture.poolHelp': "Selecciona una lista arriba y marca como terminados los elementos consultados.",
  'culture.edit': "Modificar",
  'culture.delete': "Eliminar",
  'culture.confirmDelete': "¿Eliminar esta obra y su historial?",
  'culture.addSeason': "Añadir temporada",
  'culture.author': "Autor",
  'culture.category': "Categoría",
  'culture.theme': "Tema",
  'culture.year': "Año",
  'culture.language': "Idioma",
  'culture.pages': "Páginas",
  'culture.releaseDate': "Fecha de estreno",
  'culture.director': "Director",
  'culture.genre': "Género",
  'culture.country': "País",
  'culture.seasonNumber': "Número de temporada",
  'culture.episodeCount': "Número de episodios",
  'culture.addToList': "Añadir a la lista",
  'culture.chooseList': "Elegir una lista",
  'culture.syncRaindrop': "Sincronizar Raindrop",
  'culture.syncHelp': "Usa temporalmente tu token de prueba de Raindrop. LifeOps no guarda el token.",
  'culture.token': "Token Raindrop",
  'culture.sync': "Sincronizar",
  'culture.syncing': "Sincronizando…",
  'culture.syncSuccess': "Marcadores procesados",
  'culture.syncFailed': "No se pudo sincronizar Raindrop.",
  'culture.chooseTag': "Elegir una etiqueta",
  'culture.completeBookmark': "Completar",
  'culture.reopenBookmark': "Marcar como pendiente",
  'culture.showCompleted': 'Mostrar completados',
  'culture.pickRandom': 'Selección aleatoria',
  'culture.scheduleSelected': 'Planificar selección',
  'culture.selectBookmark': 'Seleccionar este marcador',
  'culture.selectAllFilteredRaindrops': 'Seleccionar todos los Raindrops filtrados',
  'culture.deselectAllFilteredRaindrops': 'Deseleccionar Raindrops filtrados',
  'culture.deleteAllSelectedRaindrops': 'Eliminar todos los seleccionados',
  'culture.deleteRaindrop': 'Eliminar este Raindrop de LifeOps',
  'culture.confirmDeleteRaindrops': '¿Eliminar definitivamente estos Raindrops de LifeOps?',
  'culture.raindropLocalDeleteHint': 'Los marcadores seguirán en Raindrop.io. Una nueva sincronización puede volver a importarlos.',
  'culture.raindropDeleteFailed': 'La eliminación ha fallado o está incompleta. Se ha recargado la lista: comprueba los marcadores restantes.',
  'culture.xlsxImportMode': 'Modo de importación',
  'culture.xlsxImportFree': 'Importación libre',
  'culture.xlsxImportList': 'Importar en una lista',
  'culture.xlsxChooseList': 'Elegir una lista',
  'culture.xlsxNewList': 'Crear una lista',
  'culture.hideCompleted': 'Ocultar completados',
  'culture.raindropStatusFailed': "Error al sincronizar el estado. Comprueba Raindrop y vuelve a intentarlo; LifeOps no ha confirmado el cambio.",
  'culture.homeDescription': 'Organiza libros, películas, series y artículos.',
  'culture.title': "Mediateca",
  'culture.add': "Añadir",
  'culture.works': "Obras",
  'culture.history': "Historial",
  'culture.bookmarks': "Marcadores web",
  'culture.loading': "Cargando…",
  'culture.loadError': "No se han podido cargar los datos.",
  'culture.saveError': "No se ha podido guardar.",
  'culture.emptyWorks': "No hay obras guardadas.",
  'culture.emptyHistory': "No hay consumos registrados.",
  'culture.emptyBookmarks': "No hay marcadores guardados.",
  'culture.type': "Tipo",
  'culture.book': "Libro",
  'culture.movie': "Película",
  'culture.series': "Serie",
  'culture.podcast': "Episodio de pódcast",
  'culture.name': "Título",
  'culture.choose': "Elegir una obra",
  'culture.startDate': "Fecha de inicio",
  'culture.endDate': "Fecha de fin",
  'culture.rating': "Nota sobre 10",
  'culture.comment': "Comentario",
  'culture.article': "Artículo",
  'culture.video': "Vídeo",
  'culture.other': "Otro",
  'culture.backlog': "Pendiente",
  'culture.planned': "Planificado",
  'culture.done': "Terminado",
  'culture.cancel': "Cancelar",
  'culture.saving': "Guardando…",
  'culture.save': "Guardar",
  'mealsV2.addRecipeToSession': 'Añadir receta',
  'mealsV2.addPreparedDish': 'Añadir preparación',
  'mealsV2.addFoodToConsumption': 'Añadir alimento',
  'mealsV2.viewDetails': 'Ver detalle',
  'mealsV2.consumptionDetails': 'Detalle del consumo',
  'mealsV2.editConsumption': 'Modificar consumo',
  'mealsV2.nutritionEstimate': 'Aporte nutricional estimado',
  'mealsV2.macros': 'Macronutrientes',
  'mealsV2.unknownNutrition': 'No disponible',
  'mealsV2.portionPlural': 'porciones',
  'mealsV2.noConsumption': 'No hay comidas registradas',
  'mealsV2.noLinesAvailable': 'No se puede modificar este consumo porque su preparación original ya no está disponible.',
  'mealsV2.sourceSnapshot': 'Valores guardados al registrar el consumo',
  'mealsV2.addMeal': 'Registrar comida',
  'mealsV2.uncook': 'Marcar como no cocinada',
  'mealsV2.editSession': 'Editar platos e ingredientes',
  'mealsV2.shoppingResult': '{added} ingrediente(s) añadido(s) · {skipped} ya presente(s)',
  'mealsV2.saving': 'Guardando…',
  'mealsV2.addIngredientInRecipe': 'Crear ingrediente',
  'mealsV2.unitPiece': 'Unidad',
  'mealsV2.unitFree': 'Libre',
  'mealsV2.title': 'Comidas',
  'mealsV2.ingredients': 'Ingredientes',
  'mealsV2.recipes': 'Recetas',
  'mealsV2.consumed': 'Comidas consumidas',
  'mealsV2.shopping': 'Lista de compra',
  'mealsV2.name': 'Nombre',
  'mealsV2.unit': 'Unidad de referencia',
  'mealsV2.kcal': 'Calorías',
  'mealsV2.protein': 'Proteínas',
  'mealsV2.carbs': 'Carbohidratos',
  'mealsV2.fat': 'Grasas',
  'mealsV2.newIngredient': 'Nuevo ingrediente',
  'mealsV2.newRecipe': 'Nueva receta',
  'mealsV2.instructions': 'Instrucciones',
  'mealsV2.servings': 'Porciones de la receta',
  'mealsV2.quantity': 'Cantidad',
  'mealsV2.addLine': 'Añadir ingrediente',
  'mealsV2.add': 'Añadir',
  'mealsV2.save': 'Guardar',
  'mealsV2.cancel': 'Cancelar',
  'mealsV2.edit': 'Editar',
  'mealsV2.delete': 'Eliminar',
  'mealsV2.date': 'Fecha',
  'mealsV2.portion': 'Porciones consumidas',
  'mealsV2.log': 'Registrar comida',
  'mealsV2.choose': 'Elegir',
  'mealsV2.list': 'Lista',
  'mealsV2.toList': 'Añadir ingredientes seleccionados',
  'mealsV2.selectAll': 'Seleccionar todo',
  'mealsV2.empty': 'Sin datos.',
  'mealsV2.confirm': '¿Confirmar eliminación?',
  'mealsV2.error': 'No se pudo completar.',
  'mealsV2.nutrition': 'Nutrición estimada por receta',
  'mealsV2.g': 'g',
  'mealsV2.perUnit': 'Valores por unidad de referencia (g, ml o pieza)',
  'mealsV2.shoppingHelp': 'Selecciona los ingredientes necesarios y añádelos a una lista existente.',
  'mealsV2.day': 'Día previsto',
  'mealsV2.session': 'Sesión de cocina',
  'mealsV2.newSession': 'Nueva sesión de cocina',
  'mealsV2.cooked': 'Cocinado',
  'mealsV2.markCooked': 'Marcar como cocinado',
  'mealsV2.produced': 'Porciones reales preparadas',
  'mealsV2.theoretical': 'Recetas teóricas',
  'mealsV2.realIngredients': 'Composición real (editable)',
  'mealsV2.addFood': 'Añadir alimento',
  'mealsV2.consumeReal': 'Consumo real',
  'mealsV2.cookedPreparation': 'Preparación cocinada',
  'mealsV2.singleFood': 'Alimento individual',
  'mealsV2.portionUnit': 'Porción',
  'mealsV2.fractionUnit': 'Fracción del plato completo',
  'mealsV2.nutritionBasis': 'Base nutricional',
  'mealsV2.optionalNutrition': 'Los nutrientes son opcionales. Déjalos vacíos si son desconocidos.',
  'mealsV2.onePortion': 'Receta de referencia para una porción.',
  'mealsV2.partial': 'Estimación parcial',
  'mealsV2.recipeSelect': 'Elegir receta',
  'mealsV2.addPreparation': 'Añadir preparación',
  'mealsV2.addSingleFood': 'Añadir alimento',
  'today.title': 'Hoy',
  'calendar.title': 'Calendario',
  'product.today': 'Hoy',
  'product.todo': 'To Do',
  'product.highlight': 'Highlight',
  'product.template': 'Plantilla',
  'common.actions.add': 'Añadir',
  'common.actions.archive': 'Archivar',
  'common.actions.back': 'Volver',
  'common.actions.cancel': 'Cancelar',
  'common.actions.close': 'Cerrar',
  'common.actions.create': 'Crear',
  'common.actions.delete': 'Eliminar',
  'common.actions.deleteForever': 'Eliminar definitivamente',
  'common.actions.edit': 'Editar',
  'common.actions.open': 'Abrir',
  'common.actions.remove': 'Quitar',
  'common.actions.rename': 'Renombrar',
  'common.actions.reopen': 'Reabrir',
  'common.actions.retry': 'Reintentar',
  'common.actions.save': 'Guardar',
  'common.actions.link': 'Vincular',
  'common.actions.choose': 'Elegir…',
  'common.actions.up': 'Subir',
  'common.actions.down': 'Bajar',
  'common.loading': 'Cargando…',
  'common.saving': 'Guardando…',
  'common.deleting': 'Eliminando…',
  'common.none': 'Ninguna',
  'common.yes': 'Sí',
  'common.no': 'No',
  'common.history': 'Historial',
  'common.title': 'Título',
  'common.description': 'Descripción',
  'common.priority': 'Prioridad',
  'common.actionsLabel': 'Acciones',
  'product.tasks': 'Tareas',
  'product.calendar': 'Calendario',
  'product.goals': 'Objetivos',
  'product.lists': 'Listas',
  'product.domains': 'Dominios',
  'product.measurements': 'Medidas',
  'navigation.overview': 'Vista general',

  'product.notes': 'Notas',
  'product.activities': 'Actividades',
  'product.sport': 'Deporte',
  'product.routines': 'Rutinas',
  'product.settings': 'Ajustes',
  'product.meals': 'Comidas',
  'app.homeAria': 'Inicio de LifeOps',
  'app.backHomeAria': 'Volver al inicio',
  'app.signOut': 'Cerrar sesión',
  'app.signIn': 'Iniciar sesión',
  'app.settings': 'Ajustes',
  'navigation.main': 'Navegación principal',
  'navigation.open': 'Abrir navegación',
  'navigation.close': 'Cerrar navegación',
  'navigation.backTo': 'Volver a {destination}',
  'navigation.destination.home': 'Inicio',
  'navigation.destination.previousPage': 'la página anterior',
  'navigation.activeTimer.one': '{count} cronómetro activo',
  'navigation.activeTimer.many': '{count} cronómetros activos',
  'auth.login.title': 'Iniciar sesión en LifeOps',
  'auth.login.subtitle': 'Inicia sesión con tu correo electrónico y contraseña.',
  'auth.password': 'Contraseña',
  'auth.emailRequired': 'El correo electrónico es obligatorio.',
  'auth.emailInvalid': 'Introduce un correo electrónico válido.',
  'auth.login.loading': 'Iniciando sesión…',
  'auth.login.submit': 'Iniciar sesión',
  'auth.login.createAccount': 'Crear una cuenta',
  'auth.login.accountDeleted': 'Tu cuenta de LifeOps y todos sus datos se han eliminado definitivamente.',
  'auth.login.forgotPassword': '¿Has olvidado la contraseña?',
  'auth.recovery.requestTitle': 'Restablecer la contraseña',
  'auth.recovery.requestSubtitle': 'Introduce tu correo electrónico. Si existe una cuenta asociada, recibirás un enlace para elegir una nueva contraseña.',
  'auth.recovery.requestSubmit': 'Enviar enlace',
  'auth.recovery.requestLoading': 'Enviando…',
  'auth.recovery.requestSuccess': 'Si existe una cuenta asociada a esta dirección, se ha enviado un correo de recuperación.',
  'auth.recovery.backToLogin': 'Volver al inicio de sesión',
  'auth.recovery.updateTitle': 'Elegir una nueva contraseña',
  'auth.recovery.updateSubtitle': 'Elige una nueva contraseña para tu cuenta LifeOps.',
  'auth.recovery.checkingLink': 'Verificando el enlace de recuperación…',
  'auth.recovery.invalidTitle': 'Enlace de recuperación no válido',
  'auth.recovery.invalidLink': 'Este enlace no es válido, ha caducado o ya se ha utilizado. Solicita un nuevo enlace de recuperación.',
  'auth.recovery.requestAnother': 'Solicitar un nuevo enlace',
  'auth.recovery.newPassword': 'Nueva contraseña',
  'auth.recovery.confirmPassword': 'Confirmar nueva contraseña',
  'auth.recovery.updateSubmit': 'Guardar nueva contraseña',
  'auth.recovery.updateLoading': 'Guardando…',
  'auth.recovery.updateError': 'No se ha podido actualizar la contraseña. Solicita un nuevo enlace si el problema continúa.',
  'auth.signup.title': 'Crear una cuenta LifeOps',
  'auth.signup.subtitle': 'Cada cuenta tiene sus propios datos privados.',
  'auth.signup.name': 'Nombre',
  'auth.signup.language': 'Idioma',
  'auth.signup.languageHelp': 'Este idioma se usará para la interfaz y para los nombres iniciales de los ejes de Calendario.',
  'auth.signup.confirmPassword': 'Confirmar contraseña',
  'auth.signup.loading': 'Creando…',
  'auth.signup.submit': 'Crear mi cuenta',
  'auth.signup.enableHint': 'Para activar «Crear mi cuenta»:',
  'auth.signup.nameRequired': 'introduce tu nombre.',
  'auth.signup.nameLength': 'el nombre debe tener entre 2 y 80 caracteres.',
  'auth.signup.emailRequired': 'introduce tu correo electrónico.',
  'auth.signup.emailInvalid': 'introduce un correo electrónico válido.',
  'auth.signup.passwordRequired': 'introduce una contraseña.',
  'auth.signup.passwordLength': 'usa al menos 10 caracteres para la contraseña.',
  'auth.signup.confirmRequired': 'confirma tu contraseña.',
  'auth.signup.passwordsMatch': 'las dos contraseñas deben ser iguales.',
  'auth.signup.haveAccount': 'Ya tengo una cuenta',
  'auth.signup.errorNameLength': 'El nombre debe tener entre 2 y 80 caracteres.',
  'auth.signup.errorPasswordLength': 'La contraseña debe tener al menos 10 caracteres.',
  'auth.signup.errorPasswordsMismatch': 'Las contraseñas no coinciden.',
  'auth.signup.successConfirmEmail': 'Cuenta creada. Revisa tu correo para confirmar el registro.',
  'auth.error.invalidCredentials': 'Correo electrónico o contraseña incorrectos.',
  'auth.error.emailRegistered': 'Ya existe una cuenta con este correo electrónico.',
  'auth.error.weakPassword': 'La contraseña no cumple los requisitos de seguridad.',
  'auth.error.network': 'No se puede conectar con LifeOps. Comprueba tu conexión a Internet y vuelve a intentarlo.',
  'auth.error.serviceUnavailable': 'El servicio no está disponible temporalmente. Vuelve a intentarlo en unos instantes.',
  'auth.error.rateLimit': 'Se han realizado demasiadas solicitudes. Vuelve a intentarlo en unos instantes.',
  'auth.error.signIn': 'No se ha podido iniciar sesión. Vuelve a intentarlo.',
  'auth.error.signUp': 'No se ha podido crear la cuenta. Vuelve a intentarlo.',
  'home.personalSpace': 'Tu espacio personal',
  'home.intro': 'Tus espacios del día a día reunidos en una navegación clara, sin jerarquía entre dominios.',
  'home.spacesAria': 'Los ocho espacios de LifeOps',
  'home.connectedSpaces': '8 espacios conectados',
  'home.oneVision': 'Una sola visión',
  'home.yourSpaces': 'Tus espacios',
  'home.whereStart': '¿Por dónde quieres empezar?',
  'home.chooseSpace': 'Elige un espacio para pasar de la intención a la acción.',
  'home.todayDescription': 'Mira todo lo que importa para tu día.',
  'home.todayAction': 'Abrir mi día',
  'home.tasksDescription': 'Crea, programa y completa tus acciones.',
  'home.explore': 'Explorar',
  'home.calendarDescription': 'Planifica y recorre tus semanas.',
  'home.plan': 'Planificar',
  'home.goalsDescription': 'Define tus objetivos y sigue tu progreso.',
  'home.notesDescription': 'Guarda tus notas personales en un espacio dedicado.',
  'home.activitiesDescription': 'Accede a tus actividades y al seguimiento del tiempo.',
  'home.sportDescription': 'Crea tus deportes, planifica sesiones y registra resultados reales.',
  'home.listsDescription': 'Gestiona listas permanentes de forma independiente de las tareas.',
  'home.domainsDescription': 'Gestiona tus dominios y sus propiedades.',
  'domains.subtitle': 'Agrupa tus elementos de LifeOps por grandes ámbitos de vida.',
  'domains.namePlaceholder': 'Ej. Deporte, Trabajo, Cultura…',
  'domains.color': 'Color del dominio',
  'domains.palettePreview': 'Vista previa de 5 tonos',
  'domains.color.blue': 'Azul',
  'domains.color.red': 'Rojo',
  'domains.color.orange': 'Naranja',
  'domains.color.green': 'Verde',
  'domains.color.purple': 'Morado',
  'domains.color.teal': 'Turquesa',
  'domains.color.pink': 'Rosa',
  'domains.color.gray': 'Gris',
  'domains.showArchived': 'Mostrar dominios archivados',
  'domains.createAction': 'Crear dominio',
  'domains.editAction': 'Editar dominio',
  'domains.openDomain': 'Abrir dominio',
  'domains.empty': 'Todavía no hay dominios.',
  'domains.assignment': 'Dominio',
  'domains.loadError': 'No se han podido cargar los dominios.',
  'domains.deleteConfirm': '¿Eliminar «{name}»? Los elementos asociados se conservarán sin dominio.',
  'domains.shortcutsTitle': 'Mis dominios',
  'domains.homeFilter': 'Filtrar por dominio',
  'domains.allDomains': 'Todos los dominios',
  'domains.entryHelp': 'Elige un módulo para abrirlo filtrado por este dominio.',
  'domains.filteredModule': 'Mostrar solo los elementos de {name}.',
  'domains.notFound': 'No se encuentra este dominio.',
  'domains.hideShortcut': 'Ocultar acceso directo',
  'domains.showShortcut': 'Mostrar acceso directo',
  'home.progress': 'Ver mi progreso',
  'notes.navigationPlaceholder': 'Notas ya está disponible desde la navegación principal. La gestión completa de notas se entregará por separado.',
  'activities.navigationPlaceholder': 'Actividades ya está disponible desde la navegación principal. La gestión completa de actividades se entregará por separado.',
  'activities.eyebrow': 'Seguimiento del tiempo',
  'activities.subtitle': 'Planifica tus actividades en Calendar y mide aquí el tiempo realmente dedicado.',
  'activities.backToTasks': 'Volver a tareas',
  'activities.taskSessionSource': 'Esta sesión está vinculada a una tarea y sigue separada de Activities.',
  'activities.quickCreateTitle': 'Creación rápida',
  'activities.quickCreateHelp': 'Solo necesitas un nombre. La misma actividad se puede planificar varias veces y cronometrar cuando quieras.',
  'activities.nameLabel': 'Nombre de la actividad',
  'activities.namePlaceholder': 'Ej. Lectura',
  'activities.create': 'Crear actividad',
  'activities.loading': 'Cargando actividades y cronómetros…',
  'activities.loadError': 'No se han podido cargar las actividades o el seguimiento del tiempo. Inténtalo de nuevo.',
  'activities.activeTitle': 'Actividades activas',
  'activities.activeHelp': 'Actividades disponibles para el calendario y nuevos cronómetros.',
  'activities.empty': 'No hay ninguna actividad activa. Crea una aquí o desde el calendario.',
  'activities.reusable': 'Actividad reutilizable',
  'activities.archived': 'Actividad archivada',
  'activities.showArchived': 'Mostrar actividades archivadas ({count})',
  'activities.restore': 'Restaurar',
  'activities.archiveAria': 'Archivar {name}',
  'activities.restoreAria': 'Restaurar {name}',
  'activities.archiveConfirmTitle': '¿Archivar esta actividad?',
  'activities.archiveConfirmMessage': '¿Archivar «{name}»? Se conservarán su historial y sus cronómetros. Un cronómetro ya activo no se detendrá.',
  'activities.activeTimersTitle': 'Cronómetros activos',
  'activities.activeTimersHelp': 'Pueden funcionar varios cronómetros al mismo tiempo. Las duraciones son acumulativas.',
  'activities.startTimer': 'Iniciar',
  'activities.startTimerAria': 'Iniciar un cronómetro para {name}',
  'activities.stopTimer': 'Detener',
  'activities.cancelTimer': 'Cancelar cronómetro',
  'activities.cancelTimerConfirmTitle': '¿Cancelar este cronómetro?',
  'activities.cancelTimerConfirmMessage': 'Este cronómetro activo se eliminará sin crear una sesión histórica.',
  'activities.elapsedTime': 'Tiempo transcurrido',
  'activities.longTimerWarning': 'Cronómetro activo desde hace más de 12 h — comprueba la hora de inicio.',
  'activities.runningCount': '{count} activo(s)',
  'activities.today': 'Hoy',
  'activities.week': 'Esta semana',
  'activities.totalsAria': 'Tiempo acumulado para {name}',
  'activities.unknownActivity': 'Actividad',
  'activities.historyTitle': 'Sesiones',
  'activities.historyHelp': 'Consulta y corrige el tiempo registrado, día a día.',
  'activities.historyDate': 'Fecha del historial',
  'activities.previousDay': 'Día anterior',
  'activities.nextDay': 'Día siguiente',
  'activities.historyEmpty': 'No hay ninguna sesión terminada para esta fecha.',
  'activities.sessionEditorEyebrow': 'SESIÓN',
  'activities.sessionTimezone': 'Zona horaria histórica: {timezone}',
  'activities.sessionStart': 'Inicio',
  'activities.sessionEnd': 'Fin',
  'activities.activeSessionEndHelp': 'Déjalo vacío para mantener el cronómetro activo.',
  'activities.sessionNote': 'Comentario',
  'activities.sessionNotePlaceholder': 'Ej. Trabajo concentrado, capítulo leído…',
  'activities.tags': 'Etiquetas',
  'activities.chooseExistingTag': 'Añadir una etiqueta existente…',
  'activities.newTagPlaceholder': 'Nueva etiqueta',
  'activities.createTag': 'Crear etiqueta',
  'activities.removeTagAria': 'Quitar la etiqueta {name}',
  'activities.now': 'ahora',
  'activities.deleteSessionConfirmTitle': '¿Eliminar esta sesión?',
  'activities.deleteSessionConfirmMessage': 'La sesión y sus asociaciones de etiquetas se eliminarán definitivamente.',
  'tasks.time.sectionAria': 'Seguimiento de tiempo para {title}',
  'tasks.time.start': 'Cronómetro',
  'tasks.time.openActivities': 'Ver en Actividades',
  'tasks.time.startAria': 'Iniciar un cronómetro para {title}',
  'tasks.time.history': 'Tiempo registrado',
  'tasks.time.cancelTimerTitle': '¿Cancelar este cronómetro?',
  'tasks.time.cancelTimerMessage': 'El cronómetro activo de « {title} » se eliminará sin crear una sesión histórica.',
  'tasks.time.activeOnClose': 'Hay {count} cronómetro(s) activo(s) vinculados a esta tarea. Elige explícitamente qué hacer.',
  'tasks.time.completeKeepRunning': 'Completar y mantener activo',
  'tasks.time.completeAndStop': 'Completar y detener',
  'tasks.time.cancelKeepRunning': 'Cancelar tarea y mantener activo',
  'tasks.time.cancelAndStop': 'Cancelar tarea y detener',
  'tasks.time.changeStatusKeepRunning': 'Cambiar estado y mantener activo',
  'tasks.time.changeStatusAndStop': 'Cambiar estado y detener',
  'tasks.time.statusDecisionTitle': '¿Qué hacer con el cronómetro activo?',
  'tasks.time.editInActivities': 'Las sesiones se pueden corregir desde el historial de Activities.',
  'tasks.time.deleteKeepsHistory': 'Esta tarea tiene tiempo registrado: se retirará de Tasks, pero se conservará su historial temporal.',
  'tasks.time.taskSession': 'Sesión de tarea',
  'settings.title': 'Ajustes',
  'settings.raindrop.title': "Raindrop",
  'settings.raindrop.description': "Gestiona la conexión de tu cuenta de Raindrop con LifeOps.",
  'settings.raindrop.connected': "Cuenta de Raindrop conectada",
  'settings.raindrop.notConnected': "Cuenta de Raindrop no conectada",
  'settings.raindrop.unknown': "Estado de conexión no disponible",
  'settings.raindrop.connect': "Conectar Raindrop",
  'settings.raindrop.disconnect': "Desconectar Raindrop",
  'settings.raindrop.retry': "Reintentar",
  'settings.raindrop.confirmTitle': "¿Desconectar Raindrop?",
  'settings.raindrop.confirmHelp': "LifeOps dejará de sincronizar tus marcadores hasta que vuelvas a conectar la cuenta. Los marcadores y el historial ya guardados en LifeOps se conservarán.",
  'settings.raindrop.confirm': "Confirmar desconexión",
  'settings.raindrop.disconnecting': "Desconectando…",
  'settings.raindrop.disconnected': "Raindrop se ha desconectado. Puedes volver a conectar tu cuenta en cualquier momento.",
  'settings.raindrop.loadError': "No se pudo comprobar la conexión de Raindrop. Inténtalo de nuevo.",
  'settings.raindrop.connectError': "No se pudo iniciar la conexión con Raindrop. Inténtalo de nuevo.",
  'settings.raindrop.disconnectError': "No se pudo desconectar Raindrop. Se ha mantenido la conexión.",
  'settings.profile.title': 'Perfil',
  'settings.profile.description': 'Cambia el nombre mostrado en LifeOps. Tu correo sigue vinculado a tu cuenta y no se puede modificar aquí.',
  'settings.profile.email': 'Correo electrónico',
  'settings.profile.emailReadonly': 'El correo electrónico es de solo lectura.',
  'settings.profile.username': 'Nombre mostrado',
  'settings.profile.usernameHelp': 'Entre 2 y 80 caracteres. Se eliminan los espacios al principio y al final.',
  'settings.profile.save': 'Guardar perfil',
  'settings.profile.saving': 'Guardando…',
  'settings.profile.saved': 'Perfil guardado.',
  'settings.profile.invalidUsername': 'El nombre mostrado debe contener entre 2 y 80 caracteres después de eliminar los espacios al principio y al final.',
  'settings.profile.loadError': 'No se ha podido cargar tu perfil. Vuelve a intentarlo.',
  'settings.profile.error': 'No se ha podido guardar el perfil. Vuelve a intentarlo.',
  'settings.deleteAccount.title': 'Zona sensible',
  'settings.deleteAccount.description': 'La eliminación de la cuenta es definitiva y borra todos tus datos de LifeOps.',
  'settings.deleteAccount.open': 'Eliminar cuenta',
  'settings.deleteAccount.eyebrow': 'ELIMINACIÓN DEFINITIVA',
  'settings.deleteAccount.confirmTitle': '¿Eliminar definitivamente tu cuenta?',
  'settings.deleteAccount.irreversible': 'Esta operación es irreversible. No podrás recuperar tu cuenta después de eliminarla.',
  'settings.deleteAccount.deleteProfile': 'Se eliminará tu perfil de LifeOps.',
  'settings.deleteAccount.deleteData': 'Se eliminarán todas tus tareas, listas, notas, actividades, calendarios, objetivos y demás datos.',
  'settings.deleteAccount.deleteHistory': 'Se eliminarán tus preferencias, historiales y plantillas.',
  'settings.deleteAccount.loseAccess': 'Se revocarán todas tus sesiones y tus antiguas credenciales ya no permitirán iniciar sesión.',
  'settings.deleteAccount.exportOffer': 'Puedes descargar una copia JSON antes de eliminar la cuenta. Esta exportación es opcional.',
  'settings.deleteAccount.exportNow': 'Exportar mis datos antes de eliminar',
  'settings.deleteAccount.confirmationLabel': 'Para confirmar, escribe exactamente esta frase:',
  'settings.deleteAccount.passwordLabel': 'Contraseña actual',
  'settings.deleteAccount.finalWarning': 'Al confirmar, tus datos actuales se eliminarán definitivamente. Esta acción no se puede deshacer.',
  'settings.deleteAccount.confirm': 'Eliminar definitivamente',
  'settings.deleteAccount.deleting': 'Eliminando…',
  'settings.deleteAccount.invalidPassword': 'La contraseña es incorrecta.',
  'settings.deleteAccount.confirmationMismatch': 'La frase de confirmación no coincide exactamente.',
  'settings.deleteAccount.confirmationMismatchHint': 'La frase debe coincidir exactamente con « SUPPRIMER MON COMPTE ». Se ignoran los espacios al principio y al final.',
  'settings.deleteAccount.reauthExpired': 'La reautenticación ha caducado. Introduce de nuevo tu contraseña.',
  'settings.deleteAccount.error': 'La eliminación de la cuenta ha fallado. La cuenta no se considera eliminada.',

  'settings.subtitle': 'Personaliza tu experiencia LifeOps.',
  'settings.backHome': '← Inicio',
  'settings.language.title': 'Idioma',
  'settings.language.description': 'El idioma de la interfaz se guarda en tu perfil y se aplica inmediatamente.',
  'settings.language.label': 'Idioma de la interfaz',
  'settings.language.saved': 'Idioma guardado.',
  'settings.language.error': 'No se ha podido guardar el idioma. Vuelve a intentarlo.',
  'settings.backup.title': 'Copia de seguridad de datos',
  'settings.backup.description': 'Descarga una copia JSON completa y restaurable de tus datos de LifeOps.',
  'settings.backup.contentsTitle': 'Contenido de la copia',
  'settings.backup.contents': 'Perfil de LifeOps, tareas e historial, rutinas, listas, calendario, actividades y cronómetros, notas, comidas, satisfacción, objetivos y todas las plantillas relacionadas.',
  'settings.backup.restoreHelp': 'El archivo conserva los identificadores de origen y las relaciones necesarias para una futura restauración. Los identificadores de propietario se reasignarán a la cuenta autenticada durante la restauración.',
  'settings.backup.export': 'Exportar todos mis datos',
  'settings.backup.exporting': 'Creando copia de seguridad…',
  'settings.backup.success': 'Copia generada el {generatedAt}.',
  'settings.backup.error': 'No se ha podido generar la copia completa. No se ha descargado ningún archivo incompleto.',
  'settings.restore.choose': 'Restaurar una copia',
  'settings.restore.preparing': 'Comprobando la copia…',
  'settings.restore.eyebrow': 'RESTAURACIÓN',
  'settings.restore.confirmTitle': '¿Restaurar los datos a partir de la copia del {generatedAt}?',
  'settings.restore.confirmHelp': 'Revisa esta copia antes de continuar. No se escribe ningún dato hasta que confirmes.',
  'settings.restore.file': 'Archivo',
  'settings.restore.backupDate': 'Fecha de la copia',
  'settings.restore.rows': 'Elementos',
  'settings.restore.atomicWarning': 'La restauración es atómica: si algún dato o relación no puede restaurarse, no se conserva ningún cambio.',
  'settings.restore.replaceExistingWarning': 'Esta cuenta ya contiene {count} fila(s) de datos. Se sustituirán por el estado de esta copia. Si la restauración falla, los datos actuales se conservarán gracias al rollback transaccional.',
  'settings.restore.confirm': 'Restaurar',
  'settings.restore.restoring': 'Restaurando…',
  'settings.restore.success': 'Restauración terminada: {count} elemento(s) restaurado(s).',
  'settings.restore.targetNotEmpty': 'Esta cuenta ya contiene datos. La restauración V1 requiere una cuenta vacía.',
  'settings.restore.invalidFile': 'Este archivo no es una copia de LifeOps compatible o está incompleto.',
  'settings.restore.error': 'La restauración ha fallado. No se ha conservado ninguna restauración parcial.',
  'lists.myLists': 'Mis listas',
  'lists.new': 'Nueva lista',
  'lists.edit': 'Editar la lista',
  'lists.type': 'Tipo de lista',
  'lists.kind.checklist': 'Checklist — elementos para marcar',
  'lists.kind.backlog': 'Backlog — cola ordenada de elementos',
  'lists.kind.collection': 'Colección — elementos sin estado completado',
  'lists.kind.collectionShort': 'Colección',
  'lists.checklistHelp': 'Ideal para una lista de compras permanente: marca las compras y después limpia los elementos comprados sin eliminar la lista.',
  'lists.archiveThis': 'Archivar esta lista',
  'lists.subtitle': 'Listas permanentes e independientes de las tareas que puedes reutilizar tantas veces como necesites.',
  'lists.loading': 'Cargando listas…',
  'lists.empty': 'No hay listas activas. Por ejemplo, crea una lista de Compras y vincúlala a una tarea recurrente.',
  'lists.showArchived': 'Mostrar listas archivadas ({count})',
  'lists.archived': 'Archivada',
  'lists.restore': 'Restaurar',
  'lists.summaryAria': 'Resumen de la lista',
  'lists.activeCount': '{count} activos',
  'lists.completedCount': '{count} marcados',
  'lists.linkedTaskCount': '{count} tareas vinculadas',
  'lists.back': '← Mis listas',
  'lists.loadingOne': 'Cargando la lista…',
  'lists.archivedBanner': 'Esta lista está archivada. Su contenido y asociaciones siguen visibles, pero las modificaciones están desactivadas.',
  'lists.section.todo': 'A completar',
  'lists.section.backlog': 'Backlog activo',
  'lists.section.items': 'Elementos',
  'lists.permanentHelp': 'La lista permanece: marca las compras a medida que avanzas y limpia solo los elementos comprados.',
  'lists.newItem': 'Nuevo elemento',
  'lists.itemPlaceholder': 'Ej. Leche',
  'lists.noActiveItems': 'No hay elementos activos en esta lista.',
  'lists.markCompletedAria': 'Marcar {title} como completado',
  'lists.renameAria': 'Renombrar {title}',
  'lists.subitem': 'Subelemento',
  'lists.subitemPlaceholder': 'Nombre del subelemento',
  'lists.completedPurchased': 'Comprados / completados',
  'lists.completed': 'Completados',
  'lists.completedHelp': 'Estos elementos permanecen en la lista hasta que los limpies.',
  'lists.purgeCompleted': 'Limpiar elementos marcados',
  'lists.linkedTasks': 'Tareas vinculadas',
  'lists.linkedTasksHelp': 'El vínculo apunta a la definición de la tarea: completar o cancelar una ocurrencia nunca modifica esta lista.',
  'lists.noLinkedTasks': 'No hay tareas vinculadas.',
  'lists.linkExistingTask': 'Vincular una tarea existente',
  'lists.chooseTask': 'Elegir una tarea…',
  'lists.detachAria': 'Desvincular {title}',
  'lists.taskArchived': 'archivada',
  'lists.loadError': 'No se han podido cargar las listas. Vuelve a intentarlo en unos instantes.',
  'lists.loadOneError': 'No se ha podido cargar esta lista. Vuelve a intentarlo en unos instantes.',
  'lists.confirm.removeItemTitle': '¿Quitar este elemento?',
  'lists.confirm.removeItem': '¿Quitar este elemento de la lista activa? Sus subelementos también se archivarán.',
  'lists.confirm.removeSubitem': '¿Quitar este subelemento de la lista activa?',
  'lists.confirm.purgeTitle': '¿Quitar los elementos marcados?',
  'lists.confirm.purge': '¿Quitar todos los elementos marcados de la lista activa? Permanecerán archivados en el historial.',
  'lists.confirm.archiveTitle': '¿Archivar la lista?',
  'lists.confirm.deleteTitle': '¿Eliminar la lista?',
  'lists.confirm.archive': 'Esta lista tiene historial o tareas vinculadas. Se archivará y seguirá disponible. ¿Continuar?',
  'lists.confirm.delete': '¿Eliminar definitivamente esta lista vacía?',
  'tasks.title': 'Tareas',
  'tasks.subtitle': 'Acciones puntuales, recurrentes y rutinas.',
  'tasks.typesAria': 'Tipos de tareas',
  'tasks.routines.defaultPeriod': 'Franja predeterminada',
  'tasks.routines.period.morning': 'Mañana',
  'tasks.routines.period.afternoon': 'Tarde',
  'tasks.routines.period.evening': 'Noche temprana',
  'tasks.routines.period.night': 'Noche',
  'tasks.routines.measureType': 'Tipo de medida',
  'tasks.routines.measureType.quantity': 'Cantidad',
  'tasks.routines.measureType.time': 'Tiempo',
  'tasks.routines.measureUnit': 'Unidad',
  'tasks.routines.quantityUnitRequired': 'Indica una unidad para las medidas de cantidad.',
  'tasks.routines.defaultDuration': 'Duración predeterminada (min)',
  'tasks.routines.durationCompleted': 'Duración realizada',
  'tasks.routines.timerMeasured': 'Cronómetro vinculado actualmente: {value} min',
  'tasks.routines.useTimerValue': 'Usar la duración del cronómetro',
  'tasks.routines.measureUnitPlaceholder': 'Ej. min, páginas, repeticiones, ml',
  'tasks.routines.defaultQuantity': 'Cantidad predeterminada',
  'tasks.routines.measurePairRequired': 'Indica una unidad y una cantidad positiva, o deja ambos campos vacíos.',
  'tasks.routines.quantityCompletedTitle': 'Completar « {title} »',
  'tasks.routines.quantityCompleted': 'Cantidad realizada',
  'tasks.routines.quantityPositive': 'La cantidad debe ser mayor que cero.',
  'tasks.filters.search': 'Buscar',
  'tasks.filters.searchPlaceholder': 'Título o descripción…',
  'tasks.filters.all': 'Todos',
  'tasks.filters.lastDate': 'Última',
  'tasks.filters.nextDate': 'Próxima',
  'tasks.filters.activity': 'Seguimiento',
  'tasks.filters.withActivity': 'Con actividad / cronómetro',
  'tasks.filters.withoutActivity': 'Sin actividad / cronómetro',
  'tasks.filters.reset': 'Restablecer',
  'tasks.recurrent': 'Recurrentes',
  'tasks.exchange.import': 'Importar desde Excel / CSV',
  'tasks.exchange.exportActive': 'Exportar configuraciones activas',
  'tasks.exchange.exportOne': 'Exportar {name}',
  'tasks.exchange.preview': '{count} configuración(es) reconocida(s). No se importará el historial.',
  'tasks.exchange.upsertHelp': 'Mismo nombre: se actualiza la configuración existente. Nombre nuevo: se crea. Las configuraciones ausentes del archivo quedan sin cambios.',
  'tasks.exchange.upserted': '{updated} configuración(es) actualizada(s), {created} creada(s). Las demás configuraciones no se han modificado.',
  'tasks.exchange.conflict': 'Si ya existe una configuración con el mismo nombre',
  'tasks.exchange.replace': 'Reemplazar configuración',
  'tasks.exchange.copy': 'Importar como nueva',
  'tasks.exchange.skip': 'Ignorar',
  'tasks.exchange.importConfirm': 'Importar',
  'tasks.exchange.imported': '{imported} configuración(es) importada(s), {skipped} omitida(s).',
  'tasks.exchange.importError': 'La importación de configuraciones ha fallado.',
  'tasks.exchange.exportError': 'La exportación de configuraciones ha fallado.',
  'tasks.newTodo': 'Nueva To Do',
  'tasks.loading': 'Cargando tareas…',
  'tasks.todoEmpty': 'No hay To Do. Crea tu primera acción, con o sin fecha.',
  'tasks.open': 'Por hacer',
  'tasks.deleteAria': 'Eliminar definitivamente {title}',
  'tasks.completeAria': 'Completar {title}',
  'tasks.scheduledFor': 'Prevista el',
  'tasks.changeDateAria': 'Cambiar la fecha prevista de {title}',
  'tasks.cancelTask': 'Cancelar la tarea',
  'tasks.loadingHistory': 'Cargando el historial…',
  'tasks.purgeHistory': 'Limpiar tareas completadas y canceladas',
  'tasks.historyEmpty': 'No hay tareas en el historial.',
  'tasks.completedOn': 'Completada el {date}',
  'tasks.cancelled': 'Cancelada',
  'tasks.done': 'Realizada',
  'tasks.notDone': 'No realizada',
  'tasks.editTodo': 'Editar la To Do',
  'tasks.createTodo': 'Crear una To Do',
  'tasks.titleRequired': 'El título es obligatorio.',
  'tasks.scheduledDate': 'Fecha prevista',
  'tasks.subtasks': 'Subtareas',
  'tasks.subtaskAria': 'Subtarea {index}',
  'tasks.addSubtask': '+ Añadir una subtarea',
  'tasks.completeDialogTitle': '¿Completar la tarea?',
  'tasks.completeDialogBody': '«{title}» y sus subtareas se marcarán como realizadas.',
  'tasks.deleteDialogTitle': '¿Eliminar definitivamente la tarea?',
  'tasks.deleteDialogBody': '«{title}» y todo su historial se eliminarán. Esta acción es irreversible.',
  'tasks.purgeDialogTitle': '¿Limpiar todo el historial cerrado?',
  'tasks.purgeDialogBody': 'Se eliminarán definitivamente {count} tarea(s) completada(s) o cancelada(s).',
  'tasks.cancelDialogTitle': '¿Cancelar esta tarea?',
  'tasks.cancelDialogBody': 'Se conservará en el historial sin considerarse realizada.',
  'tasks.cancelReason': 'Motivo opcional',
  'tasks.recurrentDescription': 'Acciones que se repiten según un intervalo calculado desde su realización real.',
  'tasks.newRecurrent': 'Nueva recurrente',
  'tasks.editRecurrent': 'Editar la recurrente',
  'tasks.createRecurrent': 'Crear una recurrente',
  'tasks.intervalDays': 'Intervalo en días',
  'tasks.firstDate': 'Primera fecha opcional',
  'tasks.futureOccurrences': 'de las próximas ocurrencias',
  'tasks.noActiveRecurrent': 'No hay tareas recurrentes activas.',
  'tasks.task': 'Tarea',
  'tasks.frequency': 'Frecuencia',
  'tasks.last': 'Última',
  'tasks.next': 'Próxima',
  'tasks.steps': 'Pasos',
  'tasks.priority.urgent': 'P1 — Urgente',
  'tasks.priority.high': 'P2 — Alta',
  'tasks.priority.normal': 'P3 — Normal',
  'tasks.priority.low': 'P4 — Baja',
  'tasks.priority.someday': 'P5 — Algún día',
  'tasks.loadError': 'No se han podido cargar las tareas. Vuelve a intentarlo en unos instantes.',
  'tasks.historyLoadError': 'No se ha podido cargar el historial de tareas.',
  'tasks.saveError': 'No se ha podido guardar. No se enviará ningún cambio adicional.',
  'tasks.recurrentLoadError': 'No se han podido cargar las tareas recurrentes.',
  'tasks.recurrentSaveError': 'No se ha podido guardar la tarea recurrente.',
  'tasks.recurrentDetailError': 'No se ha podido cargar el detalle de «{title}».',
  'tasks.completedDateRequired': 'La fecha de realización es obligatoria.',
  'tasks.routineStatus.completed': 'Realizada',
  'tasks.routineStatus.notCompleted': 'No realizada',
  'tasks.routineStatus.cancelled': 'Cancelada',
  'tasks.routineStatus.notRecorded': 'Sin registrar',
  'tasks.routineStatus.notPlanned': 'No prevista',
  'tasks.routineSaveError': 'No se ha podido guardar la rutina.',
  'tasks.routineResultError': 'No se ha podido guardar el resultado de la rutina.',
  'tasks.subtaskSaveError': 'No se ha podido guardar la subtarea.',
  'tasks.routinesLoadError': 'No se han podido cargar las rutinas.',
  'tasks.routinesDateLoadError': 'No se han podido cargar las rutinas para esta fecha.',
  'tasks.recurrent.currentSubtasks': 'Subtareas de la ocurrencia actual',
  'tasks.recurrent.noSubtasks': 'No hay subtareas para esta ocurrencia.',
  'tasks.recurrent.occurrences': 'Ocurrencias',
  'tasks.recurrent.cancelCurrent': 'Cancelar la ocurrencia actual',
  'tasks.recurrent.planned': 'Prevista',
  'tasks.recurrent.status': 'Estado',
  'tasks.recurrent.completedOn': 'Realizada el',
  'tasks.recurrent.noHistory': 'No hay ocurrencias pasadas.',
  'tasks.recurrent.inactive': 'Desactivadas',
  'tasks.recurrent.reactivate': 'Reactivar',
  'tasks.recurrent.planNext': 'Planificar la próxima ocurrencia',
  'tasks.recurrent.nextDate': 'Próxima fecha',
  'tasks.recurrent.cancelOccurrenceQuestion': '¿Cancelar esta ocurrencia?',
  'tasks.recurrent.planFollowing': 'Planificar la siguiente ocurrencia',
  'tasks.recurrent.cancelOccurrence': 'Cancelar la ocurrencia',
  'tasks.recurrent.date': 'Fecha',
  'tasks.recurrent.plan': 'Planificar',
  'tasks.recurrent.editOccurrence': 'Editar la ocurrencia',
  'tasks.recurrent.completed': 'Realizada',
  'tasks.recurrent.cancelled': 'Cancelada',
  'tasks.recurrent.realCompletionDate': 'Fecha real de realización',
  'tasks.recurrent.cancellationReason': 'Motivo de cancelación',
  'tasks.recurrent.recalculateNext': 'Recalcular también la próxima ocurrencia',
  'tasks.recurrent.deleteOccurrenceQuestion': '¿Eliminar esta ocurrencia?',
  'tasks.recurrent.deleteOccurrenceHelp': 'Esta eliminación es definitiva. La ocurrencia y sus subtareas desaparecerán del historial.',
  'tasks.recurrent.deactivateQuestion': '¿Desactivar esta tarea recurrente?',
  'tasks.recurrent.deactivateHelp': 'La ocurrencia abierta se cancelará. Se conservará el historial y no se creará ninguna ocurrencia nueva.',
  'tasks.recurrent.deactivate': 'Desactivar',
  'tasks.recurrent.deleteTaskHelp': 'La tarea, todas sus ocurrencias, su historial y sus subtareas se eliminarán definitivamente.',
  'tasks.recurrent.irreversible': 'Esta acción es irreversible.',
  'tasks.recurrent.markDone': 'Marcar como realizada',
  'tasks.recurrent.showDetails': 'Mostrar detalles',
  'tasks.recurrent.completeQuestion': '¿Completar «{title}»?',
  'tasks.recurrent.everyDay': 'Cada día',
  'tasks.recurrent.everyDays': 'Cada {count} días',
  'tasks.recurrent.lateDays': '+{count} d',
  'tasks.recurrent.deleteOccurrenceAria': 'Eliminar esta ocurrencia',
  'tasks.routines.dateNavigation': 'Navegación por fecha',
  'tasks.routines.previousDay': 'Día anterior',
  'tasks.routines.nextDay': 'Día siguiente',
  'tasks.routines.historyFiveDays': 'Historial de los últimos cinco días',
  'tasks.routines.cancelOccurrence': 'Cancelar esta ocurrencia',
  'tasks.routines.resetStatus': 'Restablecer como sin registrar',
  'tasks.routines.inactiveBadge': 'Inactiva',
  'tasks.routines.stepSingular': 'paso',
  'tasks.routines.stepPlural': 'pasos',
  'tasks.routines.markCompletedAria': 'Marcar {title} como realizada',
  'tasks.routines.markNotCompletedAria': 'Marcar {title} como no realizada',
  'tasks.routines.resetAria': 'Restablecer {title} como sin registrar',
  'tasks.routines.dailyTracking': 'Seguimiento diario',
  'tasks.routines.today': 'Hoy',
  'tasks.routines.futureReadOnly': 'Fecha futura — solo consulta',
  'tasks.routines.chooseDate': 'Elegir una fecha',
  'tasks.routines.configuration': 'Configuración',
  'tasks.routines.new': '+ Nueva rutina',
  'tasks.routines.active': 'Activas',
  'tasks.routines.inactive': 'Inactivas',
  'tasks.routines.historyKept': 'Historial conservado',
  'tasks.routines.archive': 'Archivar',
  'tasks.routines.emptyConfig': 'No hay rutinas configuradas',
  'tasks.routines.emptyConfigHelp': 'Crea tu primera rutina para empezar el seguimiento diario.',
  'tasks.routines.loading': 'Cargando rutinas…',
  'tasks.routines.retryToday': 'Reintentar hoy',
  'tasks.routines.archived': 'Archivada',
  'tasks.routines.fiveDays': '5 días',
  'tasks.routines.emptyDay': 'No hay rutinas previstas para esta fecha',
  'tasks.routines.noRollover': 'Las rutinas nunca se trasladan de un día al siguiente.',
  'tasks.routines.create': 'Crear una rutina',
  'tasks.routines.daySteps': 'Pasos del día',
  'tasks.routines.stepsLocked': 'Los pasos solo se pueden modificar mientras no se haya registrado el resultado de la rutina.',
  'tasks.routines.activeFrom': 'Activa a partir del',
  'tasks.routines.dailySteps': 'Pasos diarios',
  'tasks.routines.optionalSteps': 'Opcionales, se reinician para cada nueva fecha.',
  'tasks.routines.historyDeactivateHelp': 'Se conserva el historial. No se creará ningún día nuevo a partir de hoy.',
  'tasks.routines.resumeFrom': 'Reanudar a partir del',
  'tasks.routines.noRetroactive': 'El periodo de inactividad no se recreará retroactivamente.',
  'tasks.routines.archiveHelp': 'La rutina desaparecerá de la configuración, pero sus días ya registrados seguirán disponibles en el historial.',
  'tasks.routines.closeConfig': 'Cerrar configuración',
  'tasks.routines.configure': 'Configurar rutinas',
  'tasks.routines.completedCount': 'rutinas realizadas de',
  'tasks.routines.plannedCount': 'previstas',

  'today.today': 'Hoy',
  'today.loading': 'Cargando el día…',
  'today.loadUnavailable': 'No se ha podido cargar el día. Tus datos están intactos.',
  'today.retryLoading': 'Reintentar',
  'today.dayPriority': 'Prioridad del día',
  'today.openCalendar': 'Ver en Calendario →',
  'today.highlightUnavailable': 'Highlight no está disponible temporalmente.',
  'today.noHighlight': 'No hay Highlight definido para este día',
  'today.chooseHighlight': 'Highlight del día',
  'today.chooseHighlightAria': 'Elegir el Highlight del día',
  'today.clearHighlight': 'Quitar Highlight',
  'today.clearHighlightAria': 'Quitar el Highlight del día',
  'today.setHighlightTo': 'Definir como Highlight:',
  'today.removeHighlightFrom': 'Quitar del Highlight:',
  'today.startActivityTimer': 'Iniciar cronómetro',
  'today.error.startActivityTimer': 'No se ha podido iniciar el cronómetro para {title}.',
  'today.clearMealAria': 'Borrar la comida para',
  'today.noHighlightCandidate': 'No hay ninguna actividad planificada disponible como Highlight.',
  'today.error.highlightSave': 'No se ha podido guardar el Highlight.',
  'today.reschedule': 'Reprogramar',
  'today.changeActivityPeriod': 'Cambiar el periodo de',
  'today.error.rescheduleActivity': 'No se ha podido reprogramar {title}.',
  'today.mealFor': 'Comida para',
  'today.noMealSelected': 'Ninguna comida seleccionada',
  'today.noMealAvailable': 'No hay comidas disponibles',
  'today.toPlan': 'Por planificar',
  'today.tasksPartialError': 'No se han podido cargar algunas tareas.',
  'today.plan': 'Planificar…',
  'today.postpone': 'Aplazar',
  'today.skip': 'Omitir',
  'today.noSubtasks': 'No hay subtareas.',
  'today.hideSubtasks': 'Ocultar subtareas',
  'today.planning': 'Planificación',
  'today.myDay': 'Mi día',
  'today.openCalendarShort': 'Abrir Calendario →',
  'today.calendarUnavailable': 'La planificación de Calendario no está disponible.',
  'today.plannedTasksPartialError': 'No se han podido cargar algunas tareas planificadas.',
  'today.calendarActivity': 'Actividad de Calendario',
  'today.dropTaskHere': 'Suelta o asigna una tarea aquí.',
  'today.noCalendarPeriod': 'No hay ningún periodo activo de Calendario disponible para este día.',
  'today.myMeals': 'Mis comidas',
  'today.mealsUnavailable': 'Las comidas no están disponibles temporalmente.',
  'today.noMealType': 'No hay ningún tipo de comida activo. Añade o reactiva un eje Comida en Calendario.',
  'today.wellbeing': 'Bienestar',
  'today.satisfaction': 'Satisfacción del día',
  'today.clear': 'Borrar',
  'today.satisfactionUnavailable': 'El índice de satisfacción no está disponible temporalmente.',
  'today.goalsProgress': 'Progreso del día',
  'today.openGoals': 'Ver Objetivos →',
  'today.partialUnavailable': 'Algunos bloques no están disponibles temporalmente. Los demás siguen utilizables.',
  'today.recurrentTask': 'Tarea recurrente',
  'today.completedOn': 'Realizada el',
  'today.createNextOccurrence': 'Crear la próxima ocurrencia',
  'today.nextOccurrence': 'Próxima ocurrencia',
  'today.navigationAria': 'Navegación del día',
  'today.previousDayAria': 'Día anterior',
  'today.chooseDateAria': 'Elegir una fecha',
  'today.nextDayAria': 'Día siguiente',
  'today.highlightDoneAria': 'Highlight realizado',
  'today.moveTaskAria': 'Mover la tarea',
  'today.mealPlaceholder': 'Comida / receta…',
  'today.satisfactionAria': 'Satisfacción del día de menos tres a más tres',
  'today.error.completeRecurrent': 'No se ha podido completar la tarea recurrente.',
  'today.error.placeTask': 'No se ha podido asignar la tarea a este periodo.',
  'today.error.moveTask': 'No se ha podido mover la tarea.',
  'today.error.unplanTask': 'No se ha podido devolver la tarea a Por planificar.',
  'today.error.reorder': 'No se ha podido guardar el orden del periodo.',
  'today.highlightFallback': 'Elemento destacado',
  'today.recurrent': 'Recurrente',
  'today.routine': 'Rutina',
  'today.satisfaction.minus3': 'Día extremadamente insatisfactorio',
  'today.satisfaction.minus2': 'Mal día',
  'today.satisfaction.minus1': 'Bastante insatisfactorio',
  'today.satisfaction.zero': 'Neutro',
  'today.satisfaction.plus1': 'Bastante satisfactorio',
  'today.satisfaction.plus2': 'Buen día',
  'today.satisfaction.plus3': 'Día excelente',
  'today.error.subtasks': 'No se han podido cargar las subtareas de «{title}».',
  'today.error.subtaskUpdate': 'No se ha podido actualizar la subtarea «{title}».',
  'today.error.mealSave': 'No se ha podido guardar la comida «{name}».',
  'today.error.satisfactionSave': 'No se ha podido guardar la satisfacción del día.',
  'today.error.satisfactionClear': 'No se ha podido borrar la satisfacción del día.',
  'today.error.futureDate': 'Elige una fecha posterior al día mostrado.',
  'today.error.postpone': 'No se ha podido aplazar la tarea «{title}».',
  'today.error.skip': 'No se ha podido omitir la rutina «{title}».',
  'today.error.completeTask': 'No se ha podido completar la tarea. Vuelve a intentarlo.',
  'today.error.reopenTask': 'No se ha podido reabrir la tarea «{title}».',
  'today.error.completeActivity': 'No se ha podido completar la actividad. Vuelve a intentarlo.',
  'today.error.reopenActivity': 'No se ha podido reabrir la actividad. Vuelve a intentarlo.',
  'calendar.meals': 'Comidas',
  'calendar.planWeek': 'Planificar la semana',
  'calendar.manageAxes': 'Gestionar ejes',
  'calendar.addAxis': 'Añadir un eje',
  'calendar.addingAxis': 'Añadiendo…',
  'calendar.axisUp': 'Mover el eje hacia arriba',
  'calendar.axisDown': 'Mover el eje hacia abajo',
  'calendar.today': 'Hoy',
  'calendar.chooseDate': 'Elegir una fecha',
  'calendar.consultation': 'Consulta',
  'calendar.editing': 'Edición',
  'calendar.editMode': 'Modo edición',
  'calendar.finishEditing': 'Terminar edición',
  'calendar.mealForDay': '{meal} — {day}',
  'calendar.configuration': 'Configuración',
  'calendar.axesTitle': 'Ejes del calendario',
  'calendar.name': 'Nombre',
  'calendar.type': 'Tipo',
  'calendar.axisThematic': 'Eje temático',
  'calendar.timeSlot': 'Franja horaria',
  'calendar.slot': 'Franja',
  'calendar.axis': 'Eje',
  'calendar.initial': 'Inicial',
  'calendar.archived': 'Archivado',
  'calendar.visible': 'Visible',
  'calendar.restore': 'Restaurar',
  'calendar.loadingWeek': 'Cargando la semana…',
  'calendar.planning': 'Planificación',
  'calendar.weekPlanning': 'Planificación de la semana',
  'calendar.dayPlanning': 'Planificación del día',
  'calendar.openToday': 'Abrir Hoy →',
  'calendar.moveCopyHelp': 'Una entrada libre se copia; una To Do o tarea recurrente se mueve. Una rutina permanece vinculada a su día. Los ejes Comida se rellenan desde Hoy.',
  'calendar.noVisibleAxes': 'Todos los ejes están ocultos o archivados. Abre «Gestionar ejes» para volver a mostrar uno.',
  'calendar.nothingPlanned': 'Nada previsto.',
  'calendar.noPlanningAxis': 'No hay ningún eje de planificación visible ahora.',
  'calendar.scheduling': 'Planificación',
  'calendar.placeExistingOccurrence': 'Colocar una ocurrencia existente',
  'calendar.chooseTaskType': 'Elige el tipo y después la ocurrencia que quieres colocar en esta celda.',
  'calendar.or': 'o',
  'calendar.createFreeEntry': 'Planificar una actividad',
  'calendar.reuseActivity': 'Reutilizar una actividad',
  'calendar.newActivity': 'Nueva actividad…',
  'calendar.activitySuggestionsHelp': 'Las actividades activas se pueden reutilizar en varias ubicaciones del calendario.',
  'calendar.chooseAxis': 'Elegir un eje',
  'calendar.date': 'Fecha',
  'calendar.deleteLogicalHelp': 'Desaparecerá de las vistas normales pero seguirá eliminada lógicamente en la base de datos.',
  'calendar.keepCurrentState': 'Mantener el estado actual',
  'calendar.recurrentTask': 'Tarea recurrente',
  'calendar.recurrentCompletionHelp': 'Calendario utiliza el mismo flujo que Tareas: fecha real de realización y elección inmediata de la próxima ocurrencia.',
  'calendar.realCompletionDate': 'Fecha real de realización',
  'calendar.createNextOccurrence': 'Crear la próxima ocurrencia',
  'calendar.nextDate': 'Próxima fecha',
  'calendar.navigationAria': 'Navegación del calendario',
  'calendar.previousWeek': 'Semana anterior',
  'calendar.nextWeek': 'Semana siguiente',
  'calendar.closeAria': 'Cerrar',
  'calendar.axisLeft': 'Mover el eje a la izquierda',
  'calendar.axisRight': 'Mover el eje a la derecha',
  'calendar.weekView': 'Vista semanal',
  'calendar.mobileDayView': 'Vista diaria móvil',
  'calendar.previousDay': 'Día anterior',
  'calendar.nextDay': 'Día siguiente',
  'calendar.notePlaceholder': 'Contexto, lugar, detalle…',
  'calendar.cancelledAria': 'Cancelada',
  'calendar.setHighlight': 'Marcar como Highlight',
  'calendar.moveEntryUp': 'Subir la entrada',
  'calendar.moveEntryDown': 'Bajar la entrada',
  'calendar.unplanTask': 'Desplanificar sin eliminar la tarea',
  'calendar.noDate': 'Sin fecha',
  'calendar.routineOn': 'Rutina del {date}',
  'calendar.postponedDays': 'Aplazada {count} d',
  'calendar.lateDays': '{count} d de retraso',
  'calendar.scheduled': 'Prevista {date}',
  'calendar.unplaced': 'Sin colocar',
  'calendar.axisUnavailable': 'Eje no disponible',
  'calendar.error.load': 'No se ha podido cargar el calendario. Vuelve a intentarlo en unos instantes.',
  'calendar.error.entrySave': 'No se ha podido guardar la entrada. Los demás elementos no se han modificado.',
  'calendar.error.tasksLoad': 'No se han podido cargar las tareas disponibles.',
  'calendar.error.routineDate': 'Una rutina debe colocarse en la fecha de su ocurrencia diaria.',
  'calendar.error.taskPlace': 'No se ha podido colocar la tarea. No se ha conservado ningún desplazamiento parcial.',
  'calendar.error.copy': 'No se ha podido guardar la copia de la actividad. Vuelve a intentarlo.',
  'calendar.error.routineMove': 'Una rutina diaria no se puede mover a otra fecha.',
  'calendar.error.taskMove': 'No se ha podido mover la tarea. Tareas y Calendario permanecen en su estado anterior.',
  'calendar.error.taskUnplan': 'No se ha podido desplanificar la tarea. Sigue disponible en Tareas.',
  'calendar.error.taskComplete': 'No se ha podido completar la tarea desde Calendario.',
  'calendar.error.taskReopen': 'No se ha podido reabrir la tarea desde Calendario.',
  'calendar.error.recurrentComplete': 'No se ha podido completar la tarea recurrente. No se ha conservado ninguna próxima ocurrencia parcial.',
  'calendar.error.highlightUpdate': 'No se ha podido actualizar Highlight.',
  'calendar.error.highlightSave': 'No se ha podido guardar Highlight.',
  'calendar.error.highlightRemove': 'No se ha podido quitar Highlight.',
  'calendar.error.axisCreate': 'No se ha podido crear el eje.',
  'calendar.error.axisOrder': 'No se ha podido guardar el orden de los ejes.',
  'calendar.error.axisUpdate': 'No se ha podido guardar la modificación del eje.',
  'calendar.mealsLoadError': 'No se han podido cargar las comidas de la semana.',
  'calendar.mealSaveError': 'No se ha podido guardar la comida. Las demás celdas permanecen sin cambios.',
  'calendar.templatesLoadError': 'No se han podido cargar las plantillas del calendario.',
  'calendar.templateItemAddError': 'No se ha podido añadir la actividad a la plantilla.',
  'calendar.templateItemRemoveError': 'No se ha podido quitar la actividad de la plantilla.',
  'calendar.templateApplied': 'Se han añadido {count} actividad(es) a la semana.',
  'calendar.templateAlreadyApplied': 'Esta plantilla ya está presente en esta semana.',
  'calendar.templateApplyError': 'No se ha podido cargar la plantilla. La semana existente no se ha eliminado.',
  'calendar.templateDeleted': 'Plantilla eliminada. Las semanas ya cargadas permanecen sin cambios.',
  'calendar.templateDeleteError': 'No se ha podido eliminar la plantilla.',
  'calendar.templateCreatedFromWeek': 'Plantilla creada con {count} actividad(es) libre(s).',
  'calendar.templateCreatedBlank': 'Plantilla vacía creada. Añade ahora sus actividades.',
  'calendar.templateCreateError': 'No se ha podido crear la plantilla. Comprueba especialmente que su nombre sea único.',
  'calendar.weekMenus': 'Menús de la semana',
  'calendar.loadingMeals': 'Cargando comidas…',
  'calendar.mealPlaceholder': 'Comida…',
  'calendar.clearMeal': 'Borrar la comida',
  'calendar.noMealAxes': 'No hay ningún tipo de comida activo. Añade uno desde «Gestionar ejes» eligiendo el tipo Comida.',
  'calendar.weekModel': 'Modelo de semana',
  'calendar.chooseTemplate': 'Elegir…',
  'calendar.noTemplate': 'Sin plantilla',
  'calendar.load': 'Cargar',
  'calendar.manageTemplates': 'Gestionar plantillas',
  'calendar.templates': 'Plantillas',
  'calendar.manageWeekModels': 'Gestionar modelos de semana',
  'calendar.templateImport': 'Importar plantillas Excel / CSV',
  'calendar.exportAllTemplates': 'Exportar todas las plantillas',
  'calendar.exportTemplate': 'Exportar {name}',
  'calendar.templateImportSummary': '{templates} plantilla(s), {axes} eje(s) por revisar.',
  'calendar.associateAxis': 'Asociar a « {name} »',
  'calendar.createAxisOnImport': 'Crear el eje « {name} »',
  'calendar.templateConflict': 'Si ya existe una plantilla con el mismo nombre',
  'calendar.templateConflictReplace': 'Reemplazar',
  'calendar.templateConflictCopy': 'Importar como nueva',
  'calendar.templateConflictSkip': 'Ignorar',
  'calendar.importTemplates': 'Importar plantillas',
  'calendar.templateImported': '{imported} plantilla(s) importada(s), {skipped} omitida(s).',
  'calendar.templateImportError': 'La importación de plantillas de Calendario ha fallado.',
  'calendar.templateImportInvalidItem': 'Una actividad del archivo está incompleta o no es válida.',
  'calendar.templateExported': '{count} plantilla exportada.',
  'calendar.templatesExported': '{count} plantillas exportadas.',
  'calendar.templateName': 'Nombre de la plantilla',
  'calendar.modelNamePlaceholder': 'Nombre del modelo',
  'calendar.createBlank': 'Crear vacía',
  'calendar.fromWeek': 'Desde esta semana',
  'calendar.createdFromWeek': 'Creada desde la semana del {date}',
  'calendar.createdBlank': 'Creada desde cero',
  'calendar.deleteTemplate': 'Eliminar la plantilla',
  'calendar.day': 'Día',
  'calendar.activity': 'Actividad',
  'calendar.optionalNote': 'Nota opcional',
  'calendar.addToTemplate': 'Añadir a la plantilla',
  'calendar.emptyTemplate': 'Plantilla vacía. Añade su primera actividad arriba.',
  'calendar.loadTemplateQuestion': '¿Cargar {name}?',
  'calendar.loadTemplateHelp': 'Las actividades libres que falten se añadirán a la semana mostrada. Las entradas existentes y todas las tareas permanecerán intactas.',
  'calendar.loadTemplate': 'Cargar la plantilla',
  'calendar.deleteTemplateQuestion': '¿Eliminar {name}?',
  'calendar.deleteTemplateHelp': 'La plantilla se eliminará, pero las semanas donde ya se cargó no se modificarán.',
  'goals.title': 'Objetivos',
  'goals.nonApplicable': 'No aplicable',
  'goals.unavailable': 'No disponible',
  'goals.error': 'Error',
  'goals.correctionValueRequired': 'Introduce un valor de corrección.',
  'goals.negativeReplacement': 'Un valor de sustitución no puede ser negativo.',
  'goals.booleanReplacement': 'Una sustitución sí/no solo acepta 0 o 1.',
  'goals.correctionSaved': 'Corrección guardada.',
  'goals.correctionDeleted': 'Corrección eliminada.',
  'goals.targetChanged': 'Objetivo modificado para esta fecha.',
  'goals.removedFromDate': 'Objetivo retirado de esta fecha.',
  'goals.removedFromPeriod': 'Objetivo retirado de este periodo.',
  'goals.targetPositive': 'El objetivo debe ser estrictamente positivo.',
  'goals.booleanTarget': 'El objetivo de un objetivo sí/no debe ser igual a 1.',
  'goals.actionFailed': 'La acción de Goals ha fallado. Vuelve a intentarlo.',
  'goals.addGoal': 'Añadir un objetivo',
  'goals.templateEmpty': 'La semana tipo guardada está vacía. Añade objetivos y guárdala antes de cargarla.',
  'goals.weekAlreadyPresent': 'La semana tipo ya está completamente presente en esta semana. Se conservan las personalizaciones existentes.',
  'goals.editorCleared': 'Semana tipo vaciada en el editor. Guárdala para aplicar este modelo a los próximos días.',
  'goals.sourceWeekEmpty': 'Esta semana no contiene ningún día de Goals guardado.',
  'goals.goalUnavailable': 'Objetivo no disponible',
  'goals.modelUnavailable': 'Un objetivo del modelo ya no está disponible.',
  'goals.templateSaved': 'Semana tipo guardada. Los días existentes no cambian hasta que cargues explícitamente el modelo en una semana.',
  'goals.eachTargetPositive': 'Cada objetivo debe ser estrictamente positivo.',
  'goals.booleanTemplateTarget': 'Un objetivo sí/no debe ser igual a 1.',
  'goals.templateSaveFailed': 'No se ha podido guardar el modelo semanal.',
  'goals.subtitle': 'Resultado, objetivo y progreso del día.',
  'goals.weeklyTemplate': 'Semana tipo',
  'goals.add': 'Añadir',
  'goals.navigationAria': 'Navegación entre fechas',
  'goals.previousDay': 'Día anterior',
  'goals.today': 'Hoy',
  'goals.nextDay': 'Día siguiente',
  'goals.loading': 'Cargando objetivos…',
  'goals.summaryAria': 'Resumen del día',
  'goals.periodSummaryAria': 'Resumen del periodo',
  'goals.scoreProvisional': 'puntuación provisional',
  'goals.scoreDay': 'puntuación del día',
  'goals.scorePeriod': 'puntuación del periodo',
  'goals.achieved': 'alcanzados',
  'goals.measured': 'informados',
  'goals.refresh': 'Actualizar',
  'goals.dayGoalsAria': 'Objetivos del día',
  'goals.goal': 'Objetivo',
  'goals.result': 'Resultado',
  'goals.automatic': 'Automático',
  'goals.corrected': 'corregido',
  'goals.addedForDay': 'Añadido para este día',
  'goals.sourceUnavailable': 'Fuente no disponible',
  'goals.resultAria': 'Resultado {name}',
  'goals.calculated': 'calculado',
  'goals.optionsAria': 'Opciones de {name}',
  'goals.editGoal': 'Modificar el objetivo',
  'goals.targetForDay': 'Objetivo para este día',
  'goals.changeTarget': 'Modificar el objetivo',
  'goals.correctAutomatic': 'Corregir el resultado automático',
  'goals.calculatedValue': 'Valor calculado: {value}',
  'goals.mode': 'Modo',
  'goals.adjust': 'Ajustar',
  'goals.replace': 'Reemplazar',
  'goals.value': 'Valor',
  'goals.apply': 'Aplicar',
  'goals.clearCorrection': 'Borrar la corrección',
  'goals.removeForDay': 'Quitar de este día',
  'goals.removeForPeriod': 'Quitar de este periodo',
  'goals.emptyDay': 'No hay objetivos para esta fecha.',
  'goals.emptyDayHelp': 'Añade un objetivo aquí o prepara tu semana tipo.',
  'goals.addToDate': 'Añadir a {date}',
  'goals.goalEdited': 'Objetivo modificado.',
  'goals.newGoalAdded': 'Nuevo objetivo añadido a esta fecha.',
  'goals.goalAdded': 'Objetivo añadido a esta fecha.',
  'goals.automaticRefreshed': 'Resultados automáticos actualizados.',
  'goals.manualNonNegative': 'El resultado debe ser positivo o cero.',
  'goals.booleanResult': 'Un objetivo sí/no solo acepta 0 o 1.',
  'goals.noOccurrence': 'No hay ninguna ocurrencia prevista para esta fecha: el resultado no es aplicable.',
  'goals.template.subtitle': 'Prepara los objetivos habituales de cada día y carga este modelo en las semanas que quieras.',
  'goals.template.backDay': 'Volver al día',
  'goals.template.saving': 'Guardando…',
  'goals.template.save': 'Guardar',
  'goals.template.loading': 'Cargando la semana tipo…',
  'goals.template.startEyebrow': 'PUNTO DE PARTIDA',
  'goals.template.createModel': 'Crear el modelo',
  'goals.template.createHelp': 'Empieza desde cero o reutiliza los objetivos y metas de una semana ya registrada.',
  'goals.template.startBlank': 'Empezar desde cero',
  'goals.template.previousWeek': 'Semana anterior',
  'goals.template.chooseExistingWeek': 'Elegir una semana existente',
  'goals.template.nextWeek': 'Semana siguiente',
  'goals.template.loadingShort': 'Cargando…',
  'goals.template.fromWeek': 'Desde esta semana',
  'goals.template.loadEyebrow': 'CARGAR EL MODELO',
  'goals.template.applyTitle': 'Aplicar la semana tipo',
  'goals.template.applyHelp': 'Añade el modelo guardado a una semana real sin borrar ni sobrescribir las personalizaciones existentes.',
  'goals.template.previousTargetWeek': 'Semana objetivo anterior',
  'goals.template.chooseTargetWeek': 'Elegir la semana en la que cargar el modelo',
  'goals.template.nextTargetWeek': 'Semana objetivo siguiente',
  'goals.template.loadThisWeek': 'Cargar en esta semana',
  'goals.template.confirmQuestion': '¿Cargar la semana tipo en {week}?',
  'goals.template.confirmHelp': 'Se añadirán los objetivos que falten. Los objetivos, resultados y metas ya personalizados no cambiarán.',
  'goals.template.load': 'Cargar la semana tipo',
  'goals.template.editorAria': 'Objetivos de la semana tipo',
  'goals.template.goalSingular': 'objetivo',
  'goals.template.goalPlural': 'objetivos',
  'goals.template.moveUp': 'Subir {name}',
  'goals.template.moveDown': 'Bajar {name}',
  'goals.template.removeFromDay': 'Quitar {name} de {day}',
  'goals.template.target': 'Objetivo',
  'goals.template.noGoal': 'Ningún objetivo.',
  'goals.template.addToDay': 'Añadir al {day}',
  'goals.template.appliedCount': '{count} objetivos añadidos o restaurados en la semana.',
  'goals.template.copiedWeek': 'Semana del {date} cargada en el editor. Nada se guarda hasta que pulses Guardar.',
  'goals.templateInline.day': 'día',
  'goals.templateInline.saveDay': 'Guardar día',
  'goals.templateInline.loadDay': 'Cargar día',
  'goals.templateInline.savePeriod': 'Guardar plantilla {period}',
  'goals.templateInline.loadPeriod': 'Cargar plantilla {period}',
  'goals.templateInline.saveWeeklyType': 'Guardar semana tipo',
  'goals.templateInline.loadWeeklyType': 'Cargar semana tipo',
  'goals.templateInline.savedDay': 'Plantilla del día guardada ({count} objetivo(s)).',
  'goals.templateInline.loadedDay': 'Plantilla del día cargada ({count} objetivo(s)).',
  'goals.templateInline.savedPeriod': 'Plantilla {period} guardada ({count} objetivo(s)).',
  'goals.templateInline.loadedPeriod': 'Plantilla {period} cargada ({count} objetivo(s)).',
  'goals.templateInline.savedWeeklyType': 'Semana tipo guardada desde la semana mostrada.',
  'goals.templateInline.loadedWeeklyType': 'Semana tipo cargada ({count} objetivo(s)).',
  'goals.templateInline.emptyWeek': 'La semana mostrada no contiene objetivos para guardar.',
  'goals.templateLibrary.eyebrow': 'BIBLIOTECA DE PLANTILLAS',
  'goals.templateLibrary.saveDayTitle': 'Guardar este día como plantilla',
  'goals.templateLibrary.loadDayTitle': 'Cargar un día tipo',
  'goals.templateLibrary.savePeriodTitle': 'Guardar una plantilla {period}',
  'goals.templateLibrary.loadPeriodTitle': 'Cargar una plantilla {period}',
  'goals.templateLibrary.saveWeekTitle': 'Guardar una semana tipo',
  'goals.templateLibrary.loadWeekTitle': 'Cargar una semana tipo',
  'goals.templateLibrary.name': 'Nombre de la plantilla',
  'goals.templateLibrary.namePlaceholder': 'Ej. Día tipo oficina',
  'goals.templateLibrary.template': 'Plantilla',
  'goals.templateLibrary.load': 'Cargar',
  'goals.templateLibrary.none': 'No hay plantillas guardadas para este contexto.',
  'goals.templateLibrary.nameRequired': 'Pon un nombre a la plantilla.',
  'goals.templateLibrary.choose': 'Elige una plantilla para cargar.',
  'goals.templateLibrary.saved': 'Plantilla « {name} » guardada.',
  'goals.templateLibrary.loaded': 'Plantilla cargada.',
  'goals.templateLibrary.weekDirect': 'Objetivos definidos directamente para cada día',
  'goals.templateLibrary.weekDayTypes': 'Componer la semana con días tipo',
  'goals.templateLibrary.weekDirectHelp': 'La semana mostrada se copiará tal cual en esta plantilla.',
  'goals.templateLibrary.weekDirectShort': 'objetivos directos',
  'goals.templateLibrary.weekDayTypesShort': 'días tipo',
  'goals.templateLibrary.sevenDaysRequired': 'Selecciona un día tipo para cada uno de los 7 días.',
  'goals.templateLibrary.exportExcel': 'Exportar como CSV compatible con Excel',
  'goals.templateLibrary.importExcel': 'Importar desde Excel / CSV',
  'goals.templateLibrary.exportAll': 'Exportar todas las plantillas',
  'goals.templateLibrary.exported': 'Plantilla exportada ({count} fila(s)).',
  'goals.templateLibrary.exportedAll': '{count} plantilla(s) exportada(s).',
  'goals.templateLibrary.exportEmpty': 'Esta plantilla no contiene ningún objetivo para exportar.',
  'goals.templateLibrary.importPreview': '{count} fila(s) reconocida(s). Revisa la gestión de conflictos antes de importar.',
  'goals.templateLibrary.conflictLabel': 'Si ya existe una plantilla con el mismo nombre',
  'goals.templateLibrary.conflictReplace': 'Reemplazar',
  'goals.templateLibrary.conflictCopy': 'Importar como nueva',
  'goals.templateLibrary.conflictSkip': 'Ignorar',
  'goals.templateLibrary.importConfirm': 'Importar',
  'goals.templateLibrary.imported': '{imported} plantilla(s) importada(s), {skipped} ignorada(s). {manualized} fuente(s) automática(s) no portable(s) se importaron como manuales y deben volver a asociarse.',
  'goals.templateLibrary.manage': 'Gestionar plantillas',
  'goals.templateLibrary.manageTitle': 'Gestionar plantillas',
  'goals.templateLibrary.emptyDay': 'Sin plantilla — día sin objetivos',
  'goals.templateLibrary.emptyDayHelp': 'Un día sin plantilla quedará deliberadamente sin objetivos al cargar la semana tipo.',
  'goals.templateLibrary.kindDay': 'Día tipo',
  'goals.templateLibrary.kindWeek': 'Semana tipo',
  'goals.templateLibrary.kindPeriod': 'Plantilla {period}',
  'goals.templateLibrary.noneAny': 'No hay plantillas guardadas.',
  'goals.templateLibrary.backToList': 'Lista de plantillas',
  'goals.templateLibrary.weekday': 'Día',
  'goals.templateLibrary.goal': 'Objetivo',
  'goals.templateLibrary.target': 'Meta',
  'goals.templateLibrary.removeGoal': 'Quitar',
  'goals.templateLibrary.addGoal': 'Añadir un objetivo',
  'goals.templateLibrary.saveChanges': 'Guardar cambios',
  'goals.templateLibrary.updated': 'Plantilla modificada.',
  'goals.templateLibrary.weekdayRequired': 'Elige un día para cada objetivo semanal.',
  'goals.templateLibrary.exportOne': 'Exportar {name}',
  'goals.periodTemplate.eyebrow': 'PLANTILLAS DE PERIODO',
  'goals.periodTemplate.title': 'Objetivos semanales y mensuales',
  'goals.periodTemplate.help': 'Crea una plantilla desde una semana o un mes existente y cárgala en un periodo actual o futuro.',
  'goals.periodTemplate.weeklyTitle': 'Plantilla semanal',
  'goals.periodTemplate.monthlyTitle': 'Plantilla mensual',
  'goals.periodTemplate.savedCount': '{count} objetivo(s) guardado(s)',
  'goals.periodTemplate.sourceWeek': 'Semana de origen',
  'goals.periodTemplate.targetWeek': 'Semana de destino',
  'goals.periodTemplate.sourceMonth': 'Mes de origen',
  'goals.periodTemplate.targetMonth': 'Mes de destino',
  'goals.periodTemplate.createFromPeriod': 'Crear desde este periodo',
  'goals.periodTemplate.load': 'Cargar plantilla',
  'goals.periodTemplate.empty': 'No hay ninguna plantilla guardada.',
  'goals.periodTemplate.saved': 'Plantilla creada desde {period} con {count} objetivo(s).',
  'goals.periodTemplate.applied': 'Plantilla cargada en {period} con {count} objetivo(s).',
  'goals.periodTemplate.confirmQuestion': '¿Cargar esta plantilla en {period}?',
  'goals.periodTemplate.confirmHelp': 'Los objetivos del mismo tipo de periodo serán sustituidos por la instantánea de la plantilla. Los periodos históricos permanecen protegidos.',
  'goals.periodTemplate.confirmLoad': 'Cargar en este periodo',
  'goals.weekday.monday': 'Lunes',
  'goals.weekday.tuesday': 'Martes',
  'goals.weekday.wednesday': 'Miércoles',
  'goals.weekday.thursday': 'Jueves',
  'goals.weekday.friday': 'Viernes',
  'goals.weekday.saturday': 'Sábado',
  'goals.weekday.sunday': 'Domingo',
  'goals.dialog.addEyebrow': 'AÑADIR',
  'goals.dialog.editEyebrow': 'MODIFICACIÓN',
  'goals.dialog.close': 'Cerrar',
  'goals.dialog.addTypeAria': 'Tipo de añadido',
  'goals.dialog.existing': 'Existente',
  'goals.dialog.newManual': 'Nuevo manual',
  'goals.dialog.newAutomatic': 'Nuevo automático',
  'goals.dialog.fromShorterGoal': 'Desde un objetivo de periodo más corto',
  'goals.dialog.dailyResults': 'Resultado de los objetivos diarios',
  'goals.dialog.sourceGoal': 'Objetivo fuente',
  'goals.dialog.sameNameByDefault': 'Mismo nombre por defecto',
  'goals.dialog.derivedAggregationHint': 'Los valores se suman; los porcentajes se promedian.',
  'goals.dialog.dailyResultsHelp': 'Media de la puntuación global de los objetivos diarios durante el periodo.',
  'goals.dialog.derivedSourceLocked': 'El periodo y la fuente están bloqueados para conservar la coherencia de la derivación.',
  'goals.dialog.chooseGoalTarget': 'Elige un objetivo y una meta.',
  'goals.dialog.selectedUnavailable': 'El objetivo seleccionado ya no está disponible.',
  'goals.dialog.nameRequired': 'Pon un nombre al objetivo.',
  'goals.dialog.definitionMissing': 'Este objetivo ya no está disponible.',
  'goals.dialog.goal': 'Objetivo',
  'goals.dialog.name': 'Nombre',
  'goals.dialog.target': 'Meta',
  'goals.dialog.period': 'Periodo',
  'goals.period.daily': 'Diario',
  'goals.period.weekly': 'Semanal',
  'goals.period.monthly': 'Mensual',
  'goals.period.quarterly': 'Trimestral',
  'goals.period.yearly': 'Anual',
  'goals.period.activeGoals': 'Objetivos del periodo',
  'goals.period.progress': 'Progreso del periodo',
  'goals.period.lastDay': 'Último día',
  'goals.period.daysRemaining': 'Quedan {count} días',
  'goals.period.tabsAria': 'Periodos de objetivos',
  'goals.period.addTab': 'Añadir un periodo',
  'goals.period.empty': 'No hay objetivos para este periodo',
  'goals.period.emptyHelp': 'Añade un objetivo para empezar a seguir este periodo.',
  'goals.period.addForPeriod': 'Añadir un objetivo — {period}',
  'goals.dialog.description': 'Descripción',
  'goals.dialog.optional': 'opcional',
  'goals.dialog.unit': 'Unidad',
  'goals.dialog.quantity': 'Cantidad',
  'goals.dialog.duration': 'Duración',
  'goals.dialog.distance': 'Distancia',
  'goals.dialog.yesNo': 'Sí / no',
  'goals.dialog.percentage': 'Porcentaje',
  'goals.dialog.unitLabel': 'Nombre de la unidad',
  'goals.dialog.loadingSources': 'Cargando fuentes…',
  'goals.dialog.source': 'Fuente',
  'goals.dialog.tasks': 'Tareas',
  'goals.dialog.routines': 'Rutinas',
  'goals.dialog.activities': 'Actividades',
  'goals.dialog.highlight': 'Highlight',
  'goals.dialog.highlightMetric': 'Métrica del Highlight',
  'goals.dialog.highlightDefined': 'Highlight definido',
  'goals.dialog.highlightCompleted': 'Highlight completado',
  'goals.dialog.calculation': 'Cálculo',
  'goals.dialog.countCompleted': 'Número realizado',
  'goals.dialog.sumRoutineQuantity': 'Suma de cantidades de rutinas',
  'goals.dialog.sumRoutineTime': 'Tiempo medido',
  'goals.dialog.linkMeasuredRoutine': 'Alimentar automáticamente este objetivo desde una rutina medida',
  'goals.dialog.sourceUnit': 'unidad de la rutina',
  'goals.dialog.quantifiedRoutineRequired': 'Selecciona al menos una rutina cuantificada.',
  'goals.dialog.sameRoutineUnitRequired': 'Las rutinas seleccionadas deben usar la misma unidad.',
  'goals.dialog.completionPercent': '% realizado / previsto',
  'goals.dialog.atLeastOne': 'Al menos una realizada',
  'goals.dialog.scope': 'Ámbito',
  'goals.dialog.allOccurrences': 'Todas las ocurrencias',
  'goals.dialog.oneTaskType': 'Un tipo de tarea',
  'goals.dialog.selectedTasks': 'Tareas seleccionadas',
  'goals.dialog.oneList': 'Una lista',
  'goals.dialog.type': 'Tipo',
  'goals.dialog.recurrent': 'Recurrentes',
  'goals.dialog.list': 'Lista',
  'goals.dialog.tasksIncluded': 'Tareas incluidas',
  'goals.dialog.allRoutines': 'Todas las rutinas',
  'goals.dialog.selectedRoutines': 'Rutinas seleccionadas',
  'goals.dialog.routinesIncluded': 'Rutinas incluidas',
  'goals.dialog.creating': 'Creando…',
  'goals.dialog.createAdd': 'Crear y añadir',
  'goals.dialog.editTitle': 'Modificar el objetivo',
  'goals.dialog.editLoading': 'Cargando el objetivo…',
  'goals.dialog.automatic': 'Automático',
  'goals.dialog.manual': 'Manual',
  'goals.dialog.mode': 'Modo de recopilación',
  'goals.dialog.historyPreserved': 'Los cambios se aplican a los períodos futuros; el historial existente se conserva.',
  'goals.dialog.historyLocked': 'La unidad y el tipo de cálculo están bloqueados porque este objetivo ya tiene historial.',
  'goals.dialog.saveChanges': 'Guardar cambios',
  'goals.dialog.chooseTaskList': 'Elige una lista de Tasks.',
  'goals.dialog.selectTask': 'Selecciona al menos una tarea.',
  'goals.dialog.selectRoutine': 'Selecciona al menos una rutina.',
  'goals.dialog.selectActivity': 'Selecciona al menos una actividad.',
  'goals.dialog.activitiesIncluded': 'Actividades incluidas',
  'goals.dialog.unitLocked': 'La unidad ya no se puede modificar porque este objetivo tiene historial.',
  'goals.dialog.invalidSourceConfig': 'La configuración de la fuente es incompatible con el cálculo elegido.',
  'goals.dialog.createFailed': 'No se ha podido crear el objetivo.',
  'goals.dialog.editFailed': 'No se ha podido modificar el objetivo.',
  'shared.confirm.confirm': 'Confirmar',
  'shared.confirm.cancel': 'Cancelar',
  'shared.state.retry': 'Reintentar'
};

export const ES_TRANSLATIONS: Record<TranslationKey, string> = {

  ...FR_TRANSLATIONS,
  ...ES_TRANSLATION_OVERRIDES
};

export const ESSENTIAL_TRANSLATION_KEYS: readonly TranslationKey[] = [
  'product.today',
  'product.todo',
  'product.highlight',
  'product.template',
  'product.tasks',
  'product.calendar',
  'product.goals',
  'product.lists',
  'product.notes',
  'product.activities',
  'product.sport',
  'product.settings',
  'app.signIn',
  'app.signOut',
  'auth.login.title',
  'auth.signup.title',
  'home.whereStart',
  'settings.language.label',
  'tasks.title',
  'today.title',
  'calendar.title',
  'goals.title'
];

export const TRANSLATIONS: Record<AppLocale, Record<TranslationKey, string>> = {
  fr: FR_TRANSLATIONS,
  en: EN_TRANSLATIONS,
  es: ES_TRANSLATIONS
};
